// Search through all sub folders of the img directory for svg files
// require.context ( folder, recurse, pattern )
const requireSVGFiles = require.context('../img', true, /\.svg$/);
// Military Symbols Objects
const mso = {};
// Populate mso object with computed property values
requireSVGFiles.keys().map((path) => {
  // Unmodified path value looks like this "./main/Signal.svg"
  // I need to set the computed property value to the file name
  const name = [
    // prettier-ignore
    path.split('/').pop().replace(/\.[^.]*$/, ''),
  ];
  mso[name] = { file: requireSVGFiles(path) };
  return true;
});

// Default equipment description
const eqDesc =
  'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).';

// Transportation Mode Indicators for Equipment Symbols
const eqTransDesc =
  'There is a special case for Sector 2 modifiers for equipment symbols that you should know about. The mobility (transportation) mode indicator is only used to depict the mode of transport of equipment. For example, a symbol for an armored self-propelled howitzer transported by train would include a railway mobility mode indicator. This mobility indicator is placed below the entire symbol.';

const questions = [
  // ? Echelons
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.teamOrCrew.file,
    description:
      'A small military unit that consists of all personnel operating a particular system. This is the smallest echelon and should not be confused with company team and brigade combat team.',
    answers: [
      { text: 'Squad', correct: false },
      { text: 'Command', correct: false },
      { text: 'Team or Crew', correct: true },
      { text: 'Section', correct: false },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.squad.file,
    description: 'A small military unit typically containing two or more fire teams.',
    answers: [
      { text: 'Squad', correct: true },
      { text: 'Command', correct: false },
      { text: 'Team or Crew', correct: false },
      { text: 'Section', correct: false },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.section.file,
    description: 'A tactical unit of the Army and Marine Corps smaller than a platoon and larger than a squad.',
    answers: [
      { text: 'Squad', correct: false },
      { text: 'Team', correct: false },
      { text: 'Platoon', correct: false },
      { text: 'Section', correct: true },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.platoon.file,
    description:
      '<p class="mdc-typography--body1"><strong>Platoon:</strong> A subdivision of a company or troop consisting of two or more squads or sections.</p><p class="mdc-typography--body1"><strong>Detachment:</strong> A tactical element organized on either a temporary or permanent basis for special duties.</p>',
    answers: [
      { text: 'Platoon/Detachment', correct: true },
      { text: 'Company/Battery/Troop', correct: false },
      { text: 'Section', correct: false },
      { text: 'Squad', correct: false },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.troop.file,
    description:
      '<p class="mdc-typography--body1"><strong>Company:</strong> A unit consisting of two or more platoons, usually of the same type, with a headquarters and a limited capacity for self-support.</p><p class="mdc-typography--body1"><strong>Battery:</strong> A company-size unit in a field artillery or air defense artillery battalion.</p><p class="mdc-typography--body1"><strong>Troop:</strong>  A company-size unit in a cavalry organization.</p>',
    answers: [
      { text: 'Platoon/Detachment', correct: false },
      { text: 'Company/Battery/Troop', correct: true },
      { text: 'Section', correct: false },
      { text: 'Battalion/Squadron', correct: false },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.squadron.file,
    description:
      '<p class="mdc-typography--body1"><strong>Battalion:</strong> A unit consisting of two or more company-, battery-, or troop-size units and a headquarters.</p><p class="mdc-typography--body1"><strong>Squadron:</strong> A unit consisting of two or more troop-size units and a headquarters in a cavalry organization.</p>',
    answers: [
      { text: 'Platoon/Detachment', correct: false },
      { text: 'Company/Battery/Troop', correct: false },
      { text: 'Battalion/Squadron', correct: true },
      { text: 'Regiment or Group', correct: false },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.regiment.file,
    description: 'A unit consisting of 2 or more battalions.',
    answers: [
      { text: 'Brigade', correct: false },
      { text: 'Division', correct: false },
      { text: 'Battalion/Squadron', correct: false },
      { text: 'Regiment or Group', correct: true },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.brigade.file,
    description: 'A unit consisting of two or more battalions and a headquarters company or detachment.',
    answers: [
      { text: 'Brigade', correct: true },
      { text: 'Division', correct: false },
      { text: 'Battalion/Squadron', correct: false },
      { text: 'Regiment or Group', correct: false },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.division.file,
    description: 'An echelon of command and tactical formation that employs brigade combat teams, multi-functional brigades, and functional brigades to achieve objectives on land.',
    answers: [
      { text: 'Brigade', correct: false },
      { text: 'Division', correct: true },
      { text: 'Corps', correct: false },
      { text: 'Army', correct: false },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.corps.file,
    description: 'An echelon of command and tactical formation that employs divisions, multi-functional brigades, and functional brigades to achieve objectives on land.',
    answers: [
      { text: 'Brigade', correct: false },
      { text: 'Division', correct: false },
      { text: 'Corps', correct: true },
      { text: 'Army', correct: false },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.army.file,
    description:
      'An echelon of command designated as the Army Service component command responsible for recommendations of allocations and employment of Army forces to the geographic combatant commander.',
    answers: [
      { text: 'Brigade', correct: false },
      { text: 'Division', correct: false },
      { text: 'Army', correct: true },
      { text: 'Corps', correct: false },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.armyGroup.file,
    description:
      'An echelon of command designated as the Army Service component command responsible for recommendations of allocations and employment of Army forces to the geographic combatant commander. <strong>Note: Used in North Atlantic Treaty Organization or multinational military operations.</strong>',
    answers: [
      { text: 'Corps', correct: false },
      { text: 'Brigade', correct: false },
      { text: 'Division', correct: false },
      { text: 'Army Group', correct: true },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.theatre.file,
    description: 'The echelon of command that employs commands and forces to achieve geographic area objectives.',
    answers: [
      { text: 'Theatre', correct: false },
      { text: 'Brigade', correct: false },
      { text: 'Division', correct: false },
      { text: 'Army Group', correct: true },
    ],
  },
  {
    question: 'What is the echelon of this symbol?',
    symbolSVG: mso.command.file,
    description:
      'Note: Command is a non-echelon symbol amplifier. It represents a unit specifically supporting a theater or corps command. The symbol above is an example of a Sustainment Command supporting a corps',
    answers: [
      { text: 'Command', correct: true },
      { text: 'Army', correct: false },
      { text: 'Army Group', correct: false },
      { text: 'Theatre', correct: false },
    ],
  },
  // ? Main Icons for Units - Command and Control
  {
    question: 'What is this symbol?',
    symbolSVG: mso.informationOperations.file,
    description:
      'The integrated employment, during military operations, of information related capabilities in concert with other lines of operation to influence, disrupt, corrupt, or usurp the decision making of adversaries and potential adversaries while protecting our own.',
    answers: [
      { text: 'Friendly Information Operations', correct: true },
      { text: 'Assumed Friendly Information Operations', correct: false },
      { text: 'Friendly Instructor Operator', correct: false },
      { text: 'Friendly Interdiction Operations', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.interpreterTranslator.file,
    description: 'This symbol represents the capability to translate orally for parties conversing in different languages, and turn documents into one’s own or other language.',
    answers: [
      { text: 'Pending Friendly Troop Docking Station', correct: false },
      { text: 'Assumed Friendly Troop Docking Station', correct: false },
      { text: 'Pending Friendly Interpreter/Translator', correct: false },
      { text: 'Assumed Friendly Interpreter/Translator', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.isolatedPersonnel.file,
    description:
      'United States military, Department of Defense civilians and contractor personnel (and others designated by the President or Secretary of Defense) who are separated from their unit (as an individual or a group) while participating in a United States sponsored military activity or mission and are, or may be, in a situation where they must survive, evade, resist, or escape.',
    answers: [
      { text: 'Faker Downed Pilot', correct: false },
      { text: 'Feint Downed Pilot', correct: false },
      { text: 'Hostile Isolated Personnel', correct: false },
      { text: 'Neutral Isolated Personnel', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.NATOLiaison.file,
    description: 'That contact or intercommunication maintained between elements of military forces or other agencies to ensure mutual understanding and unity of purpose and action.',
    answers: [
      { text: 'Friendly Line of Operations', correct: false },
      { text: 'Friendly Loading Origin', correct: false },
      { text: 'Friendly NATO Liaison', correct: true },
      { text: 'Friendly Logistical Operations', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso['Public-Affairs'].file,
    description: 'Communication activities with external and internal audiences.',
    answers: [
      { text: 'Assumed Hostile Protected Area', correct: false },
      { text: 'Friendly Public Arsenal', correct: false },
      { text: 'Hostile Public Affairs', correct: true },
      { text: 'Hostile Protected Area', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.Signal.file,
    description: 'Provides and secures the network for commanders to conduct command and control and integrate the other warfighting functions across the range of military operations.',
    answers: [
      { text: 'Pending Crowd Control (Laser)', correct: false },
      { text: 'Pending Signal Unit', correct: true },
      { text: 'Unknown Signal Unit', correct: false },
      { text: 'Unknown Signal Unit (dug in)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso['Space-Unit'].file,
    description: 'The space and terrestrial systems, equipment, facilities, organizations, and personnel necessary to access, use and, if directed, control space for national security.',
    answers: [
      { text: 'Unknown Point of Impact', correct: false },
      { text: 'Unknown Space Unit', correct: true },
      { text: 'Pending Space Unit', correct: false },
      { text: 'Pending Signal Unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso['Special-Troops'].file,
    description:
      'An organic unit of a modular brigade, division (or equivalent), corps or higher echelon responsible for planning, preparing, executing, and assessing internal support requirements. Typically has a headquarters and headquarters and a signal company, but may include other functional supporting units.',
    answers: [
      { text: 'Templated Self-Propelled Tank', correct: false },
      { text: 'Hostile Shock Trauma Center', correct: false },
      { text: 'Templated Short Takeoff', correct: false },
      { text: 'Hostile Special Troops', correct: true },
    ],
  },
  // ? Main Icons for Units - Fires
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airAndMissileDefense.file,
    description:
      'Direct [active and passive] defensive actions taken to destroy, nullify, or reduce the effectiveness of hostile air and ballistic missile threats against friendly forces and assets. This is also known as an Air Defense Artillery unit with Radar Dome capabilities.',
    answers: [
      { text: 'Assumed Hostile Air and Missile Defense', correct: true },
      { text: 'Hostile Missile Defense', correct: false },
      { text: 'Templated Mine Detection', correct: false },
      { text: 'Hostile Mortar Detachment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ANGLICO.file,
    description: 'Air-naval gunfire liaison (ANGLICO). If you don&apos;t know what these are, they are Marines, they often get attached to Army units.',
    answers: [
      { text: 'Friendly Naval Fixed Wing Unit', correct: false },
      { text: 'Friendly Air-Naval Gunfire Liaison Company (ANGLICO)', correct: true },
      { text: 'Assumed Friendly Naval Infantry', correct: false },
      { text: 'Friendly Naval Seaport', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fieldArtillery.file,
    description: 'Equipment, supplies, ammunition, and personnel involved in the use of cannon, rocket, or surface-to-surface missile launchers.',
    answers: [
      { text: 'Friendly Fueling Unit', correct: false },
      { text: 'Friendly Mines', correct: false },
      { text: 'Friendly Field Artillery', correct: true },
      { text: 'Friendly Engineers', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.missile.file,
    description: 'Generic (unspecified) missile unit.',
    answers: [
      { text: 'Friendly Field Artillery', correct: false },
      { text: 'Friendly Air Radar', correct: false },
      { text: 'Friendly Radar Dome', correct: false },
      { text: 'Friendly Missile Unit', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.missileDefense.file,
    description: 'Defense measures designed to destroy attacking enemy missiles, or to nullify or reduce the effectiveness of such attack.',
    answers: [
      { text: 'Assumed Hostile Missile Defense', correct: true },
      { text: 'Hostile Missile Defense', correct: false },
      { text: 'Assumed Hostile Mine Detection', correct: false },
      { text: 'Assumed Hostile Medical Detachment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airDefense.file,
    description: 'Defensive measures designed to destroy attacking enemy aircraft or aerodynamic missiles, or to nullify or reduce the effectiveness of such attack.',
    answers: [
      { text: 'Friendly Radar Dome Equipment', correct: false },
      { text: 'Friendly Air Defense', correct: true },
      { text: 'Friendly Missile Defense', correct: false },
      { text: 'Friendly Missile', correct: false },
    ],
  },
  // ? Main Icons for Units - Intelligence
  {
    question: 'What is this symbol?',
    symbolSVG: mso.militaryIntelligence.file,
    description: 'Conducts intelligence operations as part of information collection across the Army’s strategic roles.',
    answers: [
      { text: 'Friendly Military Interdiction', correct: false },
      { text: 'Friendly Military Intervention', correct: false },
      { text: 'Friendly Military Intelligence', correct: true },
      { text: 'Friendly Minefield Intersection ', correct: false },
    ],
  },
  // ? Main Icons for Units - Movement and Maneuver
  {
    question: 'What is this symbol?',
    symbolSVG: mso.antiArmorAntiTank.file,
    description: 'Provides long range direct fires with TOW missiles and 105mm (millimeter) main gun rounds respectively.',
    answers: [
      { text: 'Assumed Hostile Air Defense Artillery', correct: false },
      { text: 'Assumed Hostile Armored Unit', correct: false },
      { text: 'Assumed Hostile Missile', correct: false },
      { text: 'Assumed Hostile Anti-Armor (Anti-Tank)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.armoredTrackUnit.file,
    description: 'Provides main battle tank weapons system with 120mm smoothbore cannon and increased armor protection.',
    answers: [
      { text: 'Assumed Friendly Armored Track Unit', correct: true },
      { text: 'Assumed Friendly Armored Wheeled Unit', correct: false },
      { text: 'Assumed Friendly Combined Arms Unit', correct: false },
      { text: 'Friendly Armored Track Unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.armoredRecon.file,
    description: 'Conducts reconnaissance and security with armored tracked fighting vehicles to support the brigade’s awareness and knowledge in the area of operations.',
    answers: [
      { text: 'Assumed Hostile Armored Wheeled Unit', correct: false },
      { text: 'Assumed Hostile Armored Reconnaissance (Cavalry)', correct: true },
      { text: 'Assumed Hostile Armored Infantry', correct: false },
      { text: 'Hostile Armored Track Unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rotaryWingAviation.file,
    description: 'Conducts attack and air movement functions in support of ground maneuver in the area of operations or area of interest.',
    answers: [
      { text: 'Assumed Friendly Air Reconnaissance', correct: false },
      { text: 'Friendly Fixed Wing Aviation', correct: false },
      { text: 'Friendly Rotary Wing Aviation', correct: true },
      { text: 'Friendly Naval Aviation', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airRecon.file,
    description: 'Conducts aerial reconnaissance and security tasks in close coordination with the brigades Cavalry squadrons.',
    answers: [
      { text: 'Assumed Friendly Air Reconnaissance', correct: false },
      { text: 'Neutral Fixed Wing Aviation', correct: false },
      { text: 'Neutral Rotary Wing Aviation', correct: false },
      { text: 'Neutral Air Reconnaissance (Cavalry)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fixedWingAviation.file,
    description:
      'Conducts air movement of personnel, leaders, critical supplies, equipment and systems during the conduct of offensive, defensive, stability, and defense support of civilian authorities operations throughout the depth and breadth of the area of operations or are of interest.',
    answers: [
      { text: 'Neutral Army Aviation/Fixed-wing aviation', correct: true },
      { text: 'Assumed Hostile Air Reconnaissance', correct: false },
      { text: 'Hostile Naval Aviation', correct: false },
      { text: 'Neutral Rotary Wing Aviation', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.cavalry.file,
    description: 'Conducts reconnaissance and security to support friendly forces awareness and knowledge in the area of operations.',
    answers: [
      { text: 'Assumed Friendly Infantry', correct: false },
      { text: 'Assumed Friendly Cavalry', correct: true },
      { text: 'Assumed Friendly Combined Arms', correct: false },
      { text: 'Friendly Mechanized Infantry', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.combinedArms.file,
    description: 'Combines the efforts of armor units and mechanized infantry units to execute tactical missions as part of a combined arms operation.',
    answers: [
      { text: 'Assumed Friendly Infantry', correct: false },
      { text: 'Friendly Cavalry', correct: false },
      { text: 'Friendly Combined Arms', correct: true },
      { text: 'Friendly Mechanized Armored Infantry', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.infantry.file,
    description: 'Provides Soldiers trained, armed, and equipped to fight dismounted by means of fire and movement in order to destroy, defeat, capture, or repel an enemy assault.',
    answers: [
      { text: 'Assumed Friendly Infantry', correct: false },
      { text: 'Friendly Cavalry', correct: false },
      { text: 'Friendly Mechanized Armored Infantry', correct: false },
      { text: 'Friendly Infantry', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mechanizedArmoredInfantry.file,
    description: 'Provides armored tracked fighting vehicles to transport and support Soldiers trained, armed, and equipped to fight dismounted by means of fire and movement.',
    answers: [
      { text: 'Pending Mechanized Armored Infantry', correct: true },
      { text: 'Unknown Infantry', correct: false },
      { text: 'Pending Infantry', correct: false },
      { text: 'Unknown Mechanized Armored Infantry', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mobileGunSystem.file,
    description:
      'A Stryker brigade combat team asset that provides precise long range direct fire in support of Infantry and Cavalry units. Note: This main icon is placed about 1/8 from the left edge of the inside of the frame.',
    answers: [
      { text: 'Unknown Infantry', correct: false },
      { text: 'Friendly Mobile Gun System', correct: true },
      { text: 'Friendly Infantry', correct: false },
      { text: 'Friendly Mechanized Armored Infantry', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mortarUnit.file,
    description: 'Organic fire support to battalions, squadrons, companies, and troops, and are available to a commander when other indirect fire support is not available.',
    answers: [
      { text: 'Hostile Mortar Unit', correct: false },
      { text: 'Assumed Hostile Missile Unit', correct: false },
      { text: 'Assumed Hostile Mortar Unit', correct: true },
      { text: 'Assumed Hostile Air Defense Artillery', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.surveillance.file,
    description: 'The systematic observation of aerospace, surface or subsurface areas, places, persons, or things by visual, aural, electronic, photographic, or other means.',
    answers: [
      { text: 'Neutral Observation Post', correct: false },
      { text: 'Neutral Missile Unit', correct: false },
      { text: 'Neutral Sensor Unit', correct: false },
      { text: 'Neutral Surveillance Unit', correct: true },
    ],
  },
  // ? Main Icons for Units - Protection
  {
    question: 'What is this symbol?',
    symbolSVG: mso.DEA.file,
    description: 'Drug Enforcement Agency (DEA) —civil authority',
    answers: [
      { text: 'Drug Enforcement Agency', correct: true },
      { text: 'Defensive Engagement Area', correct: false },
      { text: 'Defensive Electronic Augmentation', correct: false },
      { text: 'Denial Area', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATF.file,
    description: 'Bureau of Alcohol, Tobacco, Firearms, and Explosives (ATF) — civil authority',
    answers: [
      { text: 'Friendly Anti-Tank Fires', correct: false },
      { text: 'Bureau of Alcohol, Tobacco, Firearms, and Explosives', correct: true },
      { text: 'Augmented Training Facility', correct: false },
      { text: 'Friendly Area Target Fires Unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CBRN.file,
    description:
      'Chemical, biological, radiological, and nuclear (CBRN): Recognizes vulnerabilities, identifies and understands CBRN hazards, and their consequences when they appear, and response appropriately to protect the force',
    answers: [
      { text: 'Unknown Air Defense Artillery unit', correct: false },
      { text: 'Unknown Mortars unit', correct: false },
      { text: 'Pending CBRN unit', correct: true },
      { text: 'Pending Mortars unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CBRNHYE.file,
    description:
      'Chemical, biological, radiological, nuclear, and high-yield explosives: Recognizes components that are threats or potential hazards with adverse effects in the operational environment.',
    answers: [
      { text: 'Unknown CBRN and Electromagnetic unit', correct: false },
      { text: 'Unknown CBRN unit', correct: false },
      { text: 'Neutral CBRN unit', correct: false },
      { text: 'Neutral CBRN and High-Yield Explosives unit', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CBRNRecon.file,
    description:
      'Chemical, biological, radiological, nuclear, reconnaissance—Executes operations to obtain by visual observation or other detection methods, information on the potential or actual CBRN hazards and threats in an area of operations.',
    answers: [
      { text: 'Friendly CBRN Reconnaissance unit', correct: true },
      { text: 'Friendly CBRN and Electromagnetic unit', correct: false },
      { text: 'Friendly CBRN Infantry unit', correct: false },
      { text: 'Neutral CBRN unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.Engineer.file,
    description: 'Provides Soldiers with technical skills and equipment to provide freedom of action or land power by mitigating the effects of terrain.',
    answers: [
      { text: 'Friendly Electromagnetic unit', correct: false },
      { text: 'Friendly Engineer unit', correct: true },
      { text: 'Friendly Explosives unit', correct: false },
      { text: 'Friendly EOD unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.FBI.file,
    description: 'Federal Bureau of Investigation (FBI) — civil authority',
    answers: [
      { text: 'Fire Base Integration', correct: false },
      { text: 'Friendly Fire Base (Illumination) unit', correct: false },
      { text: 'Federal Bureau of Investigation (FBI)', correct: true },
      { text: 'Fix/Block/Interdict', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fireProtection.file,
    description: 'Fire department — civil authority',
    answers: [
      { text: 'Unknown Powerplant', correct: false },
      { text: 'Unknown Law Enforcement', correct: false },
      { text: 'Unknown US Marshalls Agency', correct: false },
      { text: 'Unknown Fire Protection', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ISF.file,
    description: 'Internal Security Force — civil authority',
    answers: [
      { text: 'Assumed Hostile Internal Security Force', correct: true },
      { text: 'Assumed Hostile Intelligence, Surveillance and Fires', correct: false },
      { text: 'Assumed Hostile Law Enforcement', correct: false },
      { text: 'Hostile Integrated Secured Fires', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.lawEnforcementAgency.file,
    description: 'Law enforcement — civil authority',
    answers: [
      { text: 'Assumed Hostile Intelligence, Surveillance and Fires', correct: false },
      { text: 'Assumed Hostile Law Enforcement Agency', correct: true },
      { text: 'Assumed Hostile Internal Security Force', correct: false },
      { text: 'Hostile Fire Protection', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.maneuverEnhancement.file,
    description: 'Provides command and control of forces from multiple branches, but especially those that conduct support area and maneuver support operations for the force.',
    answers: [
      { text: 'Unknown Civil Relief unit', correct: false },
      { text: 'Unknown Observation Post', correct: false },
      { text: 'Unknown Maneuver Enhancement', correct: true },
      { text: 'Pending Observation Post', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MP.file,
    description: 'Provides law enforcement activities to control and protect populations and resources to facilitate the existence of a lawful and orderly environment.',
    answers: [
      { text: 'Friendly Mobilization Point', correct: false },
      { text: 'Friendly Movement Phase', correct: false },
      { text: 'Multinational Police (NATO)', correct: false },
      { text: 'Friendly Military Police', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.policeDepartment.file,
    description: 'Police department — civil authority.',
    answers: [
      { text: 'Friendly Police Department', correct: true },
      { text: 'Friendly Military Police unit', correct: false },
      { text: 'Friendly Internal Security Forces', correct: false },
      { text: 'Friendly Security Forces (NATO)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.securityISF.file,
    description: 'Measures taken by a military unit, activity, or installation to protect itself against all acts designed to, or which may, impair its effectiveness.',
    answers: [
      { text: 'Friendly Military Police unit', correct: false },
      { text: 'Friendly Security unit', correct: true },
      { text: 'Submarine Element Coordinator', correct: false },
      { text: 'Security Enhancement Coordinator', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.usMarshalls.file,
    description: 'United States Marshall Service — civil authority',
    answers: [
      { text: 'Friendly Military Police unit', correct: false },
      { text: 'Friendly Internal Security Force', correct: false },
      { text: 'U.S. Marshall Service', correct: true },
      { text: 'Police Department', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.usss.file,
    description: 'United States Secret Service — civil authority',
    answers: [
      { text: 'Underwater Surface to Surface Missiles', correct: false },
      { text: 'U.S. Security Sector', correct: false },
      { text: 'U.S. Steamship', correct: false },
      { text: 'U.S. Secret Service', correct: true },
    ],
  },
  // ? Main Icons for Units - Sustainment
  {
    question: 'What is this symbol?',
    symbolSVG: mso.KS.file,
    description:
      'Provides support contracting services, along with contracting advice and assistance, primarily to Army forces and to joint forces when directed, and is organized along functional lines.',
    answers: [
      { text: 'Hostile Contracting Support', correct: true },
      { text: 'Hostile Key Sector', correct: false },
      { text: 'Hostile Knowledge Sharing', correct: false },
      { text: 'Hostile Key Support', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EOD.file,
    description:
      'The detection, identification, on-site evaluation, rendering safe, recovery, and final disposal of unexploded explosive ordnance. The detection, identification, on-site evaluation, rendering safe, exploitation, recovery, and final disposal of explosive ordnance. Also called EOD.',
    answers: [
      { text: 'Friendly Electromagnetic Optical Device', correct: false },
      { text: 'Friendly Explosive Ordnance Disposal', correct: true },
      { text: 'Friendly Explosive Ordnance Detonation', correct: false },
      { text: 'Friendly Electro-Optical Device', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.Finance.file,
    description: 'Provides timely commercial vendor services and contractual payments, various pay and disbursing services, and oversight and management of the Army’s Banking Program.',
    answers: [
      { text: 'Unknown Mortuary Affairs unit', correct: false },
      { text: 'Pending Mortuary Affairs unit', correct: false },
      { text: 'Pending Finance unit ', correct: true },
      { text: 'Unknown Finance unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HR.file,
    description: 'Provides operational effectiveness of the total force by anticipating, manning, and sustaining military operations.',
    answers: [
      { text: 'Hostile Humanitarian Relief unit', correct: false },
      { text: 'Hostile High Risk event', correct: false },
      { text: 'Hostile Helicopter Request', correct: false },
      { text: 'Hostile Human Resources unit ', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.JAG.file,
    description: 'Provide subject matter experts in all of the core legal disciplines and are counselors, advocates, and trusted advisors to commanders and Soldiers.',
    answers: [
      { text: 'Friendly Judge Advocate General unit ', correct: true },
      { text: 'Friendly Joint Air-Ground unit', correct: false },
      { text: 'Friendly Joint Assessment Group (NATO)', correct: false },
      { text: 'Friendly Joint Asset Group unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.Maintenance.file,
    description:
      'Ensures unit readiness by maintaining weapon systems and equipment in a fully mission-capable status for immediate and continuous employment in complex and highly lethal environments.',
    answers: [
      { text: 'Friendly Tow-hitch Trailer', correct: false },
      { text: 'Friendly Maintenance unit ', correct: true },
      { text: 'Friendly Mortar Trailer unit', correct: false },
      { text: 'Friendly Mortar', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.Medical.file,
    description: 'Promotes, improves, conserves, or restores the behavioral and physical well-being of personnel in the Army, and as directed in other Services, agencies, and organizations.',
    answers: [
      { text: 'Assumed Friendly Infantry Trailer', correct: false },
      { text: 'Assumed Friendly Targeting unit', correct: false },
      { text: 'Assumed Friendly Medical unit ', correct: true },
      { text: 'Friendly Infantry unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.medicalTreatmentFacility.file,
    description:
      'A facility established for the purpose of furnishing medical and/or dental care to eligible individuals. Any facility established for the purpose of providing medical treatment. This includes battalion aid stations, role 2 facilities, dispensaries, clinics, and hospitals.',
    answers: [
      { text: 'Friendly Infantry unit', correct: false },
      { text: 'Friendly Artillery Targeting unit', correct: false },
      { text: 'Friendly Medical unit', correct: false },
      { text: 'Friendly Medical Treatment Facility ', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mortuaryAffairs.file,
    description: 'Provides for the search, recovery, identification, preparation, and disposition of human remains of persons for whom the Services are responsible by status and executive order.',
    answers: [
      { text: 'Hostile Mortuary Affairs unit', correct: true },
      { text: 'Hostile Finance unit', correct: false },
      { text: 'Hostile Chaplain unit', correct: false },
      { text: 'Hostile Religious Affairs unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.band.file,
    description: 'Serves as a combat multiplier and plays an integral part in the sustainment of forces engaged in unified land operations.',
    answers: [
      { text: 'Limp Bizkit', correct: false },
      { text: 'Pending Band', correct: true },
      { text: 'Unknown Band', correct: false },
      { text: 'Neutral Band', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ordnance.file,
    description:
      'Provides munitions, maintenance, and explosive ordnance disposal support to generate and maintain combat power and to provide protection to Army, joint, intergovernmental, interagency and multinational forces.',
    answers: [
      { text: 'Friendly Field Artillery unit', correct: false },
      { text: 'Friendly Mine Laying unit', correct: false },
      { text: 'Friendly Ordnance unit', correct: true },
      { text: 'Friendly EOD unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.PS.file,
    description:
      'Sustainment functions that man and fund the force, maintain Soldier and family readiness, promote the moral and ethical values of the nation, and enable the fighting qualities of the Army.',
    answers: [
      { text: 'Assumed Hostile Psychological Support', correct: false },
      { text: 'Assumed Hostile Port Security', correct: false },
      { text: 'Assumed Hostile Precision Strike', correct: false },
      { text: 'Assumed Hostile Personnel Services unit', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.quartermaster.file,
    description: 'Provides supply and field services to enable freedom of action, extend operational reach, and prolong endurance.',
    answers: [
      { text: 'Neutral Quartermaster unit', correct: true },
      { text: 'Neutral Custodian unit', correct: false },
      { text: 'Neutral Port Security', correct: false },
      { text: 'Unknown Precision Strike', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.chaplain.file,
    description: 'Provides for the free exercise of religion and providing religious, moral, and ethical advisement and leadership. (note: this is basically a chaplain)',
    answers: [
      { text: 'Friendly Radiation Exposure Line', correct: false },
      { text: 'Friendly Religious Support unit', correct: true },
      { text: 'Friendly Recovery Engagement Line', correct: false },
      { text: 'Friendly Restricted Engagement List', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rigger.file,
    description:
      'Support that includes parachute packing, aerial delivery equipment repair, external sling load, rigging equipment and supplies for airdrop, as well as the provision of aerial delivery equipment and systems.',
    answers: [
      { text: 'Friendly Snowcone', correct: false },
      { text: 'Friendly Airborne unit', correct: false },
      { text: 'Friendly Rigger unit', correct: true },
      { text: 'Friendly Drilling unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.support.file,
    description:
      'The action of a force that aids, protects, complements, or sustains another force in accordance with the directive requiring such action. An element of a command that assists, protects, or supplies other forces in combat.',
    answers: [
      { text: 'Pending Strategic Planning Team', correct: false },
      { text: 'Pending Security Police Team', correct: false },
      { text: 'Unknown Special Purpose Troops', correct: false },
      { text: 'Pending Support unit', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.sustainment.file,
    description: 'The provision of logistics, financial management, personnel services, and health service support necessary to maintain operations until successful mission completion.',
    answers: [
      { text: 'Neutral Sustainment unit', correct: true },
      { text: 'Neutral Surface Warfare Strike Team', correct: false },
      { text: 'Neutral Subsonic Underwater/Subsonic Terrain', correct: false },
      { text: 'Unknown Surface Short ton', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.transportation.file,
    description:
      'A logistics function that includes movement control and associated activities to incorporate military, commercial, and multinational motor, rail, air, and water mode assets in the movement of units, personnel, equipment, and supplies in support the concept of operations.',
    answers: [
      { text: 'Friendly Mortar unit', correct: false },
      { text: 'Friendly Transportation unit', correct: true },
      { text: 'Friendly Signal Hub', correct: false },
      { text: 'Friendly Joint Readiness Training Center (NATO)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.AFS.file,
    description:
      'Integrates and synchronizes delivery of U.S. Army Materiel Command strategic capabilities and enablers to the operational and tactical points of need in support of Army Service component commands and corps during large-scale combat operations.',
    answers: [
      { text: 'Neutral Air Force Security unit', correct: false },
      { text: 'Neutral Air Force Support unit', correct: false },
      { text: 'Neutral Army Field Support unit', correct: true },
      { text: 'Unknown Advanced Force Support', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ammo.file,
    description: 'Provides effective and efficient handling, storing, securing, distributing, and accounting for munitions while ensuring adequate explosives safety guidelines are met.',
    answers: [
      { text: 'Friendly Missile unit', correct: false },
      { text: 'Friendly Mortar unit', correct: false },
      { text: 'Unknown Mortar Fire Support team', correct: false },
      { text: 'Friendly Ammunition unit', correct: true },
    ],
  },
  // ? Main Icons for Units - Special Operations
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CA.file,
    description: 'Designated Active and Reserve Component forces and units organized, trained, and equipped specifically to conduct civil affairs operations and to support civil-military operations.',
    answers: [
      { text: 'Assumed Friendly Civil Affairs unit', correct: true },
      { text: 'Assumed Friendly Combat Aviation unit', correct: false },
      { text: 'Assumed Friendly Coalition unit', correct: false },
      { text: 'Friendly Counter Artillery', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.civilMilitaryCooperation.file,
    description:
      '(NATO Symbol) A joint function comprising a set of capabilities integral to supporting the achievement of mission objectives and enabling NATO commands to participate effectively in a broad spectrum of civil-military interaction with diverse non-military actors.',
    answers: [
      { text: 'Friendly Naval Unit', correct: false },
      { text: 'Friendly Civil-Military Cooperation (NATO)', correct: true },
      { text: 'Friendly Transportation (rails) unit', correct: false },
      { text: 'Friendly Bridging unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MISO.file,
    description: 'Formerly known as PSYOPS. Military Information Support (MISO) Provides robust capabilities to effectively conduct military information support operations.',
    answers: [
      { text: 'Friendly Missile unit', correct: false },
      { text: 'Friendly Public Affairs unit', correct: false },
      { text: 'Friendly Psychological Operations (MISO) unit', correct: true },
      { text: 'Friendly Bridging unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ranger.file,
    description:
      'Rapidly deployable airborne light infantry organized and trained to conduct highly complex joint direct action operations in coordination with or in support of other special operations units of all Services.',
    answers: [
      { text: 'Friendly Regular Forces (NATO)', correct: false },
      { text: 'Friendly Remote Geospatial Surveying unit', correct: false },
      { text: 'Friendly Parachute Rigger unit', correct: false },
      { text: 'Friendly Ranger unit', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SAR.file,
    description:
      'The use of aircraft, surface craft, submarines, and specialized rescue teams and equipment to search for and rescue distressed persons on land or at sea in a permissive environment.',
    answers: [
      { text: 'Friendly Search and Rescue unit', correct: true },
      { text: 'Friendly Security Assistance Request', correct: false },
      { text: 'Friendly Satellite Access Request', correct: false },
      { text: 'Friendly Surface to Air Rocket', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SEAL.file,
    description:
      'The use of aircraft, surface craft, submarines, and specialized rescue teams and equipment to search for and rescue distressed persons on land or at sea in a permissive environment.',
    answers: [
      { text: 'Friendly Sealift/Airlift unit', correct: false },
      { text: 'Friendly Navy SEAL unit', correct: true },
      { text: 'Friendly Shared Early Access Line', correct: false },
      { text: 'Friendly Stabilize, Engage, Assist and Limit operation', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SF.file,
    description: 'United States Army forces organized, trained, and equipped to conduct special operations with an emphasis on unconventional warfare capabilities.',
    answers: [
      { text: 'Friendly Secured Frequency Signal unit', correct: false },
      { text: 'Friendly Security Forces', correct: false },
      { text: 'Friendly Special Forces unit', correct: true },
      { text: 'Friendly Single Fuel point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SOF.file,
    description:
      'Those Active and Reserve Component forces of the Military Service designated by the Secretary of Defense and specifically organized, trained, and equipped to conduct and support special operations.',
    answers: [
      { text: 'Friendly Signal Operations Frequency', correct: false },
      { text: 'Friendly Security Forces unit', correct: false },
      { text: 'Friendly Status of Forces event', correct: false },
      { text: 'Friendly Special Operations Forces unit', correct: true },
    ],
  },
  // ? Sector 1
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airfield.file,
    description:
      'Capability to provide airfield functions that may include port clearance, movement control, onward movement, liaison, coordination, operation of holding areas, postal operations, personnel replacement processing, and life and logistic support.',
    answers: [
      { text: 'Friendly Transportation unit with airfield terminal operations capability', correct: true },
      { text: 'Friendly Transportation unit with long range capability', correct: false },
      { text: 'Friendly Transportation unit with medium range capability', correct: false },
      { text: 'Friendly Transportation unit with seaport capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.AWS.file,
    description:
      'A combatant ship having organic capability to embark, land, and support landing forces in amphibious operations and which has characteristics enabling long-duration operations on the high seas.',
    answers: [
      { text: 'Hostile Transportation unit with airfield terminal operations capability', correct: false },
      { text: 'Hostile Transportation unit with amphibious warfare ship (generic vessel) capability', correct: true },
      { text: 'Hostile Transportation unit with medium range capability', correct: false },
      { text: 'Hostile Transportation unit with seaport capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CBRNArea.file,
    description:
      'A specified geographic surface included within a delineated set of lines (boundaries) used for the purpose of facilitating coordination and deconfliction between adjacent units, formations, or other specific geographical surfaces.',
    answers: [
      { text: 'Hostile Mortar company with area support capability', correct: false },
      { text: 'Hostile CBRN brigade with area support capability', correct: false },
      { text: 'Hostile CBRN company with area support capability', correct: true },
      { text: 'Hostile CBRN company with area special troops capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.stryker.file,
    description: 'A vehicle hull equipped or protected with armor. This modifier is almost always paired with a Sector 2 modifier for wheeled or tracked.',
    answers: [
      { text: 'Friendly Infantry with Armored Track capability', correct: false },
      { text: 'Friendly Armored Infantry unit', correct: false },
      { text: 'Friendly Infantry armor tracked vehicle capability (Stryker) unit', correct: false },
      { text: 'Friendly Infantry armor wheeled vehicle capability (Stryker) unit', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.assaultHeli.file,
    description: 'A rapid military attack capability that usually involves direct combat to destroy enemy forces, or to seize and hold terrain. Commonly combined with aviation units.',
    answers: [
      { text: 'Friendly Aviation unit with assault aviation capability', correct: true },
      { text: 'Friendly Aviation unit', correct: false },
      { text: 'Friendly Armored Infantry unit', correct: false },
      { text: 'Friendly Fixed Wing unit with assault capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.attackHeli.file,
    description:
      'A type of offensive Aviation unit with assault aviation capability operation that destroys or defeats enemy forces, seizes and secures terrain, or both. Commonly combined with aviation units.',
    answers: [
      { text: 'Pending Aviation unit', correct: false },
      { text: 'Pending Aviation unit with attack helicopter capability', correct: true },
      { text: 'Unknown Aviation unit with attack helicopter capability', correct: false },
      { text: 'Neutral Aviation unit with attack helicopter capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.maintenancePLT.file,
    description: 'Army aviation or rotary wing aviation – Conducts attack and air movement functions in support of ground maneuver in the area of operations or area of interest.',
    answers: [
      { text: 'Hostile Support Platoon', correct: false },
      { text: 'Assumed Hostile Maintenance platoon', correct: false },
      { text: 'Hostile Maintenance platoon with aviation maintenance capability', correct: true },
      { text: 'Hostile Attack Helicopter company with maintenance capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EOS.file,
    description: 'Provides support to a battalion.',
    answers: [
      { text: 'Friendly Infantry Security Force Assistance team', correct: false },
      { text: 'Assumed Friendly Infantry team', correct: false },
      { text: 'Assumed Friendly Infantry Special Forces team', correct: false },
      { text: 'Assumed Friendly Infantry Security Force Assistance team supporting a battalion', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.biological.file,
    description:
      'Capability to detect biological warfare agent employment as a measure to provide medical treatment (See FM 3-11). A biological agent is a microorganism (or a toxin derived from it) disease in personnel, plants, or animals or causes the deterioration of materiel.',
    answers: [
      { text: 'Hostile CBRN unit with biological capability', correct: true },
      { text: 'Friendly Infantry Security Force Assistance team', correct: false },
      { text: 'Hostile Mortar unit with biological capability', correct: false },
      { text: 'Hostile Missile unit with biological capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bridging.file,
    description: 'Assets used to cross a gap; the two types of bridging are standard and nonstandard bridging',
    answers: [
      { text: 'Hostile Mechanized Engineer unit', correct: false },
      { text: 'Hostile Engineer unit with bridging capability', correct: true },
      { text: 'Hostile Engineer unit with biological capability', correct: false },
      { text: 'Hostile Engineer unit with transportation capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EOSB.file,
    description: 'Provides support to a brigade',
    answers: [
      { text: 'Pending Support Battalion', correct: false },
      { text: 'Unknown Support Battalion', correct: false },
      { text: 'Unknown Brigade support battalion', correct: true },
      { text: 'Hostile Brigade support battalion', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.chemical.file,
    description:
      'Capability to non-intrusively assess chemical munitions. A chemical agent is a substance that is intended for use in military operations to kill, seriously injure, or incapacitate, mainly through physiological effects.',
    answers: [
      { text: 'Friendly Infantry Security Force Assistance team', correct: false },
      { text: 'Hostile Mortar unit with biological capability', correct: false },
      { text: 'Hostile Missile unit with biological capability', correct: false },
      { text: 'Hostile CBRN unit with chemical capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.combat.file,
    description: 'Can conduct mobility, counter-mobility, and survivability.',
    answers: [
      { text: 'Pending Engineer unit with combat capability', correct: true },
      { text: 'Unknown Explosives unit with combat capability', correct: false },
      { text: 'Pending Bridging unit with combat capability', correct: false },
      { text: 'Pending Construction unit with Coalition Building Team', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CPN.file,
    description: 'Provides SIPRNET, NIPRNET, secure and non-secure VoIP, and battlefield video teleconferencing services.',
    answers: [
      { text: 'Friendly Signal unit', correct: false },
      { text: 'Friendly Signal unit with command post node capability', correct: true },
      { text: 'Friendly Meteorological unit with Combat Plans Node capability', correct: false },
      { text: 'Assumed Friendly Signal unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.C2.file,
    description: 'The exercise of authority and direction by a properly designated commander over assigned and attached forces in the accomplishment of the mission.',
    answers: [
      { text: 'Hostile Fixed wing unit', correct: false },
      { text: 'Assumed Hostile Fixed wing unit with C2 Capability', correct: false },
      { text: 'Hostile Aviation unit with C2 capability', correct: true },
      { text: 'Hostile Aviation unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EOSC.file,
    description: 'Provides support to a Company.',
    answers: [
      { text: 'Hostile Special Forces Assistance team', correct: false },
      { text: 'Hostile Infantry company', correct: false },
      { text: 'Hostile Infantry Security force assistance team', correct: false },
      { text: 'Hostile Infantry Security force assistance team supporting a company', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.composite.file,
    description:
      'A combination of different capabilities and equipment assigned or attached to a unit with a common function or purpose. Note: This modifier symbol is interchangeable. Composite may be used as a Sector 1 or Sector 2 modifier with the same meaning.',
    answers: [
      { text: 'Pending Transportation unit with multiple variations of vehicles', correct: true },
      { text: 'Unknown Transportation unit with composite capabilities', correct: false },
      { text: 'Pending Transportation unit with computers', correct: false },
      { text: 'Pending Transportation unit supporting a company', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.construction.file,
    description: 'A general engineering capability focused on improving or repairing austere conditions, infrastructure, and building base camps and new lines of communications.',
    answers: [
      { text: 'Unknown Engineer unit with composite capabilities', correct: false },
      { text: 'Neutral Engineer unit with construction support', correct: true },
      { text: 'Neutral Bridging unit with construction support', correct: false },
      { text: 'Pending Transportation unit supporting a company', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EOSCorps.file,
    description: 'Provides support to a Corps.',
    answers: [
      { text: 'Friendly Special Forces Assistance team', correct: false },
      { text: 'Friendly Infantry battalion', correct: false },
      { text: 'Friendly Special troops battalion supporting a corps', correct: true },
      { text: 'Friendly Special troops battalion supporting a brigade', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CI.file,
    description:
      'Capability to gather information and conduct activities to identify, deceive, exploit, disrupt, or protect against espionage, other intelligence activities, sabotage, or assassinations conducted for or on behalf of foreign powers, organizations or persons or their agents, or international terrorist organizations or activities.',
    answers: [
      { text: 'Neutral Military Intelligence unit with Combat Identification capability', correct: false },
      { text: 'Neutral Military Intelligence unit', correct: false },
      { text: 'Unknown Military Intelligence unit', correct: false },
      { text: 'Neutral Military intelligence unit with counterintelligence capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CID.file,
    description:
      'Capabilities are particularly relevant in site exploitation and other evidence collection requirements on the battlefield, training and assistance to host nation law enforcement organizations, and collection of police information and analysis and production of police and specific criminal intelligence critical in identifying, understanding, and attacking criminal networks operating against U.S. interests.',
    answers: [
      { text: 'Pending Military Police unit with criminal investigation division capability', correct: true },
      { text: 'Unknown Military Police unit with Combat Identification capability', correct: false },
      { text: 'Pending Military Police unit', correct: false },
      { text: 'Unknown Military Police unit with Counter Intelligence capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CCC.file,
    description: 'The capability to communicate with individuals who have differences in culture (nationality, ethnicity, race, gender).',
    answers: [
      { text: 'Friendly Civil Affairs unit with Coalition Coordination Center', correct: false },
      { text: 'Friendly Civil affairs unit with cross cultural communications capability', correct: true },
      { text: 'Friendly Civil Affairs unit with construction capabilities', correct: false },
      { text: 'Friendly Civil Affairs Captains Career Course', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CRC.file,
    description: 'Capability to use chemical compounds that are developed, in part, for military use (riot control agents, smokes, obscurants), but not as weapons.',
    answers: [
      { text: 'Hostile Civil Affairs unit with Coalition Coordination Center', correct: false },
      { text: 'Assumed Hostile Military Police unit with construction and repair center', correct: false },
      { text: 'Assumed Hostile Military police unit with crowd and riot control capability', correct: true },
      { text: 'Hostile Military Police unit with Contingency Response Crew', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CYB.file,
    description: 'The employment of cyberspace capabilities where the primary purpose is to achieve objectives in or through cyberspace.',
    answers: [
      { text: 'Friendly Military Police unit with criminal investigation division capability', correct: false },
      { text: 'Friendly Military Intelligence unit with Combat Identification capability', correct: false },
      { text: 'Friendly Military Police unit', correct: false },
      { text: 'Friendly Military intelligence unit with Cyberspace operations capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.decontamination.file,
    description:
      'The process of making any person, object, or area safe by absorbing, destroying, neutralizing, making harmless, or removing chemical or biological agents, or by removing radioactive material clinging to or around it. Note: The Decontamination modifier is interchangeable and be used as a Sector 1 or Sector 2 modifier with the same meaning.',
    answers: [
      { text: 'Hostile CBRN unit with decontamination capability', correct: true },
      { text: 'Hostile Infantry Security Force Assistance team', correct: false },
      { text: 'Hostile Mortar unit with decontamination capability', correct: false },
      { text: 'Hostile Missile unit with decontamination capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.detention.file,
    description:
      'Capability to shelter, sustain, guard, protect, and account for populations or groups (detainees or U.S. military prisoners) as a result of military or civil conflict or to facilitate criminal prosecution.',
    answers: [
      { text: 'Hostile Military police unit with detention capability', correct: false },
      { text: 'Neutral Military police unit with detention capability', correct: true },
      { text: 'Neutral Military police unit with det cord', correct: false },
      { text: 'Military police unit with crowd deterrent capabilities', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.digitalSignal.file,
    description: 'A Digital Signal is related to Signal units. It is really uninteresting.',
    answers: [
      { text: 'Friendly Signal unit with digging capability', correct: false },
      { text: 'Assumed Friendly Signal unit', correct: false },
      { text: 'Friendly Signal unit with digital capability', correct: true },
      { text: 'Friendly Engineer unit with digging capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.diving.file,
    description: 'Capability to conduct scuba and surface diving operations to a depth of 190 feet in a maritime environment in support of combat, general, and geospatial engineering.',
    answers: [
      { text: 'Friendly Bridging unit with diving capability', correct: false },
      { text: 'Friendly Bridging unit with digital capability', correct: false },
      { text: 'Assumed Friendly Engineer unit with digging capability', correct: false },
      { text: 'Assumed Friendly Engineer unit with diving capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EOSD.file,
    description: 'Provides support to a Division.',
    answers: [
      { text: 'Neutral Sustainment brigade supporting a division', correct: true },
      { text: 'Neutral Special Forces Assistance team', correct: false },
      { text: 'Neutral Sustainment battalion', correct: false },
      { text: 'Neutral Sustainment troops corps supporting a division', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.dog.file,
    description: '(Working Dog) A canine capability that enhances security, police operations, and force protection missions (counter improvised explosive device operations, assured mobility).',
    answers: [
      { text: 'Pending Special Forces Assistance company', correct: false },
      { text: 'Pending Special Forces company with working dog capability', correct: true },
      { text: 'Unknown Special Troops company', correct: false },
      { text: 'Unknown Special Forces company with Digital/Optical/Geospatial equipment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.drilling.file,
    description: 'Capability to detect and assess water sources and drilling water wells.',
    answers: [
      { text: 'Pending Bridging unit outpost', correct: false },
      { text: 'Pending Engineer unit with mine emplacement capability', correct: false },
      { text: 'Unknown Engineer unit with drilling capability', correct: true },
      { text: 'Unknown Engineer unit with diving capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EW.file,
    description: 'Military action involving the use of electromagnetic and directed energy to control the electromagnetic spectrum or to attack the enemy. Also called EW.',
    answers: [
      { text: 'Neutral Milk Hotel', correct: false },
      { text: 'Neutral Military Intelligence unit with mine emplacement capability', correct: false },
      { text: 'Pending Military Intelligence unit with electronic warfare capability', correct: false },
      { text: 'Neutral Military Intelligence unit with electronic warfare capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EO.file,
    description: 'Imaging systems used for military or law enforcement applications which include both visible and infrared sensors. This is usually used with night vision devices.',
    answers: [
      { text: 'Neutral Maintenance unit with electro-optical capability', correct: true },
      { text: 'Neutral Maintenance unit with Equal Opportunity specialists', correct: false },
      { text: 'Neutral Logistical unit with Explosive Ordnance', correct: false },
      { text: 'Pending Maintenance unit with Explosive Ordnance', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EPP.file,
    description: 'Capability to produce electrical power by converting fuels or other energy sources to electricity.',
    answers: [
      { text: 'Assumed Friendly Engineer section with electric generation capability', correct: false },
      { text: 'Assumed Friendly Engineer platoon with electric generation capability', correct: true },
      { text: 'Friendly Engineer platoon with electric generation capability', correct: false },
      { text: 'Friendly Engineer section with electric generation capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.enhancedSignal.file,
    description: 'Provides network installation, troubleshooting, quality assurance testing, and handoff coordination to enable the transition from tactical to semi-permanent automation support.',
    answers: [
      { text: 'Pending Enhanced Road Crossing', correct: false },
      { text: 'Pending Signal unit with enhanced capability', correct: false },
      { text: 'Unknown Signal unit with enhanced capability', correct: true },
      { text: 'Unknown Enhanced Road Crossing', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ordnanceEOD.file,
    description:
      'The detection, identification, on-site evaluation, rendering safe, recovery, and final disposal of unexploded explosive ordnance. The detection, identification, on-site evaluation, rendering safe, exploitation, recovery, and final disposal of explosive ordnance. Also called EOD.',
    answers: [
      { text: 'Friendly Ordnance unit with Electro-Optical Detection capability', correct: false },
      { text: 'Friendly Ordnance unit with explosive ordnance disposal capability', correct: false },
      { text: 'Assumed Friendly Ordnance unit with explosive ordnance disposal capability', correct: false },
      { text: 'Assumed Friendly Engineer with electric generation capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.forwardSPT.file,
    description: 'An inherent designed capability to function effectively in positions located in geographic proximity of an objective.',
    answers: [
      { text: 'Hostile Forward Support company', correct: true },
      { text: 'Hostile Special Troops company', correct: false },
      { text: 'Hostile Forward Special Purpose Team battalion', correct: false },
      { text: 'Assumed Hostile Forward company', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.FDC.file,
    description:
      'That element of a command post, consisting of gunnery and communications personnel and equipment, by means of which the commander exercises fire direction and/or fire control. Also called FDC.',
    answers: [
      { text: 'Friendly Artillery fires deflection unit', correct: false },
      { text: 'Friendly Artillery fire direction center unit', correct: true },
      { text: 'Friendly Federal Detention Center', correct: false },
      { text: 'Friendly Artillery fire direction center platoon', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.generalEngineering.file,
    description: 'Those engineering capabilities and activities, other than combat engineering, that provide infrastructure and modify, maintain, or protect the physical environment.',
    answers: [
      { text: 'Friendly Bridge (general purpose)', correct: false },
      { text: 'Friendly Bridging unit with general engineering capability', correct: false },
      { text: 'Assumed Friendly Engineer unit with general engineering capability', correct: true },
      { text: 'Assumed Friendly Artillery fire direction center platoon', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.geospatialInformation.file,
    description:
      'Information that identifies the geographic location and characteristics of natural or constructed features and boundaries on the Earth, including: statistical data and information derived from, among other things, remote sensing, mapping, and surveying technologies; and mapping, charting, geodetic data and related products.',
    answers: [
      { text: 'Hostile Engineer unit with mortar support', correct: false },
      { text: 'Hostile Engineer unit', correct: false },
      { text: 'Assumed Hostile Bridging unit with EOD capability', correct: false },
      { text: 'Assumed Hostile Engineer unit with geospatial capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HQ.file,
    description: 'A place from which a commander performs the functions of command.',
    answers: [
      { text: 'Friendly Artillery brigade headquarters', correct: true },
      { text: 'Friendly Artillery brigade', correct: false },
      { text: 'Friendly Construction unit headquarters', correct: false },
      { text: 'Friendly Artillery division headquarters', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EOSIS.file,
    description: 'Provides support to an independent support command.',
    answers: [
      { text: 'Friendly Sustainment division supporting an independent support command', correct: false },
      { text: 'Friendly Sustainment brigade supporting an independent support command', correct: true },
      { text: 'Friendly Sustainment brigade', correct: false },
      { text: 'Friendly Sustainment command', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.intermodal.file,
    description:
      'Type of international freight system that permits transshipping among sea, highway, rail, and air modes of transportation through use of American National Standards Institute and International Organization for Standardization containers, line haul assets, and handling equipment. Note: The Intermodal modifier is interchangeable and be used as a Sector 1 or Sector 2 modifier with the same meaning.',
    answers: [
      { text: 'Unknown Transportation regiment with intermodal capability', correct: false },
      { text: 'Neutral Artillery battalion with intermodal capability', correct: false },
      { text: 'Neutral Transportation battalion with intermodal capability', correct: true },
      { text: 'Neutral Transportation battalion with bridging capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.jamming.file,
    description:
      'Capability to broadcast a signal tuned to frequencies with enough power to override signals at the receivers (spot jamming or barrage jamming). Note: The Jamming modifier is interchangeable and be used as a Sector 1 or Sector 2 modifier with the same meaning. In order to avoid overlapping of symbols you will need to shorten the line of the main icon to allow space for the Sector 1 modifier.',
    answers: [
      { text: 'Unknown Transportation regiment with intermodal capability', correct: false },
      { text: 'Friendly Signal unit with Top Secret transmissions', correct: false },
      { text: 'Friendly Signal unit with amphibious capability', correct: false },
      { text: 'Friendly Signal unit with jamming capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.JNN.file,
    description:
      'Provides connection to the regional hub node uses a dedicated frequency division multiple access satellite communications link, and shares bandwidth among Command Post Nodes using network centric waveform satellite communications.',
    answers: [
      { text: 'Neutral Signal unit with joint node network capability', correct: true },
      { text: 'Neutral Signal company with joint news network transmissions', correct: false },
      { text: 'Neutral Transportation unit with Joint NATO Network capability', correct: false },
      { text: 'Unknown Signal unit with amphibious capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.aviationMaintenance.file,
    description:
      'Ensures unit readiness by maintaining weapon systems and equipment in a fully mission-capable status for immediate and continuous employment in complex and highly lethal environments. Note: The Maintenance modifier is interchangeable and be used as a Sector 1 or Sector 2 modifier with the same meaning.',
    answers: [
      { text: 'Friendly Helicopter unit', correct: false },
      { text: 'Friendly Aviation unit with organic maintenance capability', correct: true },
      { text: 'Friendly Fixed wing unit with towing capability', correct: false },
      { text: 'Friendly Signal unit with amphibious capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MEDEVAC.file,
    description:
      'The timely and effective movement of the wounded, injured, or ill to and between medical treatment facilities on dedicated and properly marked medical platforms with en route care provided by medical personnel.',
    answers: [
      { text: 'Friendly Helicopter unit', correct: false },
      { text: 'Friendly Fixed wing unit with towing capability', correct: false },
      { text: 'Friendly Aviation unit with medical evacuation capability', correct: true },
      { text: 'Friendly Signal unit with amphibious capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MR1.file,
    description: 'Unit-level medical care capability provided by the combat medic or medical treatment provided by the battalion aid station.',
    answers: [
      { text: 'Friendly Hospital', correct: false },
      { text: 'Friendly Infantry unit', correct: false },
      { text: 'Friendly Medical unit with 1 doctor', correct: false },
      { text: 'Friendly Medical unit with Role 1 capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MR2.file,
    description: 'Capability to provide care by area support squads or medical treatment platoons of medical companies with greater medical capabilities available than Role 1.',
    answers: [
      { text: 'Hostile Medical unit with Role 1 capability', correct: true },
      { text: 'Hostile Hospital', correct: false },
      { text: 'Hostile Infantry unit', correct: false },
      { text: 'Hostile Medical unit with 2 doctors', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MR3.file,
    description: 'Capability to provide care to all categories of patients, to include resuscitation, initial wound surgery, damage control surgery, and postoperative treatment.',
    answers: [
      { text: 'Assumed Friendly Hospital', correct: false },
      { text: 'Assumed Friendly Medical unit with Role 3 capability', correct: true },
      { text: 'Assumed Friendly Infantry unit', correct: false },
      { text: 'Assumed Friendly Medical unit with 3 doctors', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MR4.file,
    description: 'Medical care capability found in CONUS-based medical treatment facilities, robust OCONUS medical treatment facilities, and other safe havens.',
    answers: [
      { text: 'Assumed Hostile Hospital', correct: false },
      { text: 'Assumed Hostile Infantry unit', correct: false },
      { text: 'Assumed Hostile Medical unit with Role 4 capability', correct: true },
      { text: 'Assumed Hostile Medical unit with 4 doctors', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MET.file,
    description: 'Capability to provide weather and weather forecasting data.',
    answers: [
      { text: 'Assumed Pending Artillery unit with Marine Expeditionary Team', correct: false },
      { text: 'Pending Artillery unit with Mobile Electric Transformer', correct: false },
      { text: 'Unknown Artillery unit with Media Engagement Team', correct: false },
      { text: 'Pending Artillery unit with meteorological capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.watercraft.file,
    description: 'Capability to conduct heavy lifting associated with water transport operational maneuver and intra-theater lift of units, equipment and supplies.',
    answers: [
      { text: 'Unknown Transportation unit with watercraft capability', correct: true },
      { text: 'Unknown Surface to Air Missile unit', correct: false },
      { text: 'Unknown Logistical support company with digging equipment', correct: false },
      { text: 'Unknown Artillery unit with Media Engagement Team', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.weapons.file,
    description:
      'Heavy weapons systems capability (machine guns and anti-armor weapons) to provide additional combat power. This particular symbol is an infantry unit with machine gun and anti-armor capability.',
    answers: [
      { text: 'Assumed Friendly Heavy Weapons Infantry unit', correct: true },
      { text: 'Assumed Friendly Infantry unit', correct: false },
      { text: 'Assumed Friendly Logistical support company with digging equipment', correct: false },
      { text: 'Assumed Friendly Cavalry unit with Media Engagement Team', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MAS.file,
    description: 'Capability to asses, plan, and coordinate with host nation and or local population.',
    answers: [
      { text: 'Friendly Transportation team with rail support', correct: false },
      { text: 'Friendly Transportation rail unit with mobile advisor and support team', correct: true },
      { text: 'Friendly Logistical support company with digging equipment', correct: false },
      { text: 'Friendly Artillery unit with Media Engagement Team', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MS.file,
    description:
      'Capability to support, breaching operations, clearing operations, gap-crossing operations, traffic control plan development, main and alternate supply route regulation and enforcement, passage of lines, straggler movement control.',
    answers: [
      { text: 'Unknown Transportation unit with missiles', correct: false },
      { text: 'Neutral Transportation unit with missiles', correct: false },
      { text: 'Neutral Transportation unit with mobility support capability', correct: true },
      { text: 'Neutral Artillery unit with Media Support Team', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mod1Mortar.file,
    description: 'Organic fire support to battalions, squadrons, companies, and troops, and are available to a commander when other indirect fire support is not available.',
    answers: [
      { text: 'Unknown Transportation unit with missiles', correct: false },
      { text: 'Assumed Hostile armored infantry with artillery sensing equipment', correct: false },
      { text: 'Assumed Hostile armored infantry with missile launchers', correct: false },
      { text: 'Assumed Hostile Mechanized armored infantry unit with mortar capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MN.file,
    description: 'Between two or more forces or agencies of two or more nations or coalition partners.',
    answers: [
      { text: 'Neutral Multinational transportation unit with multiple variations of vehicles', correct: true },
      { text: 'Neutral Multinational Transportation unit', correct: false },
      { text: 'Neutral Transportation unit with multiple NATO units', correct: false },
      { text: 'Unknown Composite Transportation unit with multiple NATO units', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HIMARS.file,
    description: 'Multiple Launch Rocket System / High Mobility Artillery Rocket System capability.',
    answers: [
      { text: 'Friendly Artillery unit with medium range mortars', correct: false },
      { text: 'Friendly HIMARS Artillery unit with multiple rocket launcher capability', correct: true },
      { text: 'Friendly Drilling unit with Geospatial survey equipment', correct: false },
      { text: 'Friendly Engineer unit with bedrock drilling capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MTS.file,
    description: 'Capability to provide support functions to fixed, unimproved, bare beach, and/or degraded port facilities, and at off-shore anchorages.',
    answers: [
      { text: 'Unknown Engineer battalion with naval construction capability', correct: false },
      { text: 'Neutral Naval Bridging battalion', correct: false },
      { text: 'Neutral Engineer battalion with maritime terminal support construction capability', correct: true },
      { text: 'Neutral Naval Engineer regiment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.NO.file,
    description: 'Activities conducted to operate and defend the Global Information Grid.',
    answers: [
      { text: 'Unknown Signal unit with Naval Engagement Team', correct: false },
      { text: 'Neutral Signal unit with Naval Engagement Team', correct: false },
      { text: 'Neutral Signal unit with SIPRNET capability', correct: false },
      { text: 'Unknown Signal unit with network operations capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.nuclear.file,
    description:
      'Capability of assessing, exploiting, characterizing, and disabling facilities associated with the nuclear fuel cycle in semi-permissive or permissive environments. Advises commanders on the risks associated with these facilities, provide detailed information related to potential material proliferation, and make recommendations on how to dispose of nuclear material.',
    answers: [
      { text: 'Friendly CBRN unit with nuclear capability', correct: true },
      { text: 'Friendly Infantry Security Force Assistance team', correct: false },
      { text: 'Friendly Mortar unit with nuclear capability', correct: false },
      { text: 'Friendly Missile unit with nuclear capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.operations.file,
    description: 'Capability to execute the principal planning and operating functions of a unit.',
    answers: [
      { text: 'Neutral Transportation Special Purpose Troops operations unit', correct: false },
      { text: 'Neutral Transportation support operations unit', correct: true },
      { text: 'Neutral Mortar unit with Operations Support capability', correct: false },
      { text: 'Neutral Missile unit with Operations Support capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.PLS.file,
    description: 'A fitted integral self-loading and unloading cargo system capability.',
    answers: [
      { text: 'Hostile Transportation company', correct: false },
      { text: 'Assumed Hostile Multiple Rocket Launching platform', correct: false },
      { text: 'Assumed Hostile Transportation unit with palletized load system capability', correct: true },
      { text: 'Assumed Hostile Transportation company with Pneumatic Loading Systems', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.POL.file,
    description: 'Capability to receive, stock, or distribute petroleum products.',
    answers: [
      { text: 'Neutral Quartermaster unit with POL storage capability', correct: false },
      { text: 'Unknown Quartermaster unit with POL storage capability', correct: false },
      { text: 'Pending Quartermaster unit with with Geospatial capability', correct: false },
      { text: 'Pending Quartermaster unit with POL storage capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.pipeline.file,
    description: 'A capability that consists of pipeline sets, pipeline pump stations, and pipeline support equipment. Its primary function is to transport fuel from one area to another.',
    answers: [
      { text: 'Friendly Quartermaster unit with pipeline capability', correct: true },
      { text: 'Friendly Logistician unit with towing capability', correct: false },
      { text: 'Friendly Armorer unit with armory access', correct: false },
      { text: 'Friendly pipeline under lock', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.postal.file,
    description:
      'Capability to operate as an extension of the United States Postal Service consistent with public law and federal regulations beyond the boundaries of U.S. sovereignty and provides postal services for all DOD personnel where there is no United States Postal Service available during normal and contingency operations.',
    answers: [
      { text: 'Friendly Palletized System unit with towing capability', correct: false },
      { text: 'Friendly Personnel services unit with postal service capability', correct: true },
      { text: 'Friendly Human Resources unit with armory access', correct: false },
      { text: 'Friendly Port Security unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.radar.file,
    description:
      'A device or system consisting usually of a synchronized radio transmitter and receiver that emits radio waves and processes their reflections for display and is used especially for detecting and locating objects or surface features.',
    answers: [
      { text: 'Friendly Artillery headquarters', correct: false },
      { text: 'Assumed Friendly mobile counter battery', correct: false },
      { text: 'Assumed Friendly Artillery unit with radar capability', correct: true },
      { text: 'Assumed Friendly Digging unit with signal capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.radiological.file,
    description:
      'A device or system consisting usually of a synchronized radio transmitter and receiver that emits radio waves and processes their reflections for display and is used especially for detecting and locating objects or surface features.',
    answers: [
      { text: 'Pending Infantry Security Force Assistance team', correct: false },
      { text: 'Pending Mortar unit with radiological capability', correct: false },
      { text: 'Pending Missile unit with radiological capability', correct: false },
      { text: 'Pending CBRN unit with radiological capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.railway.file,
    description: 'Provides rail network capability and infrastructure assessments, and coordinates contracts.',
    answers: [
      { text: 'Hostile Transportation unit with railway capability', correct: true },
      { text: 'Hostile Infantry Security Force Assistance team', correct: false },
      { text: 'Hostile Mortar unit with railway capability', correct: false },
      { text: 'Templated Missile unit with railway capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RTNS.file,
    description: 'Capability to extend the range of single-channel radio networks to support command and control in retrograde operations.',
    answers: [
      { text: 'Hostile Signal unit with retrans capability', correct: false },
      { text: 'Assumed Hostile Signal unit with retrans capability', correct: true },
      { text: 'Assumed Hostile retrograde transportation intersection', correct: false },
      { text: 'Assumed Hostile transformer equipment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.riverine.file,
    description: 'Provides water transport to move troops and equipment.',
    answers: [
      { text: 'Friendly Engineer unit with NATO Cooperation support', correct: false },
      { text: 'Assumed Friendly Naval engineer unit support', correct: false },
      { text: 'Assumed Friendly Engineer unit with riverine support capability', correct: true },
      { text: 'Assumed Friendly Bridging unit with naval support capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mod1SAR.file,
    description:
      'The use of aircraft, surface craft, submarines, and specialized rescue teams and equipment to search for and rescue distressed persons on land or at sea in a permissive environment.',
    answers: [
      { text: 'Friendly Aviation Satellite Access Request', correct: false },
      { text: 'Friendly Aviation Surface to Air Rocket unit', correct: false },
      { text: 'Friendly Fixed wing unit with search and rescue capability', correct: false },
      { text: 'Friendly Aviation (rotary) unit with search and rescue capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.sensor.file,
    description: 'Capability to observe or receive a signal or observable from a person or object.',
    answers: [
      { text: 'Assumed Friendly Military intelligence unit with sensor capability', correct: true },
      { text: 'Assumed Friendly Aviation Satellite Access Request', correct: false },
      { text: 'Assumed Friendly Military intelligence Surface to Air Rocket unit', correct: false },
      { text: 'Friendly Fixed wing unit with search and rescue capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MISI.file,
    description: 'Intelligence derived from communications, electronic, and foreign instrumentation signals.',
    answers: [
      { text: 'Assumed Hostile Aviation Satellite Access Request', correct: false },
      { text: 'Hostile Military intelligence unit with signal intelligence capability', correct: true },
      { text: 'Hostile Military intelligence Surface to Air Rocket unit', correct: false },
      { text: 'Hostile Military intelligence unit with geospatial capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.singleRocketLauncher.file,
    description: '(shoulder-launched munitions) - unguided free-flight rocket and a launcher that contains all features and controls necessary to aim, fire, and engage targets.',
    answers: [
      { text: 'Friendly medium range rocket artillery unit', correct: false },
      { text: 'Friendly short range rocket artillery unit', correct: false },
      { text: 'Friendly Artillery unit with single rocket launcher capability', correct: true },
      { text: 'Friendly Artillery unit with multiple rocket launcher capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.sniper.file,
    description:
      "A specialized trained marksman with tactical skills and techniques, that is highly capable at conducting detailed surveillance and shooting at exposed enemy's forces from a concealed vantage point.",
    answers: [
      { text: 'Friendly Infantry unit with geospatial capability', correct: false },
      { text: 'Friendly Cavalry unit with trailer hitch capability', correct: false },
      { text: 'Friendly Infantry unit on an outpost overwatching a crossroads', correct: false },
      { text: 'Friendly Infantry unit with sniper capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.survey.file,
    description: 'Provides position and azimuth determining global positioning system capability.',
    answers: [
      { text: 'Unknown Artillery unit with survey capability', correct: true },
      { text: 'Unknown Artillery unit with geospatial capability', correct: false },
      { text: 'Unknown Artillery unit with counter-battery capability', correct: false },
      { text: 'Pending Artillery unit with geospatial capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.satellite.file,
    description: 'Signal unit with satellite capability.',
    answers: [
      { text: 'Assumed Friendly Signal unit with survey capability', correct: false },
      { text: 'Assumed Friendly Signal unit with tactical satellite communications capability', correct: true },
      { text: 'Assumed Friendly Signal unit with retrans capability', correct: false },
      { text: 'Unknown Signal unit with network operations capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TA.file,
    description: 'The detection, identification, and location of a target in sufficient detail to permit the effective employment of weapons.',
    answers: [
      { text: 'Pending Artillery unit transported by tanker airlift', correct: false },
      { text: 'Neutral Artillery unit with Terminal Attack capability', correct: false },
      { text: 'Neutral Artillery unit with target acquisition capability', correct: true },
      { text: 'Unknown Artillery unit with Tactical Assets', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EOSA.file,
    description: 'Provides support to a theater army.',
    answers: [
      { text: 'Unknown Sustainment theatre supporting a command', correct: false },
      { text: 'Pending Sustainment command theatre headquarters', correct: false },
      { text: 'Pending Sustainment theatre supporting a command', correct: false },
      { text: 'Pending Sustainment Command supporting a theater army', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EOST.file,
    description: 'Provides support to a theater army.',
    answers: [
      { text: 'Assumed Hostile Sustainment Command supporting a theater of operations', correct: true },
      { text: 'Unknown Sustainment theatre supporting a command', correct: false },
      { text: 'Assumed Hostile Sustainment command theatre headquarters', correct: false },
      { text: 'Assumed Hostile Sustainment theatre supporting a command', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.UAS.file,
    description: 'A system whose components include the necessary equipment, network, and personnel to control an unmanned aircraft. Also called UAS.',
    answers: [
      { text: 'Unknown Aviation (rotary-wing) unit with UAV capability', correct: false },
      { text: 'Unknown Aviation (fixed-wing) unit with UAS capability', correct: true },
      { text: 'Unknown Aviation unit with tactical satellite capability', correct: false },
      { text: 'Pending Aviation unit with mid-air refueling capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.utility.file,
    description: 'Equipment designed or adapted for general purpose use.',
    answers: [
      { text: 'Hostile Aviation unit flying in an ungoverned area', correct: false },
      { text: 'Hostile Aviation unit with unmanned capability', correct: false },
      { text: 'Hostile Aviation (rotary-wing) unit with utility helicopter capability', correct: true },
      { text: 'Hostile Aviation (rotary-wing) unit with underground helicopter capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.combatCamera.file,
    description: 'Specially-trained expeditionary forces from Service-designated units capable of providing high-quality directed visual information during military operations.',
    answers: [
      { text: 'Friendly Signal unit with battery backup capability', correct: false },
      { text: 'Friendly intersection overwatched by camera', correct: false },
      { text: 'Friendly Signal unit with pipeline capability', correct: false },
      { text: 'Friendly Signal unit with combat camera capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.water.file,
    description: 'Capability to receive, stock, produce, or distribute water.',
    answers: [
      { text: 'Neutral Quartermaster unit with water production capability', correct: true },
      { text: 'Neutral Custodian unit', correct: false },
      { text: 'Neutral Quartermaster unit with boobytrap capability', correct: false },
      { text: 'Unknown water production facility', correct: false },
    ],
  },
  // ? Sector 2
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airborneInfantry.file,
    description: 'Capability to parachute into an objective area.',
    answers: [
      { text: 'Friendly Infantry unit with air assault capability', correct: false },
      { text: 'Friendly Infantry unit with airborne capability', correct: true },
      { text: 'Friendly Infantry unit in defilade', correct: false },
      { text: 'Friendly Infantry unit with smoke capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.amphibiousInfantry.file,
    description: 'Capability to conduct amphibious operations within the littorals.',
    answers: [
      { text: 'Assumed Hostile Infantry unit with air assault capability', correct: false },
      { text: 'Assumed Hostile Infantry unit in defilade', correct: false },
      { text: 'Assumed Hostile Infantry unit with amphibious capability', correct: true },
      { text: 'Assumed Hostile Infantry unit with smoke capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.analysis.file,
    description: 'Capability to conduct a detailed examination of anything complex in order to understand its nature or to determine its essential features.',
    answers: [
      { text: 'Hostile Military Intelligence unit with electronic warfare working group', correct: false },
      { text: 'Templated Military Intelligence unit with electronic warfare and mining capability', correct: false },
      { text: 'Hostile Military Intelligence unit with mining capability', correct: false },
      { text: 'Hostile Military Intelligence unit with electronic warfare analysis capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.armoredTracked.file,
    description: 'A vehicle equipped or protected with armor, and with a continuous band of treads or track plates for self-propelled mobility.',
    answers: [
      { text: 'Unknown Artillery unit with armored self propelled (tracked) capability', correct: true },
      { text: 'Unknown Artillery with wheeled capability', correct: false },
      { text: 'Pending Artillery with tracked capability', correct: false },
      { text: 'Pending Artillery with entrenching capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.YB.file,
    description: 'A vehicle equipped or protected with armor, and with a continuous band of treads or track plates for self-propelled mobility.',
    answers: [
      { text: 'Unknown Transportation unit with Youth Brigade (NATO) capability', correct: false },
      { text: 'Unknown Transportation unit with barge (not self-propelled) capability', correct: true },
      { text: 'Pending Artillery with tracked capability', correct: false },
      { text: 'Pending Artillery with young bloods', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bloodSupport.file,
    description: 'A vehicle equipped or protected with armor, and with a continuous band of treads or track plates for self-propelled mobility.',
    answers: [
      { text: 'Friendly Engineer unit with Oil Drilling capability', correct: false },
      { text: 'Friendly Infantry unit with medical blood support', correct: false },
      { text: 'Friendly Medical unit with blood support capability', correct: true },
      { text: 'Friendly Medical unit with hospital support', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.COSC.file,
    description: 'A capability that provides behavioral health services such as consultation and combat and operational stress control.',
    answers: [
      { text: 'Assumed Friendly Medical unit with physical therapy capability', correct: false },
      { text: 'Assumed Friendly Medical unit with Sexual Assault Counselor support', correct: false },
      { text: 'Assumed Friendly Medical unit with High-Ohm imaging capability', correct: false },
      { text: 'Assumed Friendly Medical unit with combat and operational stress control capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.control.file,
    description:
      'An action taken to eliminate a hazard or reduce its risk. Note: This symbol demonstrates the capability and authority to exercise restraining or directing influence (regulating) over a specific function.',
    answers: [
      { text: 'Neutral Transportation battalion with capability control (movement control)', correct: true },
      { text: 'Neutral Transportation battalion with target acquisition capability', correct: false },
      { text: 'Neutral heavy mortar unit regiment with counter-battery capability', correct: false },
      { text: 'Neutral Transportation division with GPS tracking capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.COMP.file,
    description: 'A combination of different capabilities and equipment assigned or attached to a unit with a common function or purpose.',
    answers: [
      { text: 'Pending Transportation battalion with target composition capability', correct: false },
      { text: 'Pending Transportation unit with multiple variations of vehicles', correct: true },
      { text: 'Pending heavy mortar unit regiment with counter-battery capability', correct: false },
      { text: 'Pending Transportation division with GPS tracking capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CBRNDECON.file,
    description:
      'The process of making any person, object, or area safe by absorbing, destroying, neutralizing, making harmless, or removing chemical or biological agents, or by removing radioactive material clinging to or around it.',
    answers: [
      { text: 'Assumed Friendly Mortar unit with high explosive chemical munitions', correct: false },
      { text: 'Assumed Friendly CBRN unit with chemical detonation capability', correct: false },
      { text: 'Assumed Friendly CBRN unit with chemical decontamination capability', correct: true },
      { text: 'Assumed Friendly Missile unit with chemical warheads', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.dentalServices.file,
    description: 'Provides consultation, early treatment of severe oral and maxillofacial injuries; and augment medical personnel (as necessary) during mass casualty operations.',
    answers: [
      { text: 'Friendly Medical unit with behavioral health capability', correct: false },
      { text: 'Dentist office installation', correct: false },
      { text: 'Friendly Infantry unit augmented with dentists', correct: false },
      { text: 'Friendly Medical unit with dental service capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.directionFinding.file,
    description: 'A procedure for obtaining bearings of radio frequency emitters by using a highly directional antenna and a display unit on an intercept receiver or ancillary equipment.',
    answers: [
      { text: 'Pending Military Intelligence unit with electronic warfare direction finding capability', correct: true },
      { text: 'Pending Military Intelligence unit with light mortar capability', correct: false },
      { text: 'Pending Military Intelligence unit with Electronic Warfare Officer Working group', correct: false },
      { text: 'Unknown Military Intelligence unit with electronic foraging capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.guerilla.file,
    description:
      'An irregular, predominantly indigenous member of a guerrilla force organized similar to military concepts and structure in order to conduct military and paramilitary operations in enemy-held, hostile, or denied territory. Although a guerrilla and guerrilla forces can exist independent of an insurgency, guerrillas normally operate in covert and overt resistance operations of an insurgency.',
    answers: [
      { text: 'Assumed Friendly Infantry unit with generator equipment', correct: false },
      { text: 'Assumed Friendly Guerrilla infantry unit', correct: true },
      { text: 'Assumed Friendly Guerilla medical unit', correct: false },
      { text: 'Friendly Guerilla infantry unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.heavy.file,
    description: 'The heavy modifier is Multi-use; for many types of units.',
    answers: [
      { text: 'Hostile heavy infantry unit', correct: false },
      { text: 'Hostile heavy mortars unit', correct: false },
      { text: 'Hostile Transportation unit with heavy vehicle capability', correct: true },
      { text: 'Hostile Transportation unit with HIMARS vehicles', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.highAltitude.file,
    description: 'The High Altitude modifier is typically used in missile and rocket units.',
    answers: [
      { text: 'Unknown Air Defense Heavy Artillery', correct: false },
      { text: 'Unknown Air Defense Artillery', correct: false },
      { text: 'Pending Air and Missile defense with heavy artillery munitions', correct: false },
      { text: 'Pending Air and missile defense unit with high altitude capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.LAB.file,
    description: 'A place equipped for experimental study in a science or for testing and analysis.',
    answers: [
      { text: 'Neutral CBRN unit with laboratory capability', correct: true },
      { text: 'Neutral CBRN unit with Light Air-Blast capability', correct: false },
      { text: 'Neutral CBRN unit with labrador retrievers', correct: false },
      { text: 'Unknown CBRN unit with laboratory capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.LC.file,
    description: 'The light modifier is Multi-use; for many types of units.',
    answers: [
      { text: 'Pending Transportation unit with Light cargo capability', correct: false },
      { text: 'Pending Transportation unit with landing craft capability', correct: true },
      { text: 'Pending light infantry unit', correct: false },
      { text: 'Pending light cluster mortars unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.light.file,
    description:
      'Provides vessels (Landing Craft Utility 2000 or Landing Craft Mechanized-8) to increase access to austere points on the littorals that are unavailable to land forces, and to link ship and shore operations centers.',
    answers: [
      { text: 'Friendly light infantry unit', correct: false },
      { text: 'Friendly light mortars unit', correct: false },
      { text: 'Friendly Transportation unit with light vehicle capability', correct: true },
      { text: 'Friendly Transportation unit with loading vehicles', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.lightAndMedium.file,
    description: 'The light and medium modifier is Multi-use; for many types of units.',
    answers: [
      { text: 'Hostile light and medium infantry unit', correct: false },
      { text: 'Hostile light and medium mortars unit', correct: false },
      { text: 'Hostile Transportation unit with light maritime vehicles', correct: false },
      { text: 'Hostile Transportation unit with light and medium vehicle capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.longRange.file,
    description: 'The long range modifier is Multi-use; for many types of units.',
    answers: [
      { text: 'Pending Military intelligence unit with long range unmanned aircraft system capability', correct: true },
      { text: 'Pending Military Intelligence unit with Light Reconnaissance and UAS assets', correct: false },
      { text: 'Pending Military Intelligence unit with low radar UAS assets', correct: false },
      { text: 'Pending Transportation unit with long range maritime vehicles', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.lowAltitude.file,
    description: 'The long altitude modifier is Multi-use; for many types of units.',
    answers: [
      { text: 'Assumed Hostile Air Defense Artillery with light armor defeating capability', correct: false },
      { text: 'Assumed Hostile Air defense unit with low altitude capability', correct: true },
      { text: 'Pending Air Defense unit with limited approach capability', correct: false },
      { text: 'Pending AIr Defense unit with light armor capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.recoveryMaint.file,
    description:
      'Ensures unit readiness by maintaining weapon systems and equipment in a fully mission-capable status for immediate and continuous employment in complex and highly lethal environments.',
    answers: [
      { text: 'Unknown Armor company with organic maintenance capability', correct: false },
      { text: 'Pending Armored (wheeled) section with towing capability', correct: false },
      { text: 'Pending Armor (tracked) platoon with organic maintenance capability', correct: true },
      { text: 'Unknown Armored platoon with towing capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.medicalBed.file,
    description: 'A capability to identify and locate available adequate bed assets for current and anticipated needs.',
    answers: [
      { text: 'Friendly Medical unit treating 3 patients', correct: false },
      { text: 'Friendly Medical unit with 3 doctors and medical bed capability', correct: false },
      { text: 'Friendly Medical facility with 3 medical beds available', correct: false },
      { text: 'Friendly Medical facility with Role 3 and medical bed capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.medium.file,
    description: 'The Medium modifier is Multi-use; for many types of units.',
    answers: [
      { text: 'Hostile medium infantry unit', correct: false },
      { text: 'Assumed Hostile medium mortars unit', correct: false },
      { text: 'Assumed Hostile Transportation unit with HIMARS vehicles', correct: false },
      { text: 'Assumed Hostile Transportation unit with medium vehicle capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MA.file,
    description: 'The Medium Altitude modifier is Multi-use; for many types of units. Typically found on ADA units.',
    answers: [
      { text: 'Pending Air Defense Artillery with medium armor defeating capability', correct: false },
      { text: 'Neutral Air Defense unit with maximum approach capability', correct: false },
      { text: 'Neutral Air Defense unit with medium armor capability', correct: false },
      { text: 'Neutral Air defense unit with medium altitude capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MIMR.file,
    description: 'The Medium Range modifier is Multi-use; for many types of units, located in Sector 2 space. The Unmanned Aerial System is located in the Sector 1 space.',
    answers: [
      { text: 'Assumed Friendly Military intelligence unit with medium range UAS capability', correct: true },
      { text: 'Assumed Friendly Military Intelligence unit with maximum range Electro-optical sensing', correct: false },
      { text: 'Assumed Friendly Military Intelligence unit with organic medium range rotary wing helicopters', correct: false },
      { text: 'Assumed Friendly Military Intelligence unit with Armored Mine Resistant capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MHA.file,
    description: 'The Medium to High Altitude modifier is Multi-use; for many types of units. Typically found on ADA units.',
    answers: [
      { text: 'Friendly Air Defense unit with maximum to high altitude sensing capability', correct: false },
      { text: 'Friendly Air defense unit with medium to high altitude capability', correct: true },
      { text: 'Friendly Air Defense unit with medium to heavy armor capability', correct: false },
      { text: 'Friendly Air Defense Artillery with medium to heavy armor defeating capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mountain.file,
    description: 'Capability to conduct mountain warfare.',
    answers: [
      { text: 'Friendly Infantry platoon operating as Border Patrol', correct: false },
      { text: 'Friendly Infantry unit emplaced in Observation Posts', correct: false },
      { text: 'Friendly Infantry unit with mountain capability', correct: true },
      { text: 'Friendly Infantry unit with missile capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.multifunctional.file,
    description: 'The Multifunctional modifier is Multi-use; for many types of units.',
    answers: [
      { text: 'Unknown Infantry Regiment with missile capability', correct: false },
      { text: 'Unknown Cavalry Squadron with mobile facility capability', correct: false },
      { text: 'Pending Cavalry Battalion with missile capability', correct: false },
      { text: 'Pending Cavalry Squadron with multifunctional capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OGTB.file,
    description: 'The "AT" modifier describes a Class A 128-foot large tug capable of coastal and ocean towing and docking and undocking operations with large ocean vessels.',
    answers: [
      { text: 'Neutral Transportation unit with tug (ocean-going) capability', correct: true },
      { text: 'Unknown Infantry unit with anti-tank missile capability', correct: false },
      { text: 'Neutral Transportation unit with anti-tank missile capability', correct: false },
      { text: 'Neutral armored (wheeled) unit with anti-tank capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.optometry.file,
    description: 'A capability to provide optometry care, optical fabrication, and repair support.',
    answers: [
      { text: 'Friendly Medical treatment facility with optometry capability', correct: false },
      { text: 'Friendly Medical unit with optometry capability', correct: true },
      { text: 'Friendly Medical unit with the Eye of Sauron', correct: false },
      { text: 'Friendly medical treatment unit on a screen line (reconnaissance)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.overSnow.file,
    description: 'The "over snow (prime mover)" symbol modifier is Multi-use; for many types of units.',
    answers: [
      { text: 'Friendly Infantry unit with vehicular snorkels', correct: false },
      { text: 'Friendly Infantry company with snowshoes', correct: false },
      { text: 'Friendly Infantry unit with over-snow capability', correct: true },
      { text: 'Friendly Infantry unit with towing capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.packAnimal.file,
    description: 'An animal transport system capability that enhances mobility when the area of operations restricts normal methods of transport or resupply.',
    answers: [
      { text: 'Pending Infantry unit with mountain capability', correct: false },
      { text: 'Pending Infantry company with snowshoes', correct: false },
      { text: 'Unknown Infantry unit with medium range capability', correct: false },
      { text: 'Unknown Infantry unit with pack animal capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.preventativeMedicine.file,
    description:
      'Capability that provides consultation and conducts medical surveillance which includes health risk communication, education, field sanitation, pest and vector control, disease risk assessment, environmental and occupational monitoring and health surveillance, preventive medicine measures, health threat controls for waste (human, hazardous, and medical) disposal, food safety inspection, and potable water surveillance.',
    answers: [
      { text: 'Assumed Friendly Medical unit with preventive medicine capability', correct: true },
      { text: 'Assumed Friendly Medical unit with mountain capability', correct: false },
      { text: 'Assumed Friendly Medical Treatment Facility with land surveying capability', correct: false },
      { text: 'Friendly Medical Unit with Geospatial analysis capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.recovery.file,
    description: 'Actions taken to extricate damaged or disabled equipment for return to friendly control or repair at another location.',
    answers: [
      { text: 'Assumed Hostile Transportation unit with armored and wheeled capability', correct: false },
      { text: 'Assumed Hostile Transportation unit stuck in mud', correct: false },
      { text: 'Assumed Hostile Transportation unit with recovery capability', correct: true },
      { text: 'Assumed Hostile armored (wheeled) unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MOD2Riverine.file,
    description: 'Provides water transport to move troops and equipment.',
    answers: [
      { text: 'Pending Engineer unit with NATO Cooperation support', correct: false },
      { text: 'Unknown Naval engineer unit support', correct: false },
      { text: 'Unknown Bridging unit with naval support capability', correct: false },
      { text: 'Unknown Engineer unit with riverine capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MOD2Search.file,
    description: 'A systematic reconnaissance of a defined area, so that all parts of the area have passed within visibility.',
    answers: [
      { text: 'Unknown Military intelligence unit with electronic warfare search capability', correct: true },
      { text: 'Pending Military intelligence unit with NATO Cooperation support', correct: false },
      { text: 'Unknown Military Intelligence unit with electronic warfare working group', correct: false },
      { text: 'Pending Military Intelligence unit with electronic warfare working group', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MOD2SFA.file,
    description: 'The Department of Defense activities that support the development of the capacity and capability of foreign security forces and their supporting institutions.',
    answers: [
      { text: 'Friendly Infantry security force assistance Division', correct: false },
      { text: 'Friendly Infantry security force assistance brigade', correct: true },
      { text: 'Friendly Infantry special forces ODA (A-Team) brigade', correct: false },
      { text: 'Friendly Infantry brigade with organic surface fleet aircraft', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.surgical.file,
    description: 'Capability to provide life or limb saving operative treatment using specialized instruments to repair or stabilize a patient.',
    answers: [
      { text: 'Friendly Medical unit with observation post capability', correct: false },
      { text: 'Friendly Medical Treatment Facility on an observation post', correct: false },
      { text: 'Friendly Medical unit with surgical capability', correct: true },
      { text: 'Friendly Medical unit with Behavioral health capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SCY.file,
    description: 'Sector 1 Modifier is a seaport and Sector 2 modifier is a Service Craft Yard (for units with maritime capabilities).',
    answers: [
      { text: 'Pending Transportation unit with naval barge loading and unloading capability', correct: false },
      { text: 'Pending Transportation unit with naval barge loading capability', correct: false },
      { text: 'Pending Transportation unit with seafaring capability', correct: false },
      { text: 'Pending Transportation unit with seaport service craft yard capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SR.file,
    description: 'Sector 1 Modifier is a seaport and Sector 2 modifier is a Service Craft Yard (for units with maritime capabilities).',
    answers: [
      { text: 'Unknown Air defense unit with short range capability', correct: true },
      { text: 'Unknown Air Defense unit with short range Electro-optical sensing', correct: false },
      { text: 'Pending Air Defense unit with organic short range rotary wing helicopters', correct: false },
      { text: 'Unknown Air Defense unit with Shock Resistant capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ski.file,
    description: 'Provides specialized equipment used by trained individuals with skills to negotiate arduous snow-covered terrain.',
    answers: [
      { text: 'Pending Infantry unit with light mortars capability', correct: false },
      { text: 'Pending Infantry unit with ski capability', correct: true },
      { text: 'Pending Infantry unit with entrenching capability', correct: false },
      { text: 'Unknown Infantry unit with missile capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.sled.file,
    description: 'The sled symbol modifier is Multi-use; for many types of units.',
    answers: [
      { text: 'Neutral Infantry unit with towing capability', correct: false },
      { text: 'Neutral Infantry unit with ski capability', correct: false },
      { text: 'Neutral Infantry unit with sled capability', correct: true },
      { text: 'Unknown Infantry unit with missile capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SDDC.file,
    description:
      'The Sector 1 Modifier is a Seaport and the Sector 2 modifier is a Surface Deployment and Distribution Command. This represents the Global ocean and inland waterway port manager and surface transportation service provider as part of U.S. transportation command’s Joint Deployment and Distribution Enterprise.',
    answers: [
      { text: 'Friendly Transportation unit with naval vessel towing capability', correct: false },
      { text: 'Friendly naval unit with sub-surface deployment capability', correct: false },
      { text: 'Friendly Transportation seaport unit with Surface Detonation and Decontamination Cleanup capability', correct: false },
      { text: 'Friendly Transportation seaport unit with deployment support capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MOD2Supply.file,
    description: 'The process of providing all items necessary to equip, maintain, and operate a military command.',
    answers: [
      { text: 'Pending Quartermaster unit with supply capability', correct: true },
      { text: 'Pending Custodian unit with supply capability', correct: false },
      { text: 'Pending Port Security with supply capability', correct: false },
      { text: 'Unknown Port Security with supply capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MOD2Support.file,
    description:
      '<p class="mdc-typography--body1 symbol--description"><strong>Description:</strong> 1. The action of a force that aids, protects, complements, or sustains another force in accordance with the directive requiring such action.<br>2. A unit that helps another unit in battle.<br>3. An element of a command that assists, protects, or supplies other forces in combat.</p>',
    answers: [
      { text: 'Friendly Engineer unit with organic special purpose troops', correct: false },
      { text: 'Friendly Engineer platoon with support capability', correct: true },
      { text: 'Friendly Engineer unit with support capability', correct: false },
      { text: 'Friendly Bridging unit with supply capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MOD2Towed.file,
    description: 'Prime mover capability to pull a piece of equipment unable to move on its own.',
    answers: [
      { text: 'Friendly Custodian unit with supply capability', correct: false },
      { text: 'Friendly Artillery with supply capability', correct: false },
      { text: 'Friendly Artillery unit with towed capability (towed howitzer)', correct: true },
      { text: 'Friendly Artillery with logistical support capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TH.file,
    description: 'Class B vessel that supports movement of barges and lighterage of various types in harbors, port areas and during LOTS anchorage.',
    answers: [
      { text: 'Assumed Hostile Transportation unit with naval vessel towing capability', correct: false },
      { text: 'Hostile naval unit with sub-surface deployment capability', correct: false },
      { text: 'Hostile Transportation seaport unit with Surface Detonation and Decontamination Cleanup capability', correct: false },
      { text: 'Hostile Transportation unit with tug (harbor) capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.VTOL.file,
    description: 'Capability to take off and land vertically.',
    answers: [
      { text: 'Unknown Fixed-wing unit with vertical take-off and landing capability', correct: true },
      { text: 'Unknown Rotary-wing unit with vertical take-off and landing capability', correct: false },
      { text: 'Pending Fixed-wing unit with vertical take-off and landing capability', correct: false },
      { text: 'Pending Rotary-wing unit with vertical take-off and landing capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.VH.file,
    description: 'The "VH" in the Sector 2 modifier applies to artillery only',
    answers: [
      { text: 'Hostile Artillery unit with very heavy cargo capability', correct: false },
      { text: 'Assumed Hostile Artillery unit with very heavy artillery capability', correct: true },
      { text: 'Assumed Hostile artillery unit with organic vehicles', correct: false },
      { text: 'Assumed Hostile Air defense artillery unit with very high altitude capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.VET.file,
    description: 'The "V" in the Sector 2 represents a capability that provides consultation, animal care, food protection, and veterinary public health services.',
    answers: [
      { text: 'Pending Medical unit with veterinary service capability', correct: false },
      { text: 'Assumed Hostile Medical unit with veterinary service capability', correct: false },
      { text: 'Unknown Medical unit with veterinary service capability', correct: true },
      { text: 'Unknown Medical unit with very high altitude capability', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.WGV.file,
    description:
      'The Sector 1 modifier represents a Headquarters. The Sector 2 modifier represents a watercraft with the capability to conduct heavy lifting associated with water transport operational maneuver and intra-theater lift of units, equipment and supplies.',
    answers: [
      { text: 'Friendly Transportation headquarters unit with mountainous capability', correct: false },
      { text: 'Friendly Transportation unit with all terrain capability', correct: false },
      { text: 'Friendly Transportation unit with underwater mining capability', correct: false },
      { text: 'Friendly Transportation headquarters unit with watercraft capability', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.WHM.file,
    description:
      'The Sector 1 modifier represents armored capability. The Sector 2 modifier represents a wheeled capability that can traverse various types of off-road terrain, unimproved routes, and paved road networks.',
    answers: [
      { text: 'Neutral CBRN reconnaissance unit with armored wheeled (high mobility) vehicle capability', correct: true },
      { text: 'Neutral CBRN unit with armored wheeled transportation capability', correct: false },
      { text: 'Neutral Cavalry unit with mortars transported by armored wheeled vehicles', correct: false },
      { text: 'Unknown Transportation unit with underwater mining capability', correct: false },
    ],
  },
  // ? Attached/Detached amplifiers
  {
    question: 'What is this symbol?',
    symbolSVG: mso.reinforced.file,
    description: 'This amplifier is used at brigade echelons and below. Use a plus (+) symbol when reinforcing (attaching) one or more sub-elements of a similar function to a headquarters.',
    answers: [
      { text: 'Friendly reduced ground unit', correct: false },
      { text: 'Friendly reinforced ground unit', correct: true },
      { text: 'Friendly reinforced and reduced ground unit', correct: false },
      { text: 'Friendly task force ground unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.reduced.file,
    description: 'This amplifier is used at brigade echelons and below. Use a minus symbol (–) when reducing (detaching) one or more sub-elements of a similar function to a headquarters.',
    answers: [
      { text: 'Friendly reinforced ground unit', correct: false },
      { text: 'Friendly reinforced and reduced ground unit', correct: false },
      { text: 'Friendly reduced ground unit', correct: true },
      { text: 'Friendly task force ground unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RAR.file,
    description:
      'This amplifier is used at brigade echelons and below. Use a plus and minus symbol (±) when reinforcing (attaching) and reducing (detaching) one or more sub-elements of a similar function to a headquarters',
    answers: [
      { text: 'Friendly reinforced ground unit', correct: false },
      { text: 'Friendly task force ground unit', correct: false },
      { text: 'Friendly reduced ground unit', correct: false },
      { text: 'Friendly reinforced and reduced ground unit', correct: true },
    ],
  },
  // ? Task Force amplifiers
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TFCT.file,
    description:
      'A company team is a combined arms organization formed by attaching one or more nonorganic armor, mechanized infantry, Stryker infantry, or infantry platoons to a tank, mechanized infantry, Stryker, or infantry company, either in exchange for, or in addition to, its organic platoons.',
    answers: [
      { text: 'Friendly Light Infantry Company Task Force', correct: true },
      { text: 'Friendly Light Infantry Company', correct: false },
      { text: 'Friendly Light Infantry Battalion Task Force', correct: false },
      { text: 'Friendly Infantry Company Task Force', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TFBTF.file,
    description:
      'A battalion task force is a maneuver battalion-size unit consisting of a battalion headquarters, at least one assigned company size-element, and at least one attached company-size element from another maneuver or support unit (functional or multifunctional).',
    answers: [
      { text: 'Friendly Air Assault Mechanized Infantry headquarters Battalion', correct: false },
      { text: 'Friendly Mechanized Armored Airborne Infantry Battalion Headquarters Task Force', correct: true },
      { text: 'Friendly Airborne Infantry Battalion Task Force', correct: false },
      { text: 'Friendly Infantry Battalion headquarters Task Force', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TFMEF.file,
    description:
      'A Marine expeditionary force (MEF), formerly known as a Marine amphibious force, is the largest type of a Marine air-ground task force. A MEF is the largest building block of United States Marine Corps combat power.',
    answers: [
      { text: 'Friendly Air Assault Amphibious Infantry Corps', correct: false },
      { text: 'Friendly Airborne Infantry Brigade Task Force', correct: false },
      { text: 'Friendly III Marine Expeditionary Force', correct: true },
      { text: 'Friendly Amphibious Infantry Corps Task Force', correct: false },
    ],
  },
  // ? Command Post amplifiers
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CTCP.file,
    description: 'Controls and coordinates administrative and logistical support.',
    answers: [
      { text: 'Friendly Command Training Center Post', correct: false },
      { text: 'Friendly Combat Training Center Post', correct: false },
      { text: 'Friendly Combat Trains Command Post Task Force', correct: false },
      { text: 'Friendly Combat Trains Command Post', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EECP.file,
    description: 'A lead element of a headquarters designed to control operations until the remaining portions of the headquarters are deployed and operational.',
    answers: [
      { text: 'Friendly Early Entry Command Post', correct: true },
      { text: 'Friendly Essential Elements Command Post', correct: false },
      { text: 'Friendly Emergency Evacuation Command Post', correct: false },
      { text: 'Friendly Electronic Engagement Command Post Task Force', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.FTCP.file,
    description: 'A lead element of a headquarters designed to control operations until the remaining portions of the headquarters are deployed and operational.',
    answers: [
      { text: 'Friendly Field Training Command Post', correct: false },
      { text: 'Friendly Field Trains Command Post', correct: true },
      { text: 'Friendly Full Time Command Post', correct: false },
      { text: 'Friendly Fixed Target Command Post Task Force', correct: false },
    ],
  },
  // ? Military Symbols Examples
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E1.file,
    description: '1st Aviation Battalion (attack), 25th Regiment, 25th Combat Aviation Brigade, 25th Infantry Division',
    answers: [
      { text: '1st Aviation Squadron (attack), 25th Regiment, 25th Combat Aviation Brigade, 25th Infantry Division', correct: false },
      { text: '1st Aviation Battalion, 25th Regiment, 25th Combat Aviation Brigade, 25th Infantry Division', correct: false },
      { text: '1st Aviation Battalion (attack), 25th Regiment, 25th Combat Aviation Brigade, 25th Infantry Division', correct: true },
      { text: '1st Aviation Company (attack), 25th Regiment, 25th Combat Aviation Brigade, 25th Infantry Division', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E2.file,
    description: '2nd Infantry Battalion (mountain capability), 1st Regiment, 2nd Brigade Combat Team, 10th Mountain Division, 3rd Corps',
    answers: [
      { text: '2nd Infantry Battalion (mountain capability), 1st Regiment, 2nd Brigade Combat Team, 10th Mountain Division', correct: false },
      { text: '2nd Infantry Battalion (mountain capability), 1st Regiment, 2nd Brigade Combat Team, 10th Mountain Division, 3rd Army', correct: false },
      { text: '2nd Infantry Regiment, 1st Regiment, 2nd Brigade Combat Team, 10th Division, 3rd Corps', correct: false },
      { text: '2nd Infantry Battalion (mountain capability), 1st Regiment, 2nd Brigade Combat Team, 10th Mountain Division, 3rd Corps', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E3.file,
    description: 'B Troop (light), 2nd Squadron, 101st Cavalry Regiment, 27th Infantry Brigade Combat Team, 42nd Infantry Division',
    answers: [
      { text: 'B Troop (light), 2nd Squadron, 101st Cavalry Regiment, 27th Infantry Brigade Combat Team, 42nd Infantry Division', correct: true },
      { text: 'B Troop (light), 2nd Troop, 101st Cavalry Regiment, 27th Brigade Combat Team, 42nd Infantry Division', correct: false },
      { text: 'B Company (light), 2nd Squadron, 101st Airborne Division, 27th Infantry Brigade Combat Team, 42nd Infantry Division', correct: false },
      { text: 'B Troop, 2nd Squadron, 101st Cavalry Regiment, 27th Infantry Brigade Combat Team, 42nd Infantry Division', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E4.file,
    description: '4th Infantry Battalion (armored high mobility vehicle capability), 23rd Infantry Regiment, 2nd Stryker Brigade Combat Team, 2nd Infantry Division',
    answers: [
      { text: '4th Infantry Regiment (armored high mobility vehicle capability), 23rd Infantry Regiment, 2nd Stryker Brigade Combat Team, 2nd Infantry Division', correct: false },
      { text: '4th Infantry Battalion (armored high mobility vehicle capability), 23rd Infantry Regiment, 2nd Stryker Brigade Combat Team, 2nd Infantry Division', correct: true },
      { text: '4th Infantry Battalion, 23rd Infantry Regiment, 2nd Stryker Brigade Combat Team, 2nd Infantry Division', correct: false },
      { text: '4th Infantry Battalion (armored high mobility vehicle capability), 23rd Infantry Company, 2nd Infantry Brigade Combat Team, 2nd Infantry Division', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E5.file,
    description: '14th Brigade Engineer Battalion, 2nd Stryker Brigade Combat Team, 2nd Infantry Division',
    answers: [
      { text: '14th Brigade Engineer Battalion, 2nd Infantry Brigade Combat Team, 2nd Infantry Division', correct: false },
      { text: '14th Brigade Engineers, 2nd Stryker Brigade Combat Team, 2nd Infantry Division', correct: false },
      { text: '14th Brigade Engineer Battalion, 2nd Stryker Brigade Combat Team, 2nd Infantry Division', correct: true },
      { text: '14th Engineer, 2nd Stryker Brigade Combat Team, 2nd Infantry Division', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E6.file,
    description: '299th Brigade Support Battalion, 2nd Brigade Combat Team, 1st Infantry Division',
    answers: [
      { text: '299th Brigade Special Troops Battalion, 2nd Brigade Combat Team, 1st Infantry Division', correct: false },
      { text: '299th Support Battalion, 2nd Brigade Combat Team, 1st Infantry Division', correct: false },
      { text: '299th Brigade Support Regiment, 2nd Brigade Combat Team, 1st Infantry Division', correct: false },
      { text: '299th Brigade Support Battalion, 2nd Brigade Combat Team, 1st Infantry Division', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E7.file,
    description: '2nd Ranger Battalion, 75th Ranger Regiment',
    answers: [
      { text: '2nd Ranger Battalion, 75th Ranger Regiment', correct: true },
      { text: '2nd Regular Troops Battalion, 75th Ranger Regiment', correct: false },
      { text: '2nd Ranger Company, 75th Ranger Battalion', correct: false },
      { text: '2nd Ranger Troop, 75th Ranger Regiment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E8.file,
    description: '2nd Military Intelligence Battalion (unmanned aircraft system capability), 66th Military Intelligence Brigade',
    answers: [
      { text: '2nd Military Intelligence Battalion (unmanned aircraft system capability), 66th Military Intelligence Battalion', correct: false },
      { text: '2nd Military Intelligence Battalion (unmanned aircraft system capability), 66th Military Intelligence Brigade', correct: true },
      { text: '2nd Military Intelligence Battalion, 66th Military Intelligence Brigade', correct: false },
      { text: '2nd Military Intelligence Regiment (unmanned aircraft system capability), 66th Military Intelligence Brigade', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E9.file,
    description: '6th Field Artillery Battalion (self-propelled multiple rocket launcher capability), 37th Field Artillery Regiment, 2nd Infantry Division',
    answers: [
      { text: '6th Field Artillery Battalion, 37th Field Artillery Brigade, 2nd Infantry Division', correct: false },
      { text: '6th Field Artillery Battalion, 37th Field Artillery Regiment, 2nd Infantry Division', correct: false },
      { text: '6th Field Artillery Battalion (self-propelled multiple rocket launcher capability), 37th Field Artillery Regiment, 2nd Infantry Division', correct: true },
      { text: '6th Field Artillery Battalion (self-propelled multiple rocket launcher capability), 37th Field Artillery Brigade, 2nd Infantry Division', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E10.file,
    description: '181st Transportation Battalion, 3rd Expeditionary Sustainment Command, 3rd Corps',
    answers: [
      { text: '181st Transportation Battalion, 3rd Expeditionary Sustainment Command, 3rd MEF', correct: false },
      { text: '181st Transportation Regiment, 3rd Expeditionary Sustainment Command, 3rd Army', correct: false },
      { text: '181st Transportation Brigade, 3rd Expeditionary Sustainment Command, 3rd Corps', correct: false },
      { text: '181st Transportation Battalion, 3rd Expeditionary Sustainment Command, 3rd Corps', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E11.file,
    description: '67th Forward Support Company, 201st Brigade Support Battalion, 3rd Infantry Brigade Combat Team, 1st Infantry Division',
    answers: [
      { text: '67th Forward Support Company, 201st Brigade Support Battalion, 3rd Infantry Brigade Combat Team, 1st Infantry Division', correct: true },
      { text: '67th Forward Special Troops Company, 201st Brigade Support Battalion, 3rd Infantry Brigade Combat Team, 1st Infantry Division', correct: false },
      { text: '67th Support Company, 201st Brigade Support Battalion, 3rd Infantry Brigade Combat Team, 1st Infantry Division', correct: false },
      { text: '67th Forward Support battalion, 201st Brigade Support Brigade, 3rd Infantry Brigade Combat Team, 1st Infantry Division', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.E12.file,
    description: 'Operational Detachment Alpha 595 (pack animal capability), C Company, 3rd Battalion, 5th Special Forces Group',
    answers: [
      { text: '595th Security Forces (pack animal capability) platoon, C Company, 3rd Air Wing, 5th Security Forces Group', correct: false },
      { text: 'Operational Detachment Alpha 595 (pack animal capability), C Company, 3rd Battalion, 5th Special Forces Group', correct: true },
      { text: '595th Security Forces platoon, C Company, 3rd Air Wing, 5th Special Forces Group', correct: false },
      { text: 'Operational Detachment Delta 595 (mountain capability), C Company, 3rd Battalion, 5th Special Forces Group', correct: false },
    ],
  },
  // ? Activities
  {
    question: 'What is this symbol?',
    symbolSVG: mso.arrest.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Leadership activity', correct: false },
      { text: 'Hostile Downed Pilot', correct: false },
      { text: 'Hostile Arrest Activity', correct: true },
      { text: 'Hostile Enemy Personnel', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.attemptedCriminalActivity.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Assumed Hostile Leadership activity', correct: false },
      { text: 'Hostile Assassination Activity', correct: false },
      { text: 'Hostile Enemy Personnel', correct: false },
      { text: 'Assumed Hostile Attempted Criminal Activities Victim', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ACIO.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Attempted Criminal Activities Multiple Victims', correct: true },
      { text: 'Assumed Hostile Leadership activity', correct: false },
      { text: 'Hostile Assassination Activity', correct: false },
      { text: 'Hostile Enemy Personnel', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bombing.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Bomb unit', correct: false },
      { text: 'Hostile Bombing activity', correct: true },
      { text: 'Hostile Bomb equipment', correct: false },
      { text: 'Hostile Bomb squad', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.boobyTrap.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Observation post', correct: false },
      { text: 'Hostile mortar equipment', correct: false },
      { text: 'Hostile booby trap activity', correct: true },
      { text: 'Hostile mining activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.massDemonstration.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Unknown massing of forces activity', correct: false },
      { text: 'Unknown mass effect equipment', correct: false },
      { text: 'Unknown religious activity', correct: false },
      { text: 'Unknown mass demonstration activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.drugs.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile illegal drug related activity', correct: true },
      { text: 'Hostile drugs', correct: false },
      { text: 'Hostile drugs installation', correct: false },
      { text: 'Hostile illegal drugs unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.election.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile polling installation', correct: false },
      { text: 'Hostile election, voting or polling place activity', correct: true },
      { text: 'Hostile polling unit', correct: false },
      { text: 'The 2020 Democratic National Convention', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EMOActivity.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Friendly Emergency Response unit', correct: false },
      { text: 'Observation Post', correct: false },
      { text: 'Friendly Emergency Operations (Management) activity', correct: true },
      { text: 'Friendly Observation Post', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.emergencyMedicalOperation.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Assumed Hostile Emergency Response unit', correct: false },
      { text: 'Observation Post', correct: false },
      { text: 'Assumed Hostile Firefighting unit', correct: false },
      { text: 'Assumed Hostile Emergency Medical Operation activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.exfiltrationActivity.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Friendly Exfiltration activity', correct: true },
      { text: 'Friendly Extraction activity', correct: false },
      { text: 'Friendly Equipment Cross Fill Location', correct: false },
      { text: 'Friendly Equipment Cross Fueling Location', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.explosion_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Explosives unit', correct: false },
      { text: 'Hostile Explosion activity', correct: true },
      { text: 'Hostile Explosives Cache', correct: false },
      { text: 'Hostile Mortar Firing Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.extortion_ACT.file,
    description:
      'The black boxes in the corner of the symbol denote an activity. Note: this symbol can reflect whatever the currency that is being demanded. In accordance with ADP 1-02 the 4 available extortion symbols are Dollars, Euros, Pounds, and Yuan.',
    answers: [
      { text: 'Bounced Check', correct: false },
      { text: 'Hostile Bank installation', correct: false },
      { text: 'Hostile Extortion activity', correct: true },
      { text: 'Hostile Finance unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fireEvent_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Explosives unit', correct: false },
      { text: 'Hostile Explosives Cache', correct: false },
      { text: 'Hostile Mortar Firing Point', correct: false },
      { text: 'Hostile Fire (event)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fireHotSpot_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Fire (hot spot) activity', correct: true },
      { text: 'Hostile Explosive activity', correct: false },
      { text: 'Hostile Explosives Cache', correct: false },
      { text: 'Hostile Ammunition Explosion', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fireOrigin_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Explosive activity', correct: false },
      { text: 'Hostile Fire (origin) activity', correct: true },
      { text: 'Hostile Explosives Cache', correct: false },
      { text: 'Hostile Ammunition Explosion', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.house_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Unknown Tented Installation', correct: false },
      { text: 'Unknown Unit Headquarters', correct: false },
      { text: 'Unknown House or Home activity', correct: true },
      { text: 'Unknown Trap house', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.graffiti_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Rough waves warning (naval)', correct: false },
      { text: 'Slippery Roads Warning', correct: false },
      { text: 'Hostile searching or foraging activity', correct: false },
      { text: 'Hostile graffiti activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CAV_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Criminal Activities Victim', correct: true },
      { text: 'Hostile Leadership Execution', correct: false },
      { text: 'No Personnel Allowed', correct: false },
      { text: 'No-Go Zone', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CAMV_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Leadership Execution', correct: false },
      { text: 'Hostile Criminal Activities Multiple Victims', correct: true },
      { text: 'No Personnel Allowed', correct: false },
      { text: 'No-Go Zone', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.IED_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Improvised Explosive Device Cache', correct: false },
      { text: 'Hostile Improvised Explosive Device equipment', correct: false },
      { text: 'Hostile Improvised Explosive Device activity', correct: true },
      { text: 'Hostile Improvised Explosive Device production facility', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.INFL_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Information and Forward Logistics activity', correct: false },
      { text: 'Bureau of International Narcotics and Federal Law', correct: false },
      { text: 'Hostile Infantry Firing Line', correct: false },
      { text: 'Hostile Infiltration activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.patrolling_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Unknown patrolling activity', correct: true },
      { text: 'Unknown power grid', correct: false },
      { text: 'Pending Power grid', correct: false },
      { text: 'Unknown Mortar firing point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.poisoning_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Enemy Graveyard', correct: false },
      { text: 'Hostile poisoning activity', correct: true },
      { text: 'Hostile campfire', correct: false },
      { text: 'Hostile Mortar firing point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.riot_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Unknown Riot activity', correct: false },
      { text: 'Neutral Riot activity', correct: false },
      { text: 'Hostile riot activity', correct: true },
      { text: 'Assumed Hostile riot', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rock_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Riot activity', correct: false },
      { text: 'Neutral Riot activity', correct: false },
      { text: 'Hostile rock throwing activity', correct: true },
      { text: 'Assumed Hostile riot', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.blackMarket_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Biomedical Research Facility', correct: false },
      { text: 'Hostile Ballistic Missile', correct: false },
      { text: 'Hostile Black Market Installation', correct: false },
      { text: 'Hostile Black Market activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.jailbreak_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Jailbreak activity', correct: true },
      { text: 'Hostile Prison', correct: false },
      { text: 'Hostile EPW facility', correct: false },
      { text: 'Hostile Circus', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.burglary_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Building and Urban Redevelopment activity', correct: false },
      { text: 'Hostile Burglary activity', correct: true },
      { text: 'Hostile Basic Unmanned Radar', correct: false },
      { text: 'Hostile Battlefield Unmanned Radar', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.robbery_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Reduced Operations Boat', correct: false },
      { text: 'Hostile Rapid Obfuscation Battery', correct: false },
      { text: 'Hostile Robbery activity', correct: true },
      { text: 'Hostile Recovery of the Battlefield activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.searchingOrForaging.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Unknown TOW missile equipment', correct: false },
      { text: 'Unknown TOW missile unit', correct: false },
      { text: 'Unknown graffiti activity', correct: false },
      { text: 'Unknown searching or foraging activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.shooting_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Small Arms Equipment', correct: false },
      { text: 'Hostile Drive by shooting', correct: false },
      { text: 'Hostile Arms Manufacturing facility', correct: false },
      { text: 'Hostile Shooting activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.sniping_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Sniping activity', correct: true },
      { text: 'Hostile crossroads', correct: false },
      { text: 'Hostile Artillery bracketing activity', correct: false },
      { text: 'Hostile Arms Manufacturing facility', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.spying_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Assumed Hostile Strategic Planning activity', correct: false },
      { text: 'Assumed Hostile Spying activity', correct: true },
      { text: 'Assumed Hostile Espionage installation', correct: false },
      { text: 'Assumed Hostile Sensor Point of Interest (Class Y)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.theft_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Theatre Homeland Response Force', correct: false },
      { text: 'Hostile Tactical Hostile Fire event', correct: false },
      { text: 'Hostile Theft activity', correct: true },
      { text: 'Hostile Tactical High Frequency activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.smuggling_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Specialized Medical Government Leased equipment', correct: false },
      { text: 'Hostile Strategic Mobile Ground Liaison', correct: false },
      { text: 'Hostile Specialized Meteorological Geospatial Laboratory', correct: false },
      { text: 'Hostile Smuggling activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.sabotage_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Sabotage activity', correct: true },
      { text: 'Beastie Boys', correct: false },
      { text: 'Hostile Sabot ammunition cache', correct: false },
      { text: 'Hostile Security Assistance Battalion', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.meeting_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Military Training Group', correct: false },
      { text: 'Hostile Meeting activity', correct: true },
      { text: 'Hostile Mobile Training Group', correct: false },
      { text: 'Hostile Mission Tasking Group', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MISO_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Satellite', correct: false },
      { text: 'Hostile TOW Missile Launcher', correct: false },
      { text: 'Hostile Psychological Operations activity', correct: true },
      { text: 'Hostile Jet Propulsion equipment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.school_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Friendly School Installation', correct: false },
      { text: 'Friendly Captured Territory', correct: false },
      { text: 'Friendly Observation Post', correct: false },
      { text: 'Friendly School activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.UXO_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Assumed Hostile Unexploded Ordnance activity', correct: true },
      { text: 'Assumed Hostile Unexploded Ordnance cache', correct: false },
      { text: 'Assumed Hostile Unexploded Ordnance facility', correct: false },
      { text: 'Assumed Hostile Unexploded Ordnance Unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.triage_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Pending Hospital Installation', correct: false },
      { text: 'Pending Triage activity', correct: true },
      { text: 'Pending EMS equipment', correct: false },
      { text: 'Unknown EMS equipment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.warrant_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Assumed Hostile Warzone Navigation Team', correct: false },
      { text: 'Assumed Hostile Wideband Network activity', correct: false },
      { text: 'Assumed Hostile Warrant Served activity', correct: true },
      { text: 'Hostile Wideband Network', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.assassinationVictim.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile Assassination victim activity', correct: true },
      { text: 'Hostile leadership assistance activity', correct: false },
      { text: 'Hostile Aerial Strike victim activity', correct: false },
      { text: 'Hostile Leadership Assistance unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.execution_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Hostile leadership exercise activity', correct: false },
      { text: 'Hostile execution victim activity', correct: true },
      { text: 'Hostile exercise victim activity', correct: false },
      { text: 'Hostile Leadership exercise unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.individual_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Lost Lieutenant', correct: false },
      { text: 'Hostile Downed Pilot', correct: false },
      { text: 'Hostile Individual activity', correct: true },
      { text: 'Hostile Leadership unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.isolatedPersonnelActivity.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Faker Downed Pilot', correct: false },
      { text: 'Pending Isolated Personnel activity', correct: true },
      { text: 'Feint Downed Pilot', correct: false },
      { text: 'Hostile Isolated Personnel unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ISF_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity',
    answers: [
      { text: 'Neutral Intergalactic Space Force activity', correct: false },
      { text: 'Neutral International Security Force activity', correct: false },
      { text: 'Neutral Internal Security Force activity', correct: true },
      { text: 'Neutral Internal Security Force unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.murderVictim_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a Criminal Activities Victim and the Sector 1 modifier denotes a murder.',
    answers: [
      { text: 'Hostile Leadership Execution', correct: false },
      { text: 'No Personnel Allowed', correct: false },
      { text: 'No-Go Zone', correct: false },
      { text: 'Hostile Murder Victim activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fireArson_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a fire and the Sector 1 modifier denotes an arson.',
    answers: [
      { text: 'Hostile Arson activity', correct: true },
      { text: 'Fire event', correct: false },
      { text: 'Hostile Assassination activity', correct: false },
      { text: 'Forest fire', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.hijacking_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a civilian vehicle and the Sector 1 modifier denotes an hijacking.',
    answers: [
      { text: 'Hostile heavy vehicle', correct: false },
      { text: 'Hostile Hijacking (vehicle) activity', correct: true },
      { text: 'Hostile High mobility vehicle', correct: false },
      { text: 'Hostile Commercial vehicle (heavy)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.LAB_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents illegal drug activity and the Sector 1 modifier denotes an laboratory.',
    answers: [
      { text: 'Hostile Drug Laboratory unit', correct: false },
      { text: 'Hostile Drug installation', correct: false },
      { text: 'Hostile Illegal Drug Laboratory activity', correct: true },
      { text: 'Hostile Commercial vehicle (heavy)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.kidnapping_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a Criminal Activities Victim and the Sector 1 modifier denotes a kidnapping.',
    answers: [
      { text: 'Hostile Individual Killed', correct: false },
      { text: 'Hostile Criminal Victim killed', correct: false },
      { text: 'Hostile Criminal killed', correct: false },
      { text: 'Hostile Kidnapping activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.piracy_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a civilian boat and the Sector 1 modifier denotes a piracy activity.',
    answers: [
      { text: 'Hostile Piracy (boat) activity', correct: true },
      { text: 'Hostile Boat (positively identified)', correct: false },
      { text: 'Hostile Boat (possibly incapacitated)', correct: false },
      { text: 'Hostile Boat facility (port)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rape_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a Criminal Activities Victim and the Sector 1 modifier denotes a rape.',
    answers: [
      { text: 'Hostile Radiological Poisoning activity', correct: false },
      { text: 'Hostile Rape activity', correct: true },
      { text: 'Hostile Criminal Response Action', correct: false },
      { text: 'Hostile Victim killed by Rocket Artillery', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.DT_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a illegal Drug activity and the Sector 1 modifier denotes a trafficking.',
    answers: [
      { text: 'Hostile Drug Laboratory unit', correct: false },
      { text: 'Hostile Drug installation', correct: false },
      { text: 'Hostile Drug Trafficking activity', correct: true },
      { text: 'Hostile Victim killed by Rocket Artillery', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OM_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents an organization or group and the Sector 1 modifier denotes a Meeting.',
    answers: [
      { text: 'Friendly Military Training Group unit', correct: false },
      { text: 'Friendly Mobile Training Group activity', correct: false },
      { text: 'Friendly Mission Tasking Group activity', correct: false },
      { text: 'Friendly Organizational Meeting activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bombExplosion_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents an explosion and the Sector 1 modifier denotes a bomb.',
    answers: [
      { text: 'Hostile Bomb Explosion activity', correct: true },
      { text: 'Hostile Bomb Production unit', correct: false },
      { text: 'Hostile Bomb Production facility', correct: false },
      { text: 'Hostile Ammunition Cache Explosion', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.grenadeExplosion_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents an explosion and the Sector 1 modifier denotes a grenade.',
    answers: [
      { text: 'Hostile Bomb Production unit', correct: false },
      { text: 'Hostile Grenade Explosion activity', correct: true },
      { text: 'Hostile Bomb Production facility', correct: false },
      { text: 'Hostile Grenade Cache Explosion', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.IEDExplosion_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents an explosion and the Sector 1 modifier denotes a bomb.',
    answers: [
      { text: 'Hostile IED Production unit', correct: false },
      { text: 'Hostile IED Production facility', correct: false },
      { text: 'Hostile IED Explosion activity', correct: true },
      { text: 'Hostile IED Cache Explosion', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mineExplosion_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents an explosion and the Sector 1 modifier denotes a mine.',
    answers: [
      { text: 'Hostile Grenade Explosion activity', correct: false },
      { text: 'Hostile Rocket Explosion activity', correct: false },
      { text: 'Hostile Mortar Explosion activity', correct: false },
      { text: 'Hostile Mine Explosion activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mortarExplosion_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents an explosion and the Sector 1 modifier denotes a mortar.',
    answers: [
      { text: 'Hostile Mortar Explosion activity', correct: true },
      { text: 'Hostile Mine Explosion activity', correct: false },
      { text: 'Hostile Grenade Explosion activity', correct: false },
      { text: 'Hostile Rocket Explosion activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rocketExplosion_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents an explosion and the Sector 1 modifier denotes a rocket.',
    answers: [
      { text: 'Hostile Mortar Explosion activity', correct: false },
      { text: 'Hostile Rocket Explosion activity', correct: true },
      { text: 'Hostile Mine Explosion activity', correct: false },
      { text: 'Hostile Grenade Explosion activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ECEP_ACT.file,
    description:
      'The black boxes in the corner of the symbol denote an activity. The base symbol represents a Emergency Operations Management and the Sector 1 modifier denotes an Emergency Collection Evacuation Point.',
    answers: [
      { text: 'Assumed Friendly Encampment of Enemy Personnel', correct: false },
      { text: 'Assumed Friendly Observation Post', correct: false },
      { text: 'Assumed Friendly Emergency Operations Collection Evacuation Point activity', correct: true },
      { text: 'Assumed Friendly Emergency Operations Management Facility', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.homeEviction_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a house or home and the Sector 1 modifier denotes an Eviction activity.',
    answers: [
      { text: 'Assumed Hostile Electric Vehicle', correct: false },
      { text: 'Assumed Hostile Environmental Greenhouse', correct: false },
      { text: 'Assumed Hostile House or Home', correct: false },
      { text: 'Assumed Hostile Home Eviction activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.foragingForFood_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents searching or foraging and the Sector 1 modifier denotes food.',
    answers: [
      { text: 'Pending Foraging for Food activity', correct: true },
      { text: 'Rough waves warning (naval)', correct: false },
      { text: 'Slippery Roads Warning', correct: false },
      { text: 'Pending searching or foraging activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.raidOnHome_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a house or home and the Sector 1 modifier denotes a raid activity.',
    answers: [
      { text: 'Pending Raid on a Home', correct: false },
      { text: 'Friendly Raid on a home activity', correct: true },
      { text: 'Friendly Environmental Greenhouse', correct: false },
      { text: 'Friendly House or Home', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bombThreat_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a bomb and the Sector 1 modifier denotes suspicious activity.',
    answers: [
      { text: 'Hostile Bomb (type unknown)', correct: false },
      { text: 'Unknown enemy bomb equipment', correct: false },
      { text: 'Hostile Bomb Threat activity', correct: true },
      { text: 'Unknown Bomb Production facility', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.gang_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a group or organization and the Sector 1 modifier denotes gang activity.',
    answers: [
      { text: 'Hostile Gang Bangers', correct: false },
      { text: 'Hostile Gang organization', correct: false },
      { text: 'Gucci Gang', correct: false },
      { text: 'Hostile Gang activity', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.PIED_ACT.file,
    description:
      'The black boxes in the corner of the symbol denote an activity. The base symbol represents an explosion. The Sector 1 modifier denotes an improvised explosive device and the Sector 2 modifier denotes Premature detonation.',
    answers: [
      { text: 'Hostile Premature IED Explosion', correct: true },
      { text: 'Hostile Planned IED Explosion', correct: false },
      { text: 'Hostile IED facility', correct: false },
      { text: 'Hostile IED Explosion (Class P)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.DBS_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a shooting and the Sector 2 modifier denotes an limited cross country vehicle.',
    answers: [
      { text: 'Hostile Arms Manufacturing facility', correct: false },
      { text: 'Hostile Drive By Shooting activity', correct: true },
      { text: 'Hostile Arms transportation via wheeled vehicles', correct: false },
      { text: 'Hostile Small Arms Guerilla unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.BPCR_ACT.file,
    description: 'The black boxes in the corner of the symbol denote an activity. The base symbol represents a Border Patrol and the Sector 2 modifier denotes a Coerced Recruitment activity.',
    answers: [
      { text: 'Hostile Road Construction', correct: false },
      { text: 'Hostile Traffic Control Point activity', correct: false },
      { text: 'Hostile Border Patrol Coerced Recruitment Activity', correct: true },
      { text: 'Hostile Traffic Control Point (Civil Reconnaissance)', correct: false },
    ],
  },
  // ? Installations
  {
    question: 'What is this symbol?',
    symbolSVG: mso.APAF.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Assumed Hostile aircraft unit', correct: false },
      { text: 'Assumed Hostile Aircraft equipment', correct: false },
      { text: 'Assumed Hostile Aircraft Production and Assembly Facility', correct: true },
      { text: 'Hostile Aircraft', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.grenadeCache.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Assumed Hostile grenade equipment ', correct: false },
      { text: 'Hostile grenade troops', correct: false },
      { text: 'Hostile grenade equipment', correct: false },
      { text: 'Hostile Grenade cache', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ammoFacility.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Assumed Hostile Ammunition Facility', correct: true },
      { text: 'Assumed Hostile grenade equipment', correct: false },
      { text: 'Assumed Hostile ammunition supply specialists', correct: false },
      { text: 'Hostile Ammunition Holding Area (AHA)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airportFacility.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Unknown Air terminal', correct: false },
      { text: 'Pending Airport', correct: true },
      { text: 'Pending Airport construction unit', correct: false },
      { text: 'Pending Airport transportation unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.BPF.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Unknown Road Construction', correct: false },
      { text: 'Unknown Traffic Control Point unit', correct: false },
      { text: 'Unknown Border Patrol Facility', correct: true },
      { text: 'Pending Customs Facility', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.BTA.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Unknown Road Construction', correct: false },
      { text: 'Unknown Traffic Control Point installation', correct: false },
      { text: 'Pending Missile production Facility', correct: false },
      { text: 'Pending Broadcast Transmitter Antenna Facility', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CBRNFacility.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Hostile CBRN Facility', correct: true },
      { text: 'Hostile Mortar production installation', correct: false },
      { text: 'Hostile CBRN unit', correct: false },
      { text: 'Hostile CBRN activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CGF.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Neutral Coast Guard unit', correct: false },
      { text: 'Neutral Coast Guard Facility', correct: true },
      { text: 'Neutral Coast Guard activity', correct: false },
      { text: 'Neutral naval production facility', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CSF_IN.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Pending Garbage Collection Facility', correct: false },
      { text: 'Pending Road Construction', correct: false },
      { text: 'Pending Customs Service Facility', correct: true },
      { text: 'Pending Traffic Control Point activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.DOJ_IN.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Friendly Legal Consultant', correct: false },
      { text: 'Friendly Road Construction', correct: false },
      { text: 'Friendly Department of Justice Facility', correct: true },
      { text: 'Friendly Law Firm', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EGF.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Friendly mortar production facility', correct: false },
      { text: 'Friendly air burst artillery activity', correct: false },
      { text: 'Friendly Electric Generation Facility', correct: true },
      { text: 'Coal powered power plant', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.foodStorage_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents food and the Sector 2 modifier denotes storage.',
    answers: [
      { text: 'Friendly Class III facility', correct: false },
      { text: 'Friendly Class IV facility', correct: false },
      { text: 'Friendly Food Storage activity', correct: false },
      { text: 'Friendly Food Storage Facility', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EMOOPS_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents Emergency Operations Management and the Sector 1 modifier denotes Operations.',
    answers: [
      { text: 'Friendly Emergency Management Operations Facility', correct: true },
      { text: 'Friendly Encampment of Enemy Personnel', correct: false },
      { text: 'Friendly Observation Post', correct: false },
      { text: 'Friendly Emergency Operations Management activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EMS_IN.file,
    description: 'The black box on top of the symbol denotes an installation.',
    answers: [
      { text: 'Friendly Medical Treatment activity', correct: false },
      { text: 'Friendly EMS Facility', correct: true },
      { text: 'Friendly Firefighter facility', correct: false },
      { text: 'Friendly Law Enforcement facility', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fireFighterFacility.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Friendly Fire Fighting Installation', correct: true },
      { text: 'Friendly Law Enforcement Facility', correct: false },
      { text: 'Friendly Fire Fighting activity', correct: false },
      { text: 'Friendly food storage activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.GO_IN.file,
    description: 'The black box on top of the symbol denotes an installation.',
    answers: [
      { text: 'Neutral Government Organization activity', correct: false },
      { text: 'Neutral Garrisoned Officers', correct: false },
      { text: 'Neutral Governmental Organization Facility', correct: true },
      { text: 'Neutral General Officer', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.building_IN.file,
    description: 'The black box on top of the symbol denotes an installation.',
    answers: [
      { text: 'Friendly Government building', correct: false },
      { text: 'Friendly Electric Power Generation facility', correct: false },
      { text: 'Friendly Steam engine train', correct: false },
      { text: 'Friendly Industrial Building', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.law_IN.file,
    description: 'The black box on top of the symbol denotes an installation.',
    answers: [
      { text: 'Neutral Law Enforcement Agency Building', correct: true },
      { text: 'Neutral EMS facility', correct: false },
      { text: 'Neutral Fire Fighting activity', correct: false },
      { text: 'Neutral food storage activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MTF_IN.file,
    description: 'The black box on top of the symbol denotes an installation.',
    answers: [
      { text: 'Friendly Naval unit', correct: false },
      { text: 'Friendly Maritime Terminal Facility', correct: true },
      { text: 'Friendly Sea sub-surface unit', correct: false },
      { text: 'Assumed Friendly Naval Facility', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.massGrave_IN.file,
    description: 'The black box on top of the symbol denotes an installation.',
    answers: [
      { text: 'Hostile Artillery Bracketing activity', correct: false },
      { text: 'Hostile Target Acquisition System', correct: false },
      { text: 'Hostile Mass Grave Facility', correct: true },
      { text: 'Hostile Multiple Rocket Launcher battery', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.hospital_IN.file,
    description: 'The black box on top of the symbol denotes an installation.',
    answers: [
      { text: 'Friendly Artillery Bracketing activity', correct: false },
      { text: 'Friendly Target Acquisition System', correct: false },
      { text: 'Friendly Target Reference Point', correct: false },
      { text: 'Friendly Medical Treatment Facility', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rawMaterialMine_IN.file,
    description: 'The black box on top of the symbol denotes an installation.',
    answers: [
      { text: 'Assumed Friendly Raw Material Mine', correct: true },
      { text: 'Assumed Friendly Sapper unit', correct: false },
      { text: 'Assumed Friendly Vertical Engineers unit', correct: false },
      { text: 'Assumed Friendly Mining activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.PMF.file,
    description: 'The black box on top of the symbol denotes an installation',
    answers: [
      { text: 'Unknown Mortar production facility', correct: false },
      { text: 'Unknown Print Media Center', correct: true },
      { text: 'Unknown highway onramp installation', correct: false },
      { text: 'Unknown route', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CBRNDECON_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents CBRN and the Sector 1 Modifier denotes decontamination',
    answers: [
      { text: 'Neutral Indirect fire production facility', correct: false },
      { text: 'Neutral Direct fire production facility', correct: false },
      { text: 'Neutral Decontamination Facility', correct: true },
      { text: 'Neutral CBRN Decontamination unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EGCPF_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents a power plant and the Sector 1 Modifier denotes coal',
    answers: [
      { text: 'Unknown Combat Operations Electric Power Plant', correct: false },
      { text: 'Unknown Contingency Operations Electric Power Plant', correct: false },
      { text: 'Unknown Cyberspace Operations', correct: false },
      { text: 'Unknown Electric Generation Coal Powered Facility', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.college_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents a school or university and the Sector 1 Modifier denotes a college',
    answers: [
      { text: 'Assumed Friendly College Campus', correct: true },
      { text: 'Assumed Friendly Concept of Logistics center', correct: false },
      { text: 'Assumed Friendly Chief of Logistics', correct: false },
      { text: 'Assumed Friendly Combat Operations Line', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.DPRE_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents a tented camp and the Sector 1 Modifier denotes Displaced Persons/Refugees/Evacuees.',
    answers: [
      { text: 'Unknown Tented facility', correct: false },
      { text: 'Unknown Displaced persons, refugees, or evacuees tented camp facility', correct: true },
      { text: 'Unknown Defense Planning Retrograde Event', correct: false },
      { text: 'Unknown Decontamination of Persistent Radiological Environment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EGGT_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents an electric power plant and the Sector 1 Modifier denotes Geothermal.',
    answers: [
      { text: 'Unknown Gun Target Line', correct: false },
      { text: 'Unknown Global Transportation facility', correct: false },
      { text: 'Unknown Electric Generation Geothermal Powered Facility', correct: true },
      { text: 'Unknown Garrison Theatre Electric Power Plant', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.EGPOL_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents an electric power plant and the Sector 1 Modifier denotes Petroleum.',
    answers: [
      { text: 'Unknown Geospatial Intelligence facility', correct: false },
      { text: 'Unknown Global Transportation facility', correct: false },
      { text: 'Unknown Garrison Theatre Electric Power Plant', correct: false },
      { text: 'Unknown Electric Generation Petroleum Powered Facility', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.policeTraining_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents a police department and the Sector 1 Modifier denotes Training.',
    answers: [
      { text: 'Friendly Police Training Facility', correct: true },
      { text: 'Friendly Police Training Activity', correct: false },
      { text: 'Friendly Law Enforcement unit', correct: false },
      { text: 'Friendly Law Enforcement activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.APF_IN.file,
    description: 'The black box on top of the symbol denotes an installation. The base symbol represents ordnance and the Sector 2 Modifier denotes Production.',
    answers: [
      { text: 'Friendly Ammunition Production Activity', correct: false },
      { text: 'Friendly Ammunition Production Facility', correct: true },
      { text: 'Friendly Ordnance unit', correct: false },
      { text: 'Friendly Ammunition unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SRF_IN.file,
    description:
      'The black box on top of the symbol denotes an installation. The base symbol represents naval unit. The Sector 1 modifier denotes a yard and the Sector 2 Modifier denotes repair capabilities.',
    answers: [
      { text: 'Hostile Naval Unit', correct: false },
      { text: 'Hostile Naval unit with organic maintenance capabilities', correct: false },
      { text: 'Hostile Shipyard Repair Facility', correct: true },
      { text: 'Hostile Shipyard Repair activity', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TTSF_IN.file,
    description:
      'The black box on top of the symbol denotes an installation. The base symbol represents telecommunications. The Sector 1 modifier denotes telephone and the Sector 2 Modifier denotes service capabilities.',
    answers: [
      { text: 'Neutral Telecommunications Radio facility', correct: false },
      { text: 'Neutral Signal service installation', correct: false },
      { text: 'Neutral Telephone facility', correct: false },
      { text: 'Neutral Telecommunications Telephone Service Facility', correct: true },
    ],
  },
  // ? Equipment
  {
    question: 'What is this symbol?',
    symbolSVG: mso.unspecifiedWeapon.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Friendly rifle', correct: false },
      { text: 'Friendly flamethrower', correct: false },
      { text: 'Friendly Unspecified weapon', correct: true },
      { text: 'Friendly route', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.flameThrower.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Assumed Friendly rifle', correct: false },
      { text: 'Assumed Friendly Unspecified weapon', correct: false },
      { text: 'Assumed Friendly route', correct: false },
      { text: 'Assumed Friendly flamethrower', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.GLG.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Friendly Grenade Launcher (long range)', correct: false },
      { text: 'Friendly Grenade Launcher (medium range)', correct: false },
      { text: 'Friendly Grenade Launcher (short range)', correct: false },
      { text: 'Friendly Grenade Launcher (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.GLSR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Unknown Grenade Launcher (short range)', correct: true },
      { text: 'Unknown Grenade Launcher (long range)', correct: false },
      { text: 'Unknown Grenade Launcher (medium range)', correct: false },
      { text: 'Unknown Grenade Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.GLMR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Grenade Launcher (short range)', correct: false },
      { text: 'Friendly Grenade Launcher (medium range)', correct: true },
      { text: 'Friendly Grenade Launcher (long range)', correct: false },
      { text: 'Friendly Grenade Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.GLLR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Grenade Launcher (short range)', correct: false },
      { text: 'Friendly Grenade Launcher (medium range)', correct: false },
      { text: 'Friendly Grenade Launcher (long range)', correct: true },
      { text: 'Friendly Grenade Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ADGG.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Neutral Air Defense Gun (short range)', correct: false },
      { text: 'Neutral Air Defense Gun (medium range)', correct: false },
      { text: 'Neutral Air Defense Gun (long range)', correct: false },
      { text: 'Neutral Air Defense Gun (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ADGSR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Air Defense Gun (short range)', correct: true },
      { text: 'Friendly Air Defense Gun (medium range)', correct: false },
      { text: 'Friendly Air Defense Gun (long range)', correct: false },
      { text: 'Friendly Air Defense Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ADGMR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Assumed Hostile Air Defense Gun (short range)', correct: false },
      { text: 'Assumed Hostile Air Defense Gun (medium range)', correct: true },
      { text: 'Assumed Hostile Air Defense Gun (long range)', correct: false },
      { text: 'Assumed Hostile Air Defense Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airDefenseGun_LR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Unknown Air Defense Gun (short range)', correct: false },
      { text: 'Unknown Air Defense Gun (medium range)', correct: false },
      { text: 'Unknown Air Defense Gun (long range)', correct: true },
      { text: 'Unknown Air Defense Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATGG.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Unknown Antitank Gun (light)', correct: false },
      { text: 'Unknown Antitank Gun (medium)', correct: false },
      { text: 'Unknown Antitank Gun (heavy)', correct: false },
      { text: 'Unknown Antitank Gun (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATGL.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Hostile Antitank Gun (light)', correct: true },
      { text: 'Hostile Antitank Gun (medium)', correct: false },
      { text: 'Hostile Antitank Gun (heavy)', correct: false },
      { text: 'Hostile Antitank Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATGM.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Neutral Antitank Gun (light)', correct: false },
      { text: 'Neutral Antitank Gun (medium)', correct: true },
      { text: 'Neutral Antitank Gun (heavy)', correct: false },
      { text: 'Neutral Antitank Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATGH.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Antitank Gun (light)', correct: false },
      { text: 'Friendly Antitank Gun (medium)', correct: false },
      { text: 'Friendly Antitank Gun (heavy)', correct: true },
      { text: 'Friendly Antitank Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.DFGG.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Unknown Direct Fire Gun (light)', correct: false },
      { text: 'Unknown Direct Fire Gun (medium)', correct: false },
      { text: 'Unknown Direct Fire Gun (heavy)', correct: false },
      { text: 'Unknown Direct Fire Gun (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.DFGL.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Assumed Hostile Direct Fire Gun (light)', correct: true },
      { text: 'Assumed Hostile Direct Fire Gun (medium)', correct: false },
      { text: 'Assumed Hostile Direct Fire Gun (heavy)', correct: false },
      { text: 'Assumed Hostile Direct Fire Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.DFGM.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Assumed Friendly Direct Fire Gun (light)', correct: false },
      { text: 'Assumed Friendly Direct Fire Gun (medium)', correct: true },
      { text: 'Assumed Friendly Direct Fire Gun (heavy)', correct: false },
      { text: 'Assumed Friendly Direct Fire Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.DFGH.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Unknown Direct Fire Gun (light)', correct: false },
      { text: 'Unknown Direct Fire Gun (medium)', correct: false },
      { text: 'Unknown Direct Fire Gun (heavy)', correct: true },
      { text: 'Unknown Direct Fire Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HOWITZERG.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Hostile Howitzer - 120 millimeters or less', correct: false },
      { text: 'Hostile Howitzer - Greater than 120 millimeters but less than 160 millimeters', correct: false },
      { text: 'Hostile Howitzer - Greater than 160 millimeters but less than 210 millimeters', correct: false },
      { text: 'Hostile Howitzer (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HOWITZERL.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Assumed Hostile Howitzer - 120 millimeters or less', correct: true },
      { text: 'Assumed Hostile Howitzer - Greater than 120 millimeters but less than 160 millimeters', correct: false },
      { text: 'Assumed Hostile Howitzer - Greater than 160 millimeters but less than 210 millimeters', correct: false },
      { text: 'Assumed Hostile Howitzer - Greater than 210 millimeters and very heavy', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HOWITZERM.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Howitzer - 120 millimeters or less', correct: false },
      { text: 'Friendly Howitzer - Greater than 120 millimeters but less than 160 millimeters', correct: true },
      { text: 'Friendly Howitzer - Greater than 160 millimeters but less than 210 millimeters', correct: false },
      { text: 'Friendly Howitzer - Greater than 210 millimeters and very heavy', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HOWITZERH.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Howitzer - 120 millimeters or less', correct: false },
      { text: 'Friendly Howitzer - Greater than 120 millimeters but less than 160 millimeters', correct: false },
      { text: 'Friendly Howitzer - Greater than 160 millimeters but less than 210 millimeters', correct: true },
      { text: 'Friendly Howitzer - Greater than 210 millimeters and very heavy', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HOWITZERVH.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Howitzer - 120 millimeters or less', correct: false },
      { text: 'Friendly Howitzer - Greater than 120 millimeters but less than 160 millimeters', correct: false },
      { text: 'Friendly Howitzer - Greater than 160 millimeters but less than 210 millimeters', correct: false },
      { text: 'Friendly Howitzer - Greater than 210 millimeters and very heavy', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mortar_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Neutral Mortar - 60 millimeters or less', correct: false },
      { text: 'Neutral Mortar - Greater than 60 millimeters but less than 107 millimeters', correct: false },
      { text: 'Neutral Mortar - Greater than 107 millimeters', correct: false },
      { text: 'Neutral Mortar (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mortar_L.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Neutral Mortar - 60 millimeters or less', correct: true },
      { text: 'Neutral Mortar - Greater than 60 millimeters but less than 107 millimeters', correct: false },
      { text: 'Neutral Mortar - Greater than 107 millimeters', correct: false },
      { text: 'Neutral Mortar (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mortar_M.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Hostile Mortar - 60 millimeters or less', correct: false },
      { text: 'Hostile Mortar - Greater than 60 millimeters but less than 107 millimeters', correct: true },
      { text: 'Hostile Mortar - Greater than 107 millimeters', correct: false },
      { text: 'Hostile Mortar (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mortar_H.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Assumed Friendly Mortar - 60 millimeters or less', correct: false },
      { text: 'Assumed Friendly Mortar - Greater than 60 millimeters but less than 107 millimeters', correct: false },
      { text: 'Assumed Friendly Mortar - Greater than 107 millimeters', correct: true },
      { text: 'Assumed Friendly Mortar (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.recoiless_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Recoiless Gun (light)', correct: false },
      { text: 'Friendly Recoiless Gun (medium)', correct: false },
      { text: 'Friendly Recoiless Gun (heavy)', correct: false },
      { text: 'Friendly Recoiless Gun (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.recoiless_L.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Unknown Recoiless Gun (light)', correct: true },
      { text: 'Unknown Recoiless Gun (medium)', correct: false },
      { text: 'Unknown Recoiless Gun (heavy)', correct: false },
      { text: 'Unknown Recoiless Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.recoiless_M.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Pending Recoiless Gun (light)', correct: false },
      { text: 'Pending Recoiless Gun (medium)', correct: true },
      { text: 'Pending Recoiless Gun (heavy)', correct: false },
      { text: 'Pending Recoiless Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.recoiless_H.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Hostile Recoiless Gun (light)', correct: false },
      { text: 'Hostile Recoiless Gun (medium)', correct: false },
      { text: 'Hostile Recoiless Gun (heavy)', correct: true },
      { text: 'Hostile Recoiless Gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rifle_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Assumed Hostile Rifle (single shot)', correct: false },
      { text: 'Assumed Hostile Rifle (semi-automatic)', correct: false },
      { text: 'Assumed Hostile Rifle (automatic)', correct: false },
      { text: 'Assumed Hostile Rifle (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rifle_L.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Unknown Rifle (single shot)', correct: true },
      { text: 'Unknown Rifle (semi-automatic)', correct: false },
      { text: 'Unknown Rifle (automatic)', correct: false },
      { text: 'Unknown Rifle (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rifle_M.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Rifle (single shot)', correct: false },
      { text: 'Friendly Rifle (semi-automatic)', correct: true },
      { text: 'Friendly Rifle (automatic)', correct: false },
      { text: 'Friendly Rifle (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rifle_H.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Unknown Rifle (single shot)', correct: false },
      { text: 'Unknown Rifle (semi-automatic)', correct: false },
      { text: 'Unknown Rifle (automatic)', correct: true },
      { text: 'Unknown Rifle (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MG_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Friendly Machine gun (light)', correct: false },
      { text: 'Friendly Machine gun (medium)', correct: false },
      { text: 'Friendly Machine gun (heavy)', correct: false },
      { text: 'Friendly Machine gun (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MG_L.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Hostile Machine gun (light)', correct: true },
      { text: 'Hostile Machine gun (medium)', correct: false },
      { text: 'Hostile Machine gun (heavy)', correct: false },
      { text: 'Hostile Machine gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MG_M.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Hostile Machine gun (light)', correct: false },
      { text: 'Hostile Machine gun (medium)', correct: true },
      { text: 'Hostile Machine gun (heavy)', correct: false },
      { text: 'Hostile Machine gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MG_H.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). ',
    answers: [
      { text: 'Hostile Machine gun (light)', correct: false },
      { text: 'Hostile Machine gun (medium)', correct: false },
      { text: 'Hostile Machine gun (heavy)', correct: true },
      { text: 'Hostile Machine gun (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ML_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the dome covering most or the entire shaft similar to the unit icon indicates that it is a missile launcher. ',
    answers: [
      { text: 'Assumed Friendly Missile Launcher (short range)', correct: false },
      { text: 'Assumed Friendly Missile Launcher (medium range)', correct: false },
      { text: 'Assumed Friendly Missile Launcher (long range)', correct: false },
      { text: 'Assumed Friendly Missile Launcher (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ML_SR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the dome covering most or the entire shaft similar to the unit icon indicates that it is a missile launcher. ',
    answers: [
      { text: 'Friendly Missile Launcher (short range)', correct: true },
      { text: 'Friendly Missile Launcher (medium range)', correct: false },
      { text: 'Friendly Missile Launcher (long range)', correct: false },
      { text: 'Friendly Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ML_ML.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the dome covering most or the entire shaft similar to the unit icon indicates that it is a missile launcher. ',
    answers: [
      { text: 'Assumed Friendly Missile Launcher (short range)', correct: false },
      { text: 'Assumed Friendly Missile Launcher (medium range)', correct: true },
      { text: 'Assumed Friendly Missile Launcher (long range)', correct: false },
      { text: 'Assumed Friendly Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ML_LR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the dome covering most or the entire shaft similar to the unit icon indicates that it is a missile launcher. ',
    answers: [
      { text: 'Friendly Missile Launcher (short range)', correct: false },
      { text: 'Friendly Missile Launcher (medium range)', correct: false },
      { text: 'Friendly Missile Launcher (long range)', correct: true },
      { text: 'Friendly Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ADML_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: Air defense missile launcher or surface to air missile launcher. ',
    answers: [
      { text: 'Friendly Air Defense Missile Launcher (short range)', correct: false },
      { text: 'Friendly Air Defense Missile Launcher (medium range)', correct: false },
      { text: 'Friendly Air Defense Missile Launcher (long range)', correct: false },
      { text: 'Friendly Air Defense Missile Launcher (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ADML_SR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: Air defense missile launcher or surface to air missile launcher. ',
    answers: [
      { text: 'Friendly Air Defense Missile Launcher (short range)', correct: true },
      { text: 'Friendly Air Defense Missile Launcher (medium range)', correct: false },
      { text: 'Friendly Air Defense Missile Launcher (long range)', correct: false },
      { text: 'Friendly Air Defense Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airDefenseML_MR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: Air defense missile launcher or surface to air missile launcher. ',
    answers: [
      { text: 'Hostile Air Defense Missile Launcher (short range)', correct: false },
      { text: 'Hostile Air Defense Missile Launcher (medium range)', correct: true },
      { text: 'Hostile Air Defense Missile Launcher (long range)', correct: false },
      { text: 'Hostile Air Defense Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ADML_LR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: Air defense missile launcher or surface to air missile launcher. ',
    answers: [
      { text: 'Unknown Air Defense Missile Launcher (short range)', correct: false },
      { text: 'Unknown Air Defense Missile Launcher (medium range)', correct: false },
      { text: 'Unknown Air Defense Missile Launcher (long range)', correct: true },
      { text: 'Unknown Air Defense Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATML_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the inverted V similar to the unit icon at the base of the shaft indicates that it is primarily an anti-tank weapon.',
    answers: [
      { text: 'Friendly Antitank Missile Launcher (short range)', correct: false },
      { text: 'Friendly Antitank Missile Launcher (medium range)', correct: false },
      { text: 'Friendly Antitank Missile Launcher (long range)', correct: false },
      { text: 'Friendly Antitank Missile Launcher (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATML_SR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the inverted V similar to the unit icon at the base of the shaft indicates that it is primarily an anti-tank weapon.',
    answers: [
      { text: 'Friendly Antitank Missile Launcher (short range)', correct: true },
      { text: 'Friendly Antitank Missile Launcher (medium range)', correct: false },
      { text: 'Friendly Antitank Missile Launcher (long range)', correct: false },
      { text: 'Friendly Antitank Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATML_MR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the inverted V similar to the unit icon at the base of the shaft indicates that it is primarily an anti-tank weapon.',
    answers: [
      { text: 'Unknown Antitank Missile Launcher (short range)', correct: false },
      { text: 'Unknown Antitank Missile Launcher (medium range)', correct: true },
      { text: 'Unknown Antitank Missile Launcher (long range)', correct: false },
      { text: 'Unknown Antitank Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATML_LR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the inverted V similar to the unit icon at the base of the shaft indicates that it is primarily an anti-tank weapon.',
    answers: [
      { text: 'Unknown Antitank Missile Launcher (short range)', correct: false },
      { text: 'Unknown Antitank Missile Launcher (medium range)', correct: false },
      { text: 'Unknown Antitank Missile Launcher (long range)', correct: true },
      { text: 'Unknown Antitank Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SSML_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the dome covering most or the entire shaft similar to the unit icon indicates that it is a missile launcher.',
    answers: [
      { text: 'Hostile Surface to Surface Missile Launcher (short range)', correct: false },
      { text: 'Hostile Surface to Surface Missile Launcher (medium range)', correct: false },
      { text: 'Hostile Surface to Surface Missile Launcher (long range)', correct: false },
      { text: 'Hostile Surface to Surface Missile Launcher (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SSML_SR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the dome covering most or the entire shaft similar to the unit icon indicates that it is a missile launcher.',
    answers: [
      { text: 'Friendly Surface to Surface Missile Launcher (short range)', correct: true },
      { text: 'Friendly Surface to Surface Missile Launcher (medium range)', correct: false },
      { text: 'Friendly Surface to Surface Missile Launcher (long range)', correct: false },
      { text: 'Friendly Surface to Surface Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SSML_MR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the dome covering most or the entire shaft similar to the unit icon indicates that it is a missile launcher.',
    answers: [
      { text: 'Friendly Surface to Surface Missile Launcher (short range)', correct: false },
      { text: 'Friendly Surface to Surface Missile Launcher (medium range)', correct: true },
      { text: 'Friendly Surface to Surface Missile Launcher (long range)', correct: false },
      { text: 'Friendly Surface to Surface Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SSML_LR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the dome covering most or the entire shaft similar to the unit icon indicates that it is a missile launcher.',
    answers: [
      { text: 'Hostile Surface to Surface Missile Launcher (short range)', correct: false },
      { text: 'Hostile Surface to Surface Missile Launcher (medium range)', correct: false },
      { text: 'Hostile Surface to Surface Missile Launcher (long range)', correct: true },
      { text: 'Hostile Surface to Surface Missile Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATRL_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the inverted V similar to the unit icon at the base of the shaft indicates that it is primarily an anti-tank weapon.',
    answers: [
      { text: 'Friendly Antitank Rocket Launcher (short range)', correct: false },
      { text: 'Friendly Antitank Rocket Launcher (medium range)', correct: false },
      { text: 'Friendly Antitank Rocket Launcher (long range)', correct: false },
      { text: 'Friendly Antitank Rocket Launcher (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATRL_SR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the inverted V similar to the unit icon at the base of the shaft indicates that it is primarily an anti-tank weapon.',
    answers: [
      { text: 'Pending Antitank Rocket Launcher (short range)', correct: true },
      { text: 'Pending Antitank Rocket Launcher (medium range)', correct: false },
      { text: 'Pending Antitank Rocket Launcher (long range)', correct: false },
      { text: 'Pending Antitank Rocket Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATRL_MR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the inverted V similar to the unit icon at the base of the shaft indicates that it is primarily an anti-tank weapon.',
    answers: [
      { text: 'Pending Antitank Rocket Launcher (short range)', correct: false },
      { text: 'Pending Antitank Rocket Launcher (medium range)', correct: true },
      { text: 'Pending Antitank Rocket Launcher (long range)', correct: false },
      { text: 'Pending Antitank Rocket Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATRL_LR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the inverted V similar to the unit icon at the base of the shaft indicates that it is primarily an anti-tank weapon.',
    answers: [
      { text: 'Unknown Antitank Rocket Launcher (short range)', correct: false },
      { text: 'Unknown Antitank Rocket Launcher (medium range)', correct: false },
      { text: 'Unknown Antitank Rocket Launcher (long range)', correct: true },
      { text: 'Unknown Antitank Rocket Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SRL_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the double inverted V’s similar to the multiple rocket launcher unit icon indicates that it is a rocket launcher.',
    answers: [
      { text: 'Friendly Single Rocket Launcher (short range)', correct: false },
      { text: 'Friendly Single Rocket Launcher (medium range)', correct: false },
      { text: 'Friendly Single Rocket Launcher (long range)', correct: false },
      { text: 'Friendly Single Rocket Launcher (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SRL_SR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the double inverted V’s similar to the multiple rocket launcher unit icon indicates that it is a rocket launcher.',
    answers: [
      { text: 'Hostile Single Rocket Launcher (short range)', correct: true },
      { text: 'Hostile Single Rocket Launcher (medium range)', correct: false },
      { text: 'Hostile Single Rocket Launcher (long range)', correct: false },
      { text: 'Hostile Single Rocket Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SRL_MR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the double inverted V’s similar to the multiple rocket launcher unit icon indicates that it is a rocket launcher.',
    answers: [
      { text: 'Unknown Single Rocket Launcher (short range)', correct: false },
      { text: 'Unknown Single Rocket Launcher (medium range)', correct: true },
      { text: 'Unknown Single Rocket Launcher (long range)', correct: false },
      { text: 'Unknown Single Rocket Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SRL_LR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the double inverted V’s similar to the multiple rocket launcher unit icon indicates that it is a rocket launcher.',
    answers: [
      { text: 'Friendly Single Rocket Launcher (short range)', correct: false },
      { text: 'Friendly Single Rocket Launcher (medium range)', correct: false },
      { text: 'Friendly Single Rocket Launcher (long range)', correct: true },
      { text: 'Friendly Single Rocket Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MRL_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the double inverted V’s similar to the multiple rocket launcher unit icon indicates that it is a rocket launcher.',
    answers: [
      { text: 'Friendly Multiple Rocket Launcher (short range)', correct: false },
      { text: 'Friendly Multiple Rocket Launcher (medium range)', correct: false },
      { text: 'Friendly Multiple Rocket Launcher (long range)', correct: false },
      { text: 'Friendly Multiple Rocket Launcher (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MRL_SR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the double inverted V’s similar to the multiple rocket launcher unit icon indicates that it is a rocket launcher.',
    answers: [
      { text: 'Hostile Multiple Rocket Launcher (short range)', correct: true },
      { text: 'Hostile Multiple Rocket Launcher (medium range)', correct: false },
      { text: 'Hostile Multiple Rocket Launcher (long range)', correct: false },
      { text: 'Hostile Multiple Rocket Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MRL_MR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the double inverted V’s similar to the multiple rocket launcher unit icon indicates that it is a rocket launcher.',
    answers: [
      { text: 'Assumed Friendly Multiple Rocket Launcher (short range)', correct: false },
      { text: 'Assumed Friendly Multiple Rocket Launcher (medium range)', correct: true },
      { text: 'Assumed Friendly Multiple Rocket Launcher (long range)', correct: false },
      { text: 'Assumed Friendly Multiple Rocket Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MRL_LR.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: The use of the double inverted V’s similar to the multiple rocket launcher unit icon indicates that it is a rocket launcher.',
    answers: [
      { text: 'Neutral Multiple Rocket Launcher (short range)', correct: false },
      { text: 'Neutral Multiple Rocket Launcher (medium range)', correct: false },
      { text: 'Neutral Multiple Rocket Launcher (long range)', correct: true },
      { text: 'Neutral Multiple Rocket Launcher (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.nonLethal.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Friendly single rocket launcher (generic)', correct: false },
      { text: 'Friendly rifle (single shot)', correct: false },
      { text: 'Friendly crossroads intersection', correct: false },
      { text: 'Friendly Non-Lethal Weapon', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.taser.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Neutral Non-Lethal Weapon (taser)', correct: true },
      { text: 'Neutral single rocket launcher (generic)', correct: false },
      { text: 'Neutral rifle (single shot)', correct: false },
      { text: 'Neutral crossroads intersection', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.waterCannon.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Neutral single rocket launcher (generic)', correct: false },
      { text: 'Neutral Non-Lethal Weapon (water cannon)', correct: true },
      { text: 'Neutral rifle (single shot)', correct: false },
      { text: 'Neutral crossroads intersection', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.armoredFightingVehicle.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Friendly Armored Tractor', correct: false },
      { text: 'Friendly Armored Protected Vehicle', correct: false },
      { text: 'Friendly Armored Fighting Vehicle', correct: true },
      { text: 'Friendly Armored Personnel Carrier', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.armoredPersonnelCarrier.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Hostile Armored Tractor', correct: false },
      { text: 'Hostile Armored Protected Vehicle', correct: false },
      { text: 'Hostile Armored Fighting Vehicle', correct: false },
      { text: 'Hostile Armored Personnel Carrier', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.armoredProtectedVehicle.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Hostile Armored Tractor', correct: false },
      { text: 'Hostile Armored Protected Vehicle', correct: true },
      { text: 'Hostile Armored Fighting Vehicle', correct: false },
      { text: 'Hostile Armored Personnel Carrier', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.tank_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: This vehicle symbol construct indicates size by using the same method as weapon systems symbols. Size is indicated by a vertical line or lines within the icon. A tank equipment icon with no vertical line represents a basic (or generic) tank.',
    answers: [
      { text: 'Assumed Hostile Tank (light)', correct: false },
      { text: 'Assumed Hostile Tank (medium)', correct: false },
      { text: 'Assumed Hostile Tank (heavy)', correct: false },
      { text: 'Assumed Hostile Tank (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.tank_L.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: This vehicle symbol construct indicates size by using the same method as weapon systems symbols. Size is indicated by a vertical line or lines within the icon. A tank equipment icon with one vertical line represents a light tank.',
    answers: [
      { text: 'Assumed Friendly Tank (light)', correct: true },
      { text: 'Assumed Friendly Tank (medium)', correct: false },
      { text: 'Assumed Friendly Tank (heavy)', correct: false },
      { text: 'Assumed Friendly Tank (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.tank_M.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: This vehicle symbol construct indicates size by using the same method as weapon systems symbols. Size is indicated by a vertical line or lines within the icon. A tank equipment icon with two vertical lines represents a medium tank.',
    answers: [
      { text: 'Assumed Hostile Tank (light)', correct: false },
      { text: 'Assumed Hostile Tank (medium)', correct: true },
      { text: 'Assumed Hostile Tank (heavy)', correct: false },
      { text: 'Assumed Hostile Tank (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.tank_H.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc). Note: This vehicle symbol construct indicates size by using the same method as weapon systems symbols. Size is indicated by a vertical line or lines within the icon. A tank equipment icon with three vertical line represents a heavy tank.',
    answers: [
      { text: 'Hostile Tank (light)', correct: false },
      { text: 'Hostile Tank (medium)', correct: false },
      { text: 'Hostile Tank (heavy)', correct: true },
      { text: 'Hostile Tank (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.trainOrLocomotive.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Pending Flatbed Railway Car', correct: false },
      { text: 'Pending Railway Boxcar', correct: false },
      { text: 'Pending Vehicle', correct: false },
      { text: 'Pending Train or Locomotive', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.flatbedRailwayCar.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Hostile Flatbed Railway Car', correct: true },
      { text: 'Hostile Railway Boxcar', correct: false },
      { text: 'Hostile Vehicle', correct: false },
      { text: 'Hostile Train or Locomotive', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.railwayBoxcar.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Neutral Flatbed Railway Car', correct: false },
      { text: 'Neutral Railway Boxcar', correct: true },
      { text: 'Neutral Vehicle', correct: false },
      { text: 'Neutral Train or Locomotive', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.vehicle.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Hostile Flatbed Railway Car', correct: false },
      { text: 'Hostile Railway Boxcar', correct: false },
      { text: 'Hostile Vehicle', correct: true },
      { text: 'Hostile Train or Locomotive', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bridge_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Assumed Hostile Fixed Bridge', correct: false },
      { text: 'Assumed Hostile Floating Girder Bridge', correct: false },
      { text: 'Assumed Hostile Hollow Deck Bridge', correct: false },
      { text: 'Assumed Hostile Bridge (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bridge_Fixed.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Unknown Fixed Bridge', correct: true },
      { text: 'Unknown Floating Girder Bridge', correct: false },
      { text: 'Unknown Hollow Deck Bridge', correct: false },
      { text: 'Unknown Bridge (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bridge_Girder.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Pending Fixed Bridge', correct: false },
      { text: 'Pending Floating Girder Bridge', correct: true },
      { text: 'Pending Hollow Deck Bridge', correct: false },
      { text: 'Pending Bridge (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bridge_Hollow.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Friendly Fixed Bridge', correct: false },
      { text: 'Friendly Floating Girder Bridge', correct: false },
      { text: 'Friendly Hollow Deck Bridge', correct: true },
      { text: 'Friendly Bridge (generic)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.drill.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Hostile Fixed Bridge', correct: false },
      { text: 'Hostile Floating Girder Bridge', correct: false },
      { text: 'Hostile Bridge (generic)', correct: false },
      { text: 'Hostile Drilling equipment', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.earthmover.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Assumed Hostile Earthmover', correct: true },
      { text: 'Assumed Hostile Fixed Bridge', correct: false },
      { text: 'Assumed Hostile Light Tank', correct: false },
      { text: 'Assumed Hostile Medium Tank', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mineClearingEq.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Assumed Hostile Fixed Bridge', correct: false },
      { text: 'Assumed Hostile Mine Clearing Equipment', correct: true },
      { text: 'Assumed Hostile Light Tank', correct: false },
      { text: 'Assumed Hostile Medium Tank', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mineLayingEq.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Hostile Artillery Explosion event', correct: false },
      { text: 'Hostile Light Tank', correct: false },
      { text: 'Hostile Mine Laying Equipment', correct: true },
      { text: 'Hostile Medium Tank', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.FWA_G.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Friendly Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Friendly Rotary-wing Aircraft (in-flight)', correct: false },
      { text: 'Friendly Fixed-wing Aircraft (in-flight)', correct: false },
      { text: 'Friendly Fixed-wing Aircraft (on-ground)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.FWA_F.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Fixed-wing Aircraft (in-flight)', correct: true },
      { text: 'Friendly Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Friendly Rotary-wing Aircraft (in-flight)', correct: false },
      { text: 'Friendly Fixed-wing Aircraft (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.FWA_IF_HOSTILE.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Hostile Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Hostile Fixed-wing Aircraft (in-flight)', correct: true },
      { text: 'Hostile Rotary-wing Aircraft (in-flight)', correct: false },
      { text: 'Hostile Fixed-wing Aircraft (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.FWA_IF_UNKNOWN.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Unknown Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Unknown Rotary-wing Aircraft (in-flight)', correct: false },
      { text: 'Unknown Fixed-wing Aircraft (in-flight)', correct: true },
      { text: 'Unknown Fixed-wing Aircraft (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.FWA_IF_NEUTRAL.file,
    description:
      'Equipment is nonexpendable items needed to outfit or equip an individual or organization. The major difference in equipment symbols is the frame for friendly equipment is a circle and equipment cannot have an echelon amplifier (e.g.- platoon, company, etc).',
    answers: [
      { text: 'Neutral Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Neutral Rotary-wing Aircraft (in-flight)', correct: false },
      { text: 'Neutral Fixed-wing Aircraft (on-ground)', correct: false },
      { text: 'Neutral Fixed-wing Aircraft (in-flight)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RWA_G.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Fixed-wing Aircraft (in-flight)', correct: false },
      { text: 'Friendly Rotary-wing Aircraft (on-ground)', correct: true },
      { text: 'Friendly Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Friendly Fixed-wing Aircraft (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RWA_F.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Fixed-wing Aircraft (in-flight)', correct: false },
      { text: 'Friendly Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Friendly Rotary-wing Aircraft (in-flight)', correct: true },
      { text: 'Friendly Rotary-wing Aircraft (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RWA_IF_HOSTILE.file,
    description: eqDesc,
    answers: [
      { text: 'Hostile Fixed-wing Aircraft (in-flight)', correct: false },
      { text: 'Hostile Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Hostile Rotary-wing Aircraft (on-ground)', correct: false },
      { text: 'Hostile Rotary-wing Aircraft (in-flight)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RWA_IF_UNKNOWN.file,
    description: eqDesc,
    answers: [
      { text: 'Unknown Rotary-wing Aircraft (in-flight)', correct: true },
      { text: 'Unknown Fixed-wing Aircraft (in-flight)', correct: false },
      { text: 'Unknown Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Unknown Rotary-wing Aircraft (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RWA_IF_NEUTRAL.file,
    description: eqDesc,
    answers: [
      { text: 'Neutral Fixed-wing Aircraft (in-flight)', correct: false },
      { text: 'Neutral Rotary-wing Aircraft (in-flight)', correct: true },
      { text: 'Neutral Unmanned Aircraft System (on-ground)', correct: false },
      { text: 'Neutral Rotary-wing Aircraft (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.UAS_G.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Fixed-wing Aircraft (in-flight)', correct: false },
      { text: 'Friendly Unmanned Aircraft System (in-flight)', correct: false },
      { text: 'Friendly Rotary-wing Aircraft (on-ground)', correct: false },
      { text: 'Friendly Unmanned Aircraft System (on-ground)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.UAS_F.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Unmanned Aircraft System (in-flight)', correct: true },
      { text: 'Friendly Fixed-wing Aircraft (in-flight)', correct: false },
      { text: 'Friendly Rotary-wing Aircraft (on-ground)', correct: false },
      { text: 'Friendly Unmanned Aircraft System (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MNCS.file,
    description: eqDesc,
    answers: [
      { text: 'Assumed Friendly Drilling Equipment', correct: false },
      { text: 'Assumed Friendly Military Non-Combatant Ship', correct: true },
      { text: 'Assumed Friendly Rotary-wing Aircraft (on-ground)', correct: false },
      { text: 'Assumed Friendly Unmanned Aircraft System (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CMS.file,
    description: eqDesc,
    answers: [
      { text: 'Assumed Friendly Drilling Equipment', correct: false },
      { text: 'Assumed Friendly Military Non-Combatant Ship', correct: false },
      { text: 'Assumed Friendly Civilian Merchant Ship', correct: true },
      { text: 'Assumed Friendly Unmanned Aircraft System (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.BTAE.file,
    description: eqDesc,
    answers: [
      { text: 'Assumed Hostile Road Construction', correct: false },
      { text: 'Assumed Hostile Traffic Control Point installation', correct: false },
      { text: 'Assumed Hostile Broadcast Transmitter Antenna Facility', correct: false },
      { text: 'Assumed Hostile Broadcast Transmitter Antenna Equipment', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CBRN_EQ.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly CBRN Equipment', correct: true },
      { text: 'Friendly CBRN unit', correct: false },
      { text: 'Friendly Mortar Equipment', correct: false },
      { text: 'Friendly Mortar Unit', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.commoSat.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Roadblock Equipment', correct: false },
      { text: 'Friendly Communications Satellite', correct: true },
      { text: 'Friendly SATCOM unit', correct: false },
      { text: 'Friendly industrial area', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.computer.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Computer', correct: false },
      { text: 'Assumed Friendly SATCOM unit', correct: false },
      { text: 'Assumed Friendly Computer', correct: true },
      { text: 'Assumed Friendly Operations Planning Board', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.laser_EQ.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly TOW Missile Launcher', correct: false },
      { text: 'Assumed Friendly Pathfinding Equipment', correct: false },
      { text: 'Assumed Friendly TOW Missile Launcher', correct: false },
      { text: 'Assumed Friendly Laser Equipment', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.psyops_EQ.file,
    description: eqDesc,
    answers: [
      { text: 'Hostile Psychological Operations Equipment', correct: true },
      { text: 'Hostile Jet Propulsion Equipment', correct: false },
      { text: 'Hostile Pathfinding Equipment', correct: false },
      { text: 'Assumed Hostile TOW Missile Launcher', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.radar_EQ.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Signal unit', correct: false },
      { text: 'Assumed Friendly Radar Equipment', correct: true },
      { text: 'Assumed Friendly Signal unit', correct: false },
      { text: 'Assumed Friendly Lightning Strike event', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.sensor_EQ.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Point of Departure', correct: false },
      { text: 'Friendly Point of Impact', correct: false },
      { text: 'Friendly Sensor Equipment', correct: true },
      { text: 'Friendly Radar Equipment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.generator_EQ.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Guerilla unit', correct: false },
      { text: 'Guard (tactical mission task)', correct: false },
      { text: 'Friendly Garbage collection area', correct: false },
      { text: 'Friendly Generator Equipment', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.AHIF.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Attack Helicopter (in-flight)', correct: true },
      { text: 'Friendly Assault Helicopter (on-ground)', correct: false },
      { text: 'Friendly Ambulance Helicopter (in-flight)', correct: false },
      { text: 'Friendly Class A Helicopter (in-flight)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.MEHIF.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Assault Helicopter (on-ground)', correct: false },
      { text: 'Friendly MEDEVAC Helicopter (in-flight)', correct: true },
      { text: 'Friendly Ambulance Helicopter (on-ground)', correct: false },
      { text: 'Friendly MEDEVAC unit (in-flight)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.CHIF.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Assault Helicopter (in-flight)', correct: false },
      { text: 'Friendly Ambulance Helicopter (on-ground)', correct: false },
      { text: 'Friendly Cargo Helicopter (in-flight)', correct: true },
      { text: 'Friendly Cargo Helicopter with loading jack', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HIC_L.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Light Helicopter unit', correct: false },
      { text: 'Friendly Light Helicopter (on-ground)', correct: false },
      { text: 'Friendly Loading Helicopter (in-flight)', correct: false },
      { text: 'Friendly Light Helicopter (in-flight)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HIC_M.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Medium Helicopter (in-flight)', correct: true },
      { text: 'Friendly Medium Helicopter unit', correct: false },
      { text: 'Friendly Medium Helicopter (on-ground)', correct: false },
      { text: 'Friendly Missile Helicopter (in-flight)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HIC_H.file,
    description: eqDesc,
    answers: [
      { text: 'Friendly Heavy Helicopter unit', correct: false },
      { text: 'Friendly Heavy Helicopter (in-flight)', correct: true },
      { text: 'Friendly Heavy Helicopter (on-ground)', correct: false },
      { text: 'Friendly Missile Helicopter (in-flight)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.combatTrains.file,
    description:
      'The base symbol for this piece of equipment is a Cross Country Utility Vehicle. The Sector 1 modifier denotes a battalion level echelon of support. Combining both of these tells us this is a vehicle belonging to a battalion level combat trains',
    answers: [
      { text: 'Pending Limited Mobility vehicle supporting a battalion', correct: false },
      { text: 'Unknown Limited Mobility vehicle supporting a Brigade', correct: false },
      { text: 'Unknown High mobility vehicle supporting a battalion (combat trains)', correct: true },
      { text: 'Unknown High mobility vehicle', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.earthmover_MF.file,
    description: 'The base symbol for this piece of equipment is an earthmoving Vehicle. The Sector 1 modifier denotes Multifunctional capabilities.',
    answers: [
      { text: 'Assumed Hostile Infantry Regiment with missile capability', correct: false },
      { text: 'Assumed Hostile Light Tank with mobile facility capability', correct: false },
      { text: 'Hostile Light Tank with missile capability', correct: false },
      { text: 'Assumed Hostile Multifunctional Earthmover Vehicle', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.civilianShip_POL.file,
    description:
      'The base symbol for this piece of equipment is a Civilian Merchant Ship. The Sector 1 modifier denotes Petroleum, Oil & Lubricants (POL). This could also be inferred as an Oil Tanker',
    answers: [
      { text: 'Friendly Civilian Merchant POL Ship', correct: true },
      { text: 'Friendly Civilian Merchant Ship with Oil Drilling capability', correct: false },
      { text: 'Friendly Ship with sensing capability', correct: false },
      { text: 'Friendly Military Naval Vessel with radar equipment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ATHRV.file,
    description:
      'The base symbol for this piece of equipment is an Armored Protected Vehicle. The Sector 1 modifier denotes Maintenance capability and the Sector 2 modifier denotes the equipment is heavy. This is essentially an Armored Recovery Vehicle (ARV), or sometimes known as the M88A2 Hercules.',
    answers: [
      { text: 'Neutral Heavy Armored wheeled vehicle', correct: false },
      { text: 'Neutral Armored tracked heavy recovery vehicle', correct: true },
      { text: 'Neutral Armored tracked vehicle', correct: false },
      { text: 'Unknown Armored tracked recovery vehicle', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RATVWHATG.file,
    description:
      'The base symbol for this piece of equipment is an Anti-tank gun (heavy). The Sector 1 modifier denotes robotic capability and the Sector 2 modifier denotes the equipment is armored.',
    answers: [
      { text: 'Friendly armored heavy multiple rocket launcher vehicle', correct: false },
      { text: 'Friendly armored medium antitank gun on a fire mission', correct: false },
      { text: 'Friendly Robotic armored tracked vehicle with heavy antitank gun', correct: true },
      { text: 'Friendly armored heavy antitank gun with counter-battery capabilities', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.HMWUV.file,
    description: 'The base symbol for this piece of equipment is a Cross Country Vehicle. The Sector 1 modifier denotes a Utility capability.',
    answers: [
      { text: 'Assumed Friendly armored heavy multiple rocket launcher vehicle', correct: false },
      { text: 'Assumed Friendly High Mobility Wheeled Vehicle', correct: false },
      { text: 'Assumed Friendly Limited Mobility Wheeled Vehicle', correct: false },
      { text: 'Assumed Friendly High Mobility Wheeled Utility Vehicle', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bus.file,
    description: 'The base symbol for this piece of equipment is a Limited Cross Country Vehicle. The Sector 1 modifier denotes a bus capability.',
    answers: [
      { text: 'Assumed Hostile Bus', correct: true },
      { text: 'Hostile Bus', correct: false },
      { text: 'Assumed Hostile High Mobility Wheeled Vehicle', correct: false },
      { text: 'Assumed Hostile Limited Mobility Wheeled Vehicle', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.C2AFV.file,
    description: 'The base symbol for this piece of equipment is a Armored Fighting Vehicle. The Sector 1 modifier denotes a Command and Control capability.',
    answers: [
      { text: 'Friendly Armored Fighting Vehicle', correct: false },
      { text: 'Assumed Friendly Command and Control Armored Fighting Vehicle', correct: true },
      { text: 'Assumed Friendly Command and Control Armored Personnel Carrier', correct: false },
      { text: 'Assumed Friendly Limited Mobility Wheeled Vehicle', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.AWC.file,
    description: 'The base symbol for this piece of equipment is a Nonlethal weapon (water cannon). The Sector 1 modifier denotes an armored capability.',
    answers: [
      { text: 'Unknown White Phosphorus launching equipment', correct: false },
      { text: 'Neutral Armored single rocket launcher (white phosphorus)', correct: false },
      { text: 'Neutral Armored Water Cannon', correct: true },
      { text: 'Neutral intersection (wet conditions)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_WAT.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving via wheeled and tracked means.</p>`,
    answers: [
      { text: 'Hostile Multiple Rocket launcher moving by a wheeled and tracked vehicle', correct: false },
      { text: 'Hostile Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Hostile Mortar moving by a wheeled and tracked vehicle', correct: false },
      { text: 'Hostile Howitzer moving by a Wheeled and tracked combination vehicle', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_WL.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving by a Wheeled (limited to improved roads) vehicle.</p>`,
    answers: [
      { text: 'Unknown Howitzer moving by a Wheeled (limited) vehicle', correct: true },
      { text: 'Unknown Multiple Rocket launcher moving by a wheeled and tracked vehicle', correct: false },
      { text: 'Unknown Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Unknown Mortar moving by a railway', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_WCC.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving by a Wheeled (limited to improved roads) vehicle.</p>`,
    answers: [
      { text: 'Friendly Multiple Rocket launcher moving by a wheeled and tracked vehicle', correct: false },
      { text: 'Friendly Howitzer moving by a Wheeled (cross-country) vehicle', correct: true },
      { text: 'Friendly Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Friendly Mortar moving by a railway', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_TOSP.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving by a Tracked or Self-propelled vehicle.</p>`,
    answers: [
      { text: 'Hostile Multiple Rocket launcher moving by a wheeled and tracked vehicle', correct: false },
      { text: 'Hostile Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Hostile Howitzer moving by a tracked or self-propelled vehicle', correct: true },
      { text: 'Hostile Howitzer moving by a railway', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_TOWED.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is being towed.</p>`,
    answers: [
      { text: 'Unknown Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Unknown Multiple Rocket launcher moving by a wheeled and tracked vehicle', correct: false },
      { text: 'Unknown Howitzer moving by a railway', correct: false },
      { text: 'Unknown Howitzer being towed', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_RAILWAY.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving by a railroad.</p>`,
    answers: [
      { text: 'Neutral Howitzer moving by a railroad', correct: true },
      { text: 'Neutral Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Neutral Multiple Rocket launcher moving by a Cross Country vehicle', correct: false },
      { text: 'Neutral Howitzer being towed', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_OS.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving over snow by a prime mover vehicle.</p>`,
    answers: [
      { text: 'Pending Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Pending Howitzer moving over snow by a prime mover vehicle', correct: true },
      { text: 'Pending Howitzer moving by a sled', correct: false },
      { text: 'Pending Howitzer being towed', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_SLED.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving by a sled.</p>`,
    answers: [
      { text: 'Pending Howitzer moving by pack animals', correct: false },
      { text: 'Pending Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Pending Howitzer moving by a sled', correct: true },
      { text: 'Pending Howitzer moving over snow by a prime mover vehicle', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_PA.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving by pack animals.</p>`,
    answers: [
      { text: 'Neutral Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Neutral Howitzer moving by a sled', correct: false },
      { text: 'Neutral Howitzer moving over snow by a prime mover vehicle', correct: false },
      { text: 'Neutral Howitzer moving by pack animals', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_BARGE.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving by a barge.</p>`,
    answers: [
      { text: 'Assumed Friendly Howitzer moving by a barge', correct: true },
      { text: 'Assumed Friendly Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Assumed Friendly Howitzer moving by a sled', correct: false },
      { text: 'Assumed Friendly Howitzer moving over snow by a prime mover vehicle', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_AMP.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving by an amphibious vessel.</p>`,
    answers: [
      { text: 'Pending Light Howitzer moving by a halftrack vehicle', correct: false },
      { text: 'Pending Howitzer moving by an amphibious vessel', correct: true },
      { text: 'Pending Howitzer with radar jamming capabilities', correct: false },
      { text: 'Pending Howitzer moving over snow by a prime mover vehicle', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TM_SKI.file,
    description: `${eqTransDesc} <p class="mdc-typography--body1">The base symbol for this piece of equipment is a Howitzer (generic). The Transportation Mode modifier denotes that it is moving by on skis.</p>`,
    answers: [
      { text: 'Hostile Light Howitzer with maintenance capabilities', correct: false },
      { text: 'Hostile Howitzer with counter-battery capabilities', correct: false },
      { text: 'Hostile Howitzer moving on skis', correct: true },
      { text: 'Hostile Howitzer moving over snow by a prime mover vehicle', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_AT.file,
    description: 'The base symbol for this piece of equipment is a Mortar (between 60mm and 107mm). The Sector 2 modifier denotes Armored Tracked capability.',
    answers: [
      { text: 'Friendly Armored tracked vehicle with heavy mortar', correct: false },
      { text: 'Friendly armored Protected vehicle with medium mortar', correct: false },
      { text: 'Friendly Armored Tracked Vehicle with antitank gun', correct: false },
      { text: 'Friendly Armored tracked vehicle with medium mortar', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_AMP.file,
    description: 'The base symbol for this piece of equipment is a Armored Tracked Vehicle. The Sector 2 modifier denotes Amphibious capability.',
    answers: [
      { text: 'Friendly Amphibious armored tracked vehicle', correct: true },
      { text: 'Friendly Armored tracked vehicle with radar jamming capability', correct: false },
      { text: 'Friendly armored Protected vehicle with medium mortar', correct: false },
      { text: 'Friendly Armored Tracked Vehicle with antitank gun', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_HEAVY.file,
    description: 'The base symbol for this piece of equipment is a Bridge. The Sector 2 modifier denotes that it is heavy.',
    answers: [
      { text: 'Assumed Friendly Armored tracked vehicle with radar jamming capability', correct: false },
      { text: 'Assumed Friendly Heavy Bridge', correct: true },
      { text: 'Assumed Friendly Heavy breaching equipment', correct: false },
      { text: 'Assumed Friendly Heavy loading equipment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_LAUNCHER.file,
    description: 'The base symbol for this piece of equipment is a Mine Layer. The Sector 2 modifier denotes that it has mine launching capabilities.',
    answers: [
      { text: 'Hostile High Explosive Field Artillery Unit', correct: false },
      { text: 'Hostile Artillery Ammunition Cache', correct: false },
      { text: 'Hostile Mine Laying Launcher', correct: true },
      { text: 'Hostile Mine Cache', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_LIGHT.file,
    description: 'The base symbol for this piece of equipment is a Bridge. The Sector 2 modifier denotes that it is light.',
    answers: [
      { text: 'Hostile Armored tracked vehicle with radar jamming capability', correct: false },
      { text: 'Hostile Light breaching equipment', correct: false },
      { text: 'Hostile Light loading equipment', correct: false },
      { text: 'Hostile Light Bridge', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_MEDIUM.file,
    description: 'The base symbol for this piece of equipment is a Helicopter. The Sector 1 modifier denotes that it has cargo capabilities. The Sector 2 modifier denotes that it is medium.',
    answers: [
      { text: 'Hostile Medium Cargo helicopter (on-ground)', correct: true },
      { text: 'Hostile Medium Cargo Helicopter (in-flight)', correct: false },
      { text: 'Hostile Medium Cargo Airplane (in-flight)', correct: false },
      { text: 'Hostile Medium Cargo Airplane (on-ground)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_PA.file,
    description: 'The base symbol for this piece of equipment is a Laser. The Sector 2 modifier denotes that it is mounted on a pack animal.',
    answers: [
      { text: 'Friendly Laser Mounted on a Pack Animal', correct: true },
      { text: 'Friendly TOW Missile Launcher', correct: false },
      { text: 'Friendly Pathfinding Equipment', correct: false },
      { text: 'Friendly TOW Missile Launcher on a mountain', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_RAIL.file,
    description: 'The base symbol for this piece of equipment is a Railcar or Boxcar.',
    answers: [
      { text: 'Hostile High Mobility Cross Country Vehicle', correct: false },
      { text: 'Hostile Rail Boxcar', correct: true },
      { text: 'Hostile Limited Mobility Cross Country Vehicle', correct: false },
      { text: 'Hostile Tractor Trailer', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_TT.file,
    description: 'The base symbol for this piece of equipment is a Tractor Trailer Vehicle. The Sector 1 Modifier denotes that it is heavy',
    answers: [
      { text: 'Unknown Heavy High Mobility Cross Country Vehicle', correct: false },
      { text: 'Unknown Heavy Limited Mobility Cross Country Vehicle', correct: false },
      { text: 'Unknown Heavy Tractor Trailer vehicle', correct: true },
      { text: 'Unknown Heavy Rail Boxcar', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_WHMCC.file,
    description: 'The base symbol for this piece of equipment is a Missile Launcher. The Sector 1 Modifier denotes that it is Armored and the Sector 2 modifier denotes that it is wheeled.',
    answers: [
      { text: 'Hostile Armored Limited Cross Country Vehicle with Missile Launcher', correct: false },
      { text: 'Hostile Armored Wheeled Multiple Rocket Launcher', correct: false },
      { text: 'Hostile Wheeled Missile Launcher', correct: false },
      { text: 'Hostile Armored high mobility wheeled vehicle with missile launcher', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_WLM.file,
    description: 'The base symbol for this piece of equipment is a Limited Mobility Vehicle. The Sector 1 Modifier denotes that it has medium capabilities.',
    answers: [
      { text: 'Assumed Friendly Medium Limited Mobility Vehicle', correct: true },
      { text: 'Assumed Friendly Armored Limited Cross Country Vehicle', correct: false },
      { text: 'Friendly Armored Wheeled Multiple Rocket Launcher', correct: false },
      { text: 'Assumed Friendly Wheeled Missile Launcher', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.S2_UASL.file,
    description:
      'The base symbol for this piece of equipment is a Railcar or Boxcar. The Sector 1 Modifier denotes that it is armored and the Sector 2 modifier denotes that it has an Unmanned Aerial System launching capability.',
    answers: [
      { text: 'Friendly Armored Limited Cross Country Vehicle', correct: false },
      { text: 'Friendly Armored Railcar with Unmanned Aerial System Launcher', correct: true },
      { text: 'Friendly Armored Wheeled Multiple Rocket Launcher', correct: false },
      { text: 'Friendly Wheeled Missile Launcher', correct: false },
    ],
  },
  // ? Graphic Control Measure
  {
    question: 'What is this symbol?',
    symbolSVG: mso.strongPoint.file,
    description: 'A heavily fortified battle position tied to a natural or reinforcing obstacle to create an anchor for the Defense or to deny the enemy decisive or key terrain.',
    answers: [
      { text: 'Company Fortified Area Two', correct: false },
      { text: 'Company Battle Position Planned but not occupied', correct: false },
      { text: 'Company Strong Point Two', correct: true },
      { text: 'Company Battle Position Two', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fortifiedArea.file,
    description:
      'An area is a specified geographic surface included within a delineated set of lines (boundaries) used for the purpose of facilitating coordination and deconfliction between adjacent units, formations, or other specific geographical surfaces.',
    answers: [
      { text: 'Battle Position Planned but not occupied', correct: false },
      { text: 'Strong Point Tango', correct: false },
      { text: 'Battle Position Tango', correct: false },
      { text: 'Fortified Area Tango', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.encirclementOps.file,
    description: 'Operations where one force loses its freedom of maneuver because an opposing force is able to Isolate it by controlling all ground lines of communications and reinforcement.',
    answers: [
      { text: 'Encirclement Operations', correct: true },
      { text: 'Strong Point', correct: false },
      { text: 'Battle Position', correct: false },
      { text: 'Fortified Area', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.checkpoint.file,
    description: 'A predetermined point on the ground used to control movement, tactical maneuver, and orientation. Also called CP',
    answers: [
      { text: 'Chokepoint 12', correct: false },
      { text: 'Checkpoint 12', correct: true },
      { text: 'Control point 12', correct: false },
      { text: 'Passage Point 12', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.controlpoint.file,
    description:
      'An action taken to eliminate a hazard or reduce its risk. Note: This symbol demonstrates the capability and authority to exercise restraining or directing influence (regulating) over a specific function.',
    answers: [
      { text: 'Chokepoint Red', correct: false },
      { text: 'Checkpoint Red', correct: false },
      { text: 'Control point Red', correct: true },
      { text: 'Passage Point Red', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.engineerRegulatingPoint.file,
    description:
      'Checkpoint to ensure that vehicles do not exceed the capacity of the crossing means and to give drivers final instructions on site-specific procedures and information, such as speed and vehicle interval.',
    answers: [
      { text: 'Explosive Remnants Point', correct: false },
      { text: 'Environmental Response Point', correct: false },
      { text: 'Emergency Response Point', correct: false },
      { text: 'Engineer Regulating Point', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.rallyPoint.file,
    description: 'An easily identifiable point on the ground at which units can reassemble and reorganize if they become dispersed.',
    answers: [
      { text: 'Rally Point', correct: true },
      { text: 'Release Point', correct: false },
      { text: 'Relay Point', correct: false },
      { text: 'Reinforcements Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.releasePoint.file,
    description: 'A location on a route where marching elements are released from centralized control. Also called RP.',
    answers: [
      { text: 'Rally Point', correct: false },
      { text: 'Release Point', correct: true },
      { text: 'Relay Point', correct: false },
      { text: 'Reinforcements Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.startPoint.file,
    description: 'A location on a route where the march elements fall under the control of a designated march commander. Also called SP.',
    answers: [
      { text: 'Rally Point', correct: false },
      { text: 'Service Point', correct: false },
      { text: 'Start Point', correct: true },
      { text: 'Survey Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.isoPoint.file,
    description: 'Represents an isolated individual who needs to be rescued.',
    answers: [
      { text: 'Enemy Combatant', correct: false },
      { text: 'Downed Pilot Point', correct: false },
      { text: 'Neutral Isolated Personnel', correct: false },
      { text: 'Isolated Personnel Recovery Point', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SARPoint.file,
    description: 'Represents an isolated individual who needs to be rescued.',
    answers: [
      { text: 'Search and Rescue Point', correct: true },
      { text: 'Sea and Air Point', correct: false },
      { text: 'Sea and Air Refueling Point', correct: false },
      { text: 'Signal and Radar Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.deconPoint.file,
    description:
      'The process of making any person, object, or area safe by absorbing, destroying, neutralizing, making harmless, or removing chemical or biological agents, or by removing radioactive material clinging to or around it.',
    answers: [
      { text: 'Alternate Decontamination Point', correct: false },
      { text: 'Decontamination Point', correct: true },
      { text: 'Equipment Decontamination Point', correct: false },
      { text: 'DC Alternator Equipment', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.axpPoint.file,
    description: 'A location where a patient is transferred from one ambulance to another en route to a medical treatment facility. Also called AXP.‎‎',
    answers: [
      { text: 'Ammunition Exchange Point', correct: false },
      { text: 'Ambulance Load Point', correct: false },
      { text: 'Ambulance Exchange Point', correct: true },
      { text: 'Ambulance Control Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.acpPoint.file,
    description:
      'A manned traffic regulating, often stationed at a crossroad or road junction, where ambulances are directed to one of two or more directions to reach loading points and medical treatment facilities.‎‎‎',
    answers: [
      { text: 'Ammunition Control Point', correct: false },
      { text: 'Ambulance Load Point', correct: false },
      { text: 'Ambulance Exchange Point', correct: false },
      { text: 'Ambulance Control Point', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.arpPoint.file,
    description: 'A point in the shuttle system where one or more empty ambulances are stationed to advance to a loading point or to the next relay post to replace departed ambulances.‎‎‎‎',
    answers: [
      { text: 'Ambulance Relay Point', correct: true },
      { text: 'Ammunition Reload Point', correct: false },
      { text: 'Ambulance Retrofit Point', correct: false },
      { text: 'Ambulance Exchange Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.aspPoint.file,
    description: 'An ammunition support activity operated by one or more modular ammunition platoons.‎',
    answers: [
      { text: 'Ammunition Supply Point', correct: true },
      { text: 'Ammunition Reload Point', correct: false },
      { text: 'Ambulance Sustainment Point', correct: false },
      { text: 'Ambulance Service Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.athpPoint.file,
    description:
      'A designated site operated by a brigade support battalion distribution company where ammunition is received, transferred, or temporarily stored to supported units within a brigade combat team. Also called ATHP.‎‎',
    answers: [
      { text: 'Allied Troops Holding Point', correct: false },
      { text: 'Ammunition Transfer Holding Point', correct: true },
      { text: 'Allied Trains Point', correct: false },
      { text: 'Ambulance Transfer Hospital Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.canPoint.file,
    description: 'Usually used in terms of parts from equipment being transferred to other pieces of equipment.',
    answers: [
      { text: 'Civil Aero-Nautical Point', correct: false },
      { text: 'Aluminum Can Return Point', correct: false },
      { text: 'Cannibalization Point', correct: true },
      { text: 'Canadian Forces Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ccpPoint.file,
    description: 'A location that may or may not be staffed, where casualties are assembled for evacuation to a medical treatment facility.‎',
    answers: [
      { text: 'Civil Construction Point', correct: false },
      { text: 'Civil Coordination Point', correct: false },
      { text: 'The Soviet Union', correct: false },
      { text: 'Casualty Collection Point', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.lrpPoint.file,
    description: 'A location where logistical elements are released from control.‎',
    answers: [
      { text: 'Logistics Release Point', correct: true },
      { text: 'Local Retrograde Point', correct: false },
      { text: 'Logistical Reconstruction Point', correct: false },
      { text: 'Live Action Role Playing', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mcpPoint.file,
    description: 'A temporary location established within the battalion echelon for the collection of equipment needing or undergoing field maintenance.',
    answers: [
      { text: 'Marine Corps Police', correct: false },
      { text: 'Maintenance Collection Point', correct: true },
      { text: 'Maritime Control Point', correct: false },
      { text: 'Maritime Combat Patrol', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.medevacPoint.file,
    description: 'A location where medical services will evacuate troops.‎',
    answers: [
      { text: 'Neutral Medical Unit', correct: false },
      { text: 'Unknown Medical Unit', correct: false },
      { text: 'Medical Evacuation Pickup Point', correct: true },
      { text: 'Field Hospital', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mortuaryAffairsPoint.file,
    description: 'The location for receiving, establishing chain of custody, and evacuating human remains and personal effects.‎',
    answers: [
      { text: 'Religious Affairs Unit', correct: false },
      { text: 'Religious Affairs Point', correct: false },
      { text: 'Mass Graves Point', correct: false },
      { text: 'Mortuary Affairs Collection Point', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.r3pPoint.file,
    description: 'A designated location through which a unit passes where it receives fuel, ammunition, and other necessary supplies to continue operations. ‎‎',
    answers: [
      { text: 'Rearm, Refuel and Resupply Point', correct: true },
      { text: 'Retreat, Retrograde and Retirement Point', correct: false },
      { text: 'R3 Drone Launch Point', correct: false },
      { text: 'Reserve Rapid Response Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.tcpPoint.file,
    description: 'A manned post that is used to preclude the interruption of traffic flow or movement along a designated route.‎‎',
    answers: [
      { text: 'Theatre Communications Point', correct: false },
      { text: 'Traffic Control Point', correct: true },
      { text: 'Theatre Consolation and Processing Point', correct: false },
      { text: 'Theatre Construction Personnel', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ttpPoint.file,
    description: 'A location established along the line haul system to divide the line haul into legs, where semitrailers or flatracks are transferred from one carrier to another while en-route.‎‎',
    answers: [
      { text: 'Tactical Transportation Point', correct: false },
      { text: 'Theatre Troops Point', correct: false },
      { text: 'Trailer Transfer Point', correct: true },
      { text: 'Tactical Terrain Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.spGenPoint.file,
    description: 'A location of a generic supply point. If the supply point is generic then there is no main icon.',
    answers: [
      { text: 'Supply Point (Class I)', correct: false },
      { text: 'Service Supply Route', correct: false },
      { text: 'Element Headquarters Point', correct: false },
      { text: 'Supply Point (generic)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC1NATO.file,
    description: 'Those items which are consumed by personnel or animals at the approximately uniform rate, irrespective of local changes in combat or terrain conditions.‎',
    answers: [
      { text: 'NATO Class I Supply Point', correct: true },
      { text: 'U.S. Class I Supply Point', correct: false },
      { text: 'U.S. Class II Supply Point', correct: false },
      { text: 'NATO Class II Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC1.file,
    description: 'Rations - Subsistence (food and drinking water), gratuitous (free) health and comfort items.',
    answers: [
      { text: 'NATO Class I Supply Point', correct: false },
      { text: 'U.S. Class I Supply Point', correct: true },
      { text: 'U.S. Class II Supply Point', correct: false },
      { text: 'NATO Class II Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC2.file,
    description: 'Supplies for which allowances are established by tables of organization and equipment‎ (clothing and equipment).',
    answers: [
      { text: 'NATO Class I Supply Point', correct: false },
      { text: 'U.S. Class I Supply Point', correct: false },
      { text: 'NATO & U.S. Class II Supply Point', correct: true },
      { text: 'NATO Class III Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC3NATO.file,
    description: 'Fuels and lubricants for all purposes, except for operating aircraft or for use in weapons such as flame throwers.‎',
    answers: [
      { text: 'NATO Class I Supply Point', correct: false },
      { text: 'U.S. Class I Supply Point', correct: false },
      { text: 'NATO & U.S. Class II Supply Point', correct: false },
      { text: 'NATO Class III Supply Point', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC3.file,
    description:
      'POL - Petroleum, Oil and Lubricants (POL) (package and bulk): Petroleum, fuels, lubricants, hydraulic and insulating oils, preservatives, liquids and gases, bulk chemical products, coolants, deicer and antifreeze compounds, components, and additives of petroleum and chemical products, and coal.‎',
    answers: [
      { text: 'U.S. Class III Supply Point', correct: true },
      { text: 'NATO Class I Supply Point', correct: false },
      { text: 'U.S. Class IV Supply Point', correct: false },
      { text: 'NATO & U.S. Class II Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC4NATO.file,
    description:
      'Supplies for which initial issue allowances are not prescribed by approved issue tables.‎‎ Normally includes fortification and construction materials, as well as additional quantities of items identical to those authorized for initial issue (Class II) such as additional vehicles.',
    answers: [
      { text: 'NATO Class III Supply Point', correct: false },
      { text: 'NATO Class IV Supply Point', correct: true },
      { text: 'U.S. Class VI Supply Point', correct: false },
      { text: 'NATO & U.S. Class II Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC4.file,
    description: 'Construction materials, including installed equipment and all fortification and barrier materials.',
    answers: [
      { text: 'NATO Class III Supply Point', correct: false },
      { text: 'U.S. Class VI Supply Point', correct: false },
      { text: 'U.S. Class IV Supply Point', correct: true },
      { text: 'Engineer Rally Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC5.file,
    description: 'Ammunition, explosives, and chemical agents of all types.',
    answers: [
      { text: 'U.S. Class III Supply Point', correct: false },
      { text: 'U.S. Class VI Supply Point', correct: false },
      { text: 'NATO & U.S. Class V Supply Point', correct: true },
      { text: 'NATO & U.S. Class VII Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC6.file,
    description:
      'Personal demand items (such as health and hygiene products, soaps and toothpaste, writing material, snack food, beverages, cigarettes, batteries, alcohol, and cameras—nonmilitary sales items).',
    answers: [
      { text: 'U.S. Class IV Supply Point', correct: false },
      { text: 'U.S. Class V Supply Point', correct: false },
      { text: 'NATO & U.S. Class VII Supply Point', correct: false },
      { text: 'U.S. Class VI Supply Point', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC7.file,
    description: 'Major end items such as launchers, tanks, mobile machine shops, some parachute systems and vehicles.',
    answers: [
      { text: 'U.S. Class VII Supply Point', correct: true },
      { text: 'U.S. Class IV Supply Point', correct: false },
      { text: 'U.S. Class V Supply Point', correct: false },
      { text: 'NATO & U.S. Class II Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC8.file,
    description:
      'Medical material (equipment and consumables) including repair parts peculiar to medical equipment. (Class VIIIa – Medical consumable supplies not including blood & blood products; Class VIIIb – Blood & blood components (whole blood, platelets, plasma, packed red cells, etc.).',
    answers: [
      { text: 'U.S. Class IX Supply Point', correct: false },
      { text: 'NATO & U.S. Class VIII Supply Point', correct: true },
      { text: 'U.S. Class V Supply Point', correct: false },
      { text: 'NATO & U.S. Class IV Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC9.file,
    description: 'Repair parts and components to include kits, assemblies, and subassemblies (repairable or non-repairable) required for maintenance support of all equipment.',
    answers: [
      { text: 'U.S. Class X Supply Point', correct: false },
      { text: 'U.S. Class VIII Supply Point', correct: false },
      { text: 'U.S. Class IX Supply Point', correct: true },
      { text: 'NATO & U.S. Class IV Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPC10.file,
    description:
      'Material to support nonmilitary programs such as agriculture and economic development (not included in Classes I through IX). For example: miscellaneous - Water, salvage, and captured material.',
    answers: [
      { text: 'U.S. Class IX Supply Point', correct: false },
      { text: 'U.S. Class VIII Supply Point', correct: false },
      { text: 'NATO & U.S. Class VII Supply Point', correct: false },
      { text: 'U.S. Class X Supply Point', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.SPMSCP.file,
    description: 'Use supply class numbers (I, II, III, IV and V) for a field or for all classes of supply.',
    answers: [
      { text: 'NATO Multiple Supply Class Point', correct: true },
      { text: 'U.S. Class I Supply Point', correct: false },
      { text: 'U.S. Class III Supply Point', correct: false },
      { text: 'NATO & U.S. Class V Supply Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airfieldPoint.file,
    description: 'An area prepared for the accommodation (including any buildings, installations, and equipment), landing, and takeoff of aircraft.‎',
    answers: [
      { text: 'Highway Intersection', correct: false },
      { text: 'Airfield', correct: true },
      { text: 'UAS Launcher', correct: false },
      { text: 'Main Supply Route', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.contactPoint.file,
    description: 'In land warfare, a point on the terrain, easily identifiable, where two or more units are required to make contact. Also called CP.‎',
    answers: [
      { text: 'A Glass box of Emotions', correct: false },
      { text: 'Fortification', correct: false },
      { text: 'Contact Point', correct: true },
      { text: 'Main Supply Route', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.decisionPoint.file,
    description: 'A point in space and time when the commander or staff anticipates making a key decision concerning a specific course of action.‎',
    answers: [
      { text: 'Start Point', correct: false },
      { text: 'End Point', correct: false },
      { text: 'Soldiers Stargazing', correct: false },
      { text: 'Decision Point', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.keyTerrain.file,
    description: 'An identifiable characteristic whose seizure or retention affords a marked advantage to either combatant.‎ Note: Key Terrain is usually expressed in purple or black.‎',
    answers: [
      { text: 'Key Terrain', correct: true },
      { text: 'Kill Zone', correct: false },
      { text: 'End Point', correct: false },
      { text: 'King of the Mountain', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.pointOfInterest.file,
    description: 'A distinctive action point of interest within a theatre of operations. The "LE" means launch event.‎',
    answers: [
      { text: 'Law Enforcement', correct: false },
      { text: 'Point of Interest (Launch Event)', correct: true },
      { text: 'Authorization of Lethal Force Event', correct: false },
      { text: 'Suspicious Activity (Light Emitting)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.waypoint.file,
    description: 'Designated point or series of points loaded and stored in a global positioning system or other electronic navigational aid system to facilitate movement.‎',
    answers: [
      { text: 'Rally Point', correct: false },
      { text: 'Nuclear Target', correct: false },
      { text: 'Waypoint', correct: true },
      { text: 'Target Reference Point', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.targetHandover.file,
    description: 'Depicts a direct fire target handover mission is in progress and facilitates orientation of direct fires to maximize combat effectiveness and minimize fratricide.‎‎',
    answers: [
      { text: 'Rally Point', correct: false },
      { text: 'Thermo-nuclear Target', correct: false },
      { text: 'Target Reference Point', correct: false },
      { text: 'Target Handover', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.airborneAoA.file,
    description: "The general area through which the bulk of a unit's airborne combat power must move.‎‎‎",
    answers: [
      { text: 'Airborne Axis of Advance', correct: true },
      { text: 'Attack Helicopter Axis of Advance', correct: false },
      { text: 'Main Axis of Advance', correct: false },
      { text: 'Route Clearance Event', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.attackHelicopterAoA.file,
    description: "The general area through which the bulk of a unit's attack helicopter combat power must move.‎‎‎",
    answers: [
      { text: 'Airborne Axis of Advance', correct: false },
      { text: 'Attack Helicopter Axis of Advance', correct: true },
      { text: 'Main Axis of Advance', correct: false },
      { text: 'Route Clearance Event', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.mainAoA.file,
    description: 'The principal attack or effort into which the commander throws the full weight of the offensive power at his disposal.‎‎‎‎',
    answers: [
      { text: 'Airborne Axis of Advance', correct: false },
      { text: 'Attack Helicopter Axis of Advance', correct: false },
      { text: 'Main Axis of Advance', correct: true },
      { text: 'Route Clearance Event', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.attackByFire.file,
    description:
      'A tactical mission task in which a commander uses direct fires, supported by indirect fires, to engage an enemy force without closing with the enemy to destroy, suppress, fix, or deceive that enemy.‎‎‎‎‎',
    answers: [
      { text: 'Airborne Axis of Advance', correct: false },
      { text: 'Artillery Suppression', correct: false },
      { text: 'Support by Fire', correct: false },
      { text: 'Attack by Fire', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.supportByFire.file,
    description:
      'A tactical mission task in which a commander uses direct fires, supported by indirect fires, to engage an enemy force without closing with the enemy to destroy, suppress, fix, or deceive that enemy.‎‎‎‎‎',
    answers: [
      { text: 'Support by Fire', correct: true },
      { text: 'Airborne Axis of Advance', correct: false },
      { text: 'Screen', correct: false },
      { text: 'Attack by Fire', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.aviationDirectionOfAttack.file,
    description: 'A specific direction or assigned route a force uses and does not deviate from when attacking.‎',
    answers: [
      { text: 'Airborne Axis of Advance, Codename AVON', correct: false },
      { text: 'Aviation Direction of Attack, Codename AVON', correct: true },
      { text: 'Aviation Offensive', correct: false },
      { text: 'Attack by Fire, Codename AVON', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.directionOfMainAttack.file,
    description:
      'An attack is a type of offensive operation that destroys or defeats enemy forces, seizes and secures terrain, or both. This represents a specific direction or assigned route a force uses and does not deviate from when attacking.',
    answers: [
      { text: 'Airborne Axis of Advance, Codename MAIN', correct: false },
      { text: 'Main Aviation Offensive', correct: false },
      { text: 'Direction of Main Attack', correct: true },
      { text: 'Attack by Fire, Codename MAIN', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.cordonAndKnock.file,
    description:
      'In a cordon and knock operation, counterinsurgency forces assemble around an area to provide security ("cordon") and then obtain permission to search the area from residents ("knock").',
    answers: [
      { text: 'Cordon and Search', correct: false },
      { text: 'Cordon and Kill', correct: false },
      { text: 'Enveloped Civilians and Contractors', correct: false },
      { text: 'Cordon and Knock', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.cordonAndSearch.file,
    description:
      'A technique of conducting a movement to contact that involves isolating a target area and searching suspect locations within that target area to capture or destroy possible enemy forces and contraband.‎',
    answers: [
      { text: 'Cordon and Search', correct: true },
      { text: 'Cordon and Supply', correct: false },
      { text: 'Enveloped Civilians and Supplies', correct: false },
      { text: 'Cordon and Knock', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ambush.file,
    description: 'An attack by fire or other destructive means from concealed positions on a moving or temporarily halted enemy.',
    answers: [
      { text: 'Counterattack', correct: false },
      { text: 'Ambush', correct: true },
      { text: 'Attack by Fire', correct: false },
      { text: 'Support by Fire', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.counterattack.file,
    description:
      'Attack by part or all of a defending force against an enemy attacking force, for such specific purposes as regaining ground lost, or cutting off or destroying enemy advance units, and with the general objective of denying to the enemy the attainment of the enemy’s purpose in attacking. In sustained defensive operations, it is undertaken to restore the battle position and is directed at limited objectives. Note: The dashed lines in this graphic shall be displayed in present and anticipated status.',
    answers: [
      { text: 'Ambush', correct: false },
      { text: 'Counterattack', correct: true },
      { text: 'Attack by Fire', correct: false },
      { text: 'Support by Fire', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.demonstration.file,
    description: 'In military deception, a show of force in an area where a decision is not sought that is made to deceive an adversary.‎',
    answers: [
      { text: 'Envelopment by Danish Troops', correct: false },
      { text: 'Demolition Range', correct: false },
      { text: 'Demonstration', correct: true },
      { text: 'Planned Explosives Demolition', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.feint.file,
    description:
      'In military deception, an offensive action involving contact with the adversary conducted for the purpose of deceiving the adversary as to the location and/or time of the actual main offensive action.',
    answers: [
      { text: 'Screen', correct: false },
      { text: 'Cover', correct: false },
      { text: 'Guard', correct: false },
      { text: 'Feint', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.screen.file,
    description: 'A type of security operation that primarily provides early warning to the protected force.',
    answers: [
      { text: 'Screen', correct: true },
      { text: 'Cover', correct: false },
      { text: 'Guard', correct: false },
      { text: 'Feint', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.cover.file,
    description:
      'A type of security operation done independent of the main body to protect them by fighting to gain time while preventing enemy ground observation of and direct fire against the main body.‎',
    answers: [
      { text: 'Screen', correct: false },
      { text: 'Cover', correct: true },
      { text: 'Guard', correct: false },
      { text: 'Feint', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.guard.file,
    description: 'A type of security operation done to protect the main body by fighting to gain time while preventing enemy ground observation of and direct fire against the main body.',
    answers: [
      { text: 'Screen', correct: false },
      { text: 'Cover', correct: false },
      { text: 'Guard', correct: true },
      { text: 'Feint', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.FPOL.file,
    description: 'Occurs when a unit passes through another unit’s positions while moving toward the enemy.',
    answers: [
      { text: 'Rearward Passage of Lines', correct: false },
      { text: 'Main Axis of Advance (Primary Forces)', correct: false },
      { text: 'Demonstration (Friendly)', correct: false },
      { text: 'Forward Passage of Lines', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RPOL.file,
    description: 'Occurs when a unit passes through another unit’s positions while moving away from the enemy.‎',
    answers: [
      { text: 'Rearward Passage of Lines', correct: true },
      { text: 'Main Axis of Advance (Relief)', correct: false },
      { text: 'Retirement (Friendly)', correct: false },
      { text: 'Forward Passage of Lines', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.RIP.file,
    description:
      'An operation in which, by direction of higher authority, all or part of a unit is replaced in an area by the incoming unit and the responsibilities of the replaced elements for the mission and the assigned zone of operations are transferred to the incoming unit.‎',
    answers: [
      { text: 'Regional Interface Point', correct: false },
      { text: 'Relief in Place', correct: true },
      { text: 'Rescue of Friendly Casualties', correct: false },
      { text: 'Axis of Approach (Mortuary Affairs)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.delay.file,
    description: 'When a force under pressure trades space for time by slowing down the enemy’s momentum and inflicting maximum damage on enemy forces without becoming decisively engaged.',
    answers: [
      { text: 'Demolition', correct: false },
      { text: 'Demonstration', correct: false },
      { text: 'Delay', correct: true },
      { text: 'Axis of Approach', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.retirement.file,
    description: 'When a force out of contact moves away from the enemy.‎',
    answers: [
      { text: 'Demolition', correct: false },
      { text: 'Rebellion', correct: false },
      { text: 'Axis of Approach (in-range)', correct: false },
      { text: 'Retirement', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.withdraw.file,
    description: 'To disengage from an enemy force and move in a direction away from the enemy.',
    answers: [
      { text: 'Withdraw', correct: true },
      { text: 'Working Group', correct: false },
      { text: 'Axis of Approach (west)', correct: false },
      { text: 'Axis of Approach (wide area)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.withdrawUnderPressure.file,
    description: 'To disengage from an enemy force while under pressure and move in a direction away from the enemy.',
    answers: [
      { text: 'Axis of Attack (White Phosphorus)', correct: false },
      { text: 'Withdraw under Pressure', correct: true },
      { text: 'Axis of Approach (working party)', correct: false },
      { text: 'Axis of Approach (weather permitting)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OP_GENERIC.file,
    description:
      'A position from which military observations are made, or fire directed and adjusted, and which possesses appropriate communications. While aerial observers and sensors systems are extremely useful, those systems do not constitute aerial observation posts. Also called OP.',
    answers: [
      { text: 'Combat Outpost', correct: false },
      { text: 'Forward Observer Outpost', correct: false },
      { text: 'Observation Post', correct: true },
      { text: 'Reconnaissance Observation Post', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OP_RECON.file,
    description: 'An observation post manned by a reconnaissance unit.',
    answers: [
      { text: 'Combat Outpost', correct: false },
      { text: 'Forward Observer Outpost', correct: false },
      { text: 'Observation Post', correct: false },
      { text: 'Reconnaissance Observation Post', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OP_FORWARD.file,
    description: 'An observer operating with front line troops and trained to adjust ground or naval gunfire and pass back battlefield information. Also called FO.‎',
    answers: [
      { text: 'Forward Observer Outpost', correct: true },
      { text: 'Combat Outpost', correct: false },
      { text: 'Observation Post', correct: false },
      { text: 'Reconnaissance Observation Post', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OP_CBRN.file,
    description: 'An observation post manned by a Chemical, biological, radiological, or nuclear (CBRN) unit.‎',
    answers: [
      { text: 'Combat Outpost', correct: false },
      { text: 'CBRN Observation Post', correct: true },
      { text: 'Forward Observer Outpost', correct: false },
      { text: 'Reconnaissance Observation Post', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OP_SENSOR.file,
    description: 'An observation post manned by a listening device.‎',
    answers: [
      { text: 'Combat Observation Post', correct: false },
      { text: 'Forward Observer Outpost', correct: false },
      { text: 'Sensor Observation Post', correct: true },
      { text: 'CBRN Observation Post', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OP_COMBAT.file,
    description: 'A reinforced observation post capable of conducting limited combat operations.‎',
    answers: [
      { text: 'Forward Observer Outpost', correct: false },
      { text: 'Sensor Observation Post', correct: false },
      { text: 'Unknown Fortification', correct: false },
      { text: 'Combat Observation Post', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.TRP.file,
    description: 'A predetermined point of reference, normally a permanent structure or terrain feature that can be used when describing a target location. Also called TRP.‎‎',
    answers: [
      { text: 'Waypoint AB001', correct: false },
      { text: 'Point Target', correct: false },
      { text: 'Target Reference Point AB001', correct: true },
      { text: 'Nuclear Target Point AB001', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.pointTarget.file,
    description: 'A target that is less than or equal to 200 meters in width and length.‎ A point target requires the accurate placement of bombs or fire.',
    answers: [
      { text: 'Waypoint AB001', correct: false },
      { text: 'Target Reference Point AB001', correct: false },
      { text: 'Nuclear Target Point AB001', correct: false },
      { text: 'Point Target AB001 delivered by missile launchers', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.nuclearTarget.file,
    description:
      'A predetermined point of reference, normally a permanent structure or terrain feature that can be used when describing a target location. Note: the point at the center of the target represents the desired ground zero.',
    answers: [
      { text: 'Nuclear Target Point', correct: true },
      { text: 'Waypoint', correct: false },
      { text: 'Target Reference Point', correct: false },
      { text: 'Point Target', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.linearTarget.file,
    description: 'A target that is greater than 200 meters in length and less than or equal to 200 meters in width.',
    answers: [
      { text: 'Main Supply Route', correct: false },
      { text: 'Linear Target', correct: true },
      { text: 'Linear Smoke Target', correct: false },
      { text: 'Final Protective Fires', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.linearSmokeTarget.file,
    description: 'A target that is greater than 200 meters in length and less than or equal to 200 meters in width and the munitions is smoke.',
    answers: [
      { text: 'Main Supply Route', correct: false },
      { text: 'Linear Target', correct: false },
      { text: 'Linear Smoke Target', correct: true },
      { text: 'Final Protective Fires', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.finalProtectiveFires.file,
    description: 'An immediately available prearranged barrier of fire designed to impede enemy movement across defensive lines or areas.',
    answers: [
      { text: 'Main Supply Route', correct: false },
      { text: 'Linear Target', correct: false },
      { text: 'Linear Smoke Target', correct: false },
      { text: 'Final Protective Fires', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.groupOfTargets.file,
    description: 'Consists of two or more targets on which fire desired simultaneously, and is designed by a letter and number combination or a nickname.',
    answers: [
      { text: 'Target Group Red with 3 TRPs', correct: true },
      { text: 'Red Platoon Assembly Area', correct: false },
      { text: 'Red Platoon Engagement Area', correct: false },
      { text: 'Target Reference Points AB001-AB003', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fireSupportStation.file,
    description: 'Naval Gunfire: An exact location at sea within a fire support area from which a fire support ship delivers fire. Also called FSS.',
    answers: [
      { text: 'Waypoint', correct: false },
      { text: 'Fire Support Station 1', correct: true },
      { text: 'Target Reference Point 1', correct: false },
      { text: 'Fueling Station 1', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OB_EASY.file,
    description:
      'Obstacles are any natural or man-made obstruction designed or employed to disrupt, fix, turn, or block the movement of an opposing force, and to impose additional losses in personnel, time, and equipment on the opposing force.',
    answers: [
      { text: 'Obstacle Bypass (Difficult)', correct: false },
      { text: 'Obstacle Bypass (Impossible)', correct: false },
      { text: 'Obstacle Bypass (Easy)', correct: true },
      { text: 'Bridge Gap Crossing', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OB_DIFFICULT.file,
    description:
      'Obstacles are any natural or man-made obstruction designed or employed to disrupt, fix, turn, or block the movement of an opposing force, and to impose additional losses in personnel, time, and equipment on the opposing force. This one in particular is difficult to pass.',
    answers: [
      { text: 'Obstacle Bypass (Impossible)', correct: false },
      { text: 'Obstacle Bypass (Easy)', correct: false },
      { text: 'Bridge Gap Crossing', correct: false },
      { text: 'Obstacle Bypass (Difficult)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.OB_IMPOSSIBLE.file,
    description:
      'Obstacles are any natural or man-made obstruction designed or employed to disrupt, fix, turn, or block the movement of an opposing force, and to impose additional losses in personnel, time, and equipment on the opposing force. This one in particular is impossible to pass.',
    answers: [
      { text: 'Obstacle Bypass (Impossible)', correct: true },
      { text: 'Obstacle Bypass (Easy)', correct: false },
      { text: 'Bridge Gap Crossing', correct: false },
      { text: 'Obstacle Bypass (Difficult)', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.gap.file,
    description: 'An area free of armed mines or obstacles whose width and direction allow a friendly force to pass through while dispersed in a tactical formation.',
    answers: [
      { text: 'Obstacle Bypass, Codenamed Sword', correct: false },
      { text: 'Gap, Codenamed Sword', correct: false },
      { text: 'Passage Lane, Codenamed Sword', correct: true },
      { text: 'Bridge, Codenamed Sword', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.passageLane.file,
    description: 'A lane through an enemy or friendly obstacle that provides a safe passage for a passing force.',
    answers: [
      { text: 'Obstacle Bypass', correct: false },
      { text: 'Gap', correct: false },
      { text: 'Bridge', correct: false },
      { text: 'Passage Lane', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bridgeMobility.file,
    description: 'The location of a single bridge or rafting site, or in an initial assault a site for the crossing of assault boats or for the swimming or fording of vehicles on a broad front.',
    answers: [
      { text: 'Bridge (mobility)', correct: true },
      { text: 'Obstacle Bypass', correct: false },
      { text: 'Gap', correct: false },
      { text: 'Passage Lane', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fordEasy.file,
    description:
      'The location of a single bridge or rafting site, or in an initial assault a site for the crossing of assault boats or for the swimming or fording of vehicles on a broad front. A ford represents a Water Crossing Site',
    answers: [
      { text: 'Obstacle Bypass', correct: false },
      { text: 'Ford (Easy)', correct: true },
      { text: 'Main Supply Route', correct: false },
      { text: 'Alternate Supply Route', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fordDifficult.file,
    description:
      'The location of a single bridge or rafting site, or in an initial assault a site for the crossing of assault boats or for the swimming or fording of vehicles on a broad front. A ford represents a Water Crossing Site. This one in particular is difficult to cross.',
    answers: [
      { text: 'Obstacle Bypass', correct: false },
      { text: 'Main Supply Route', correct: false },
      { text: 'Ford (Difficult)', correct: true },
      { text: 'Alternate Supply Route', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.ferry.file,
    description:
      'The location of a single bridge or rafting site, or in an initial assault a site for the crossing of assault boats or for the swimming or fording of vehicles on a broad front. That particular symbol represents a ferry crossing.',
    answers: [
      { text: 'Linear Target', correct: false },
      { text: 'Main Supply Route', correct: false },
      { text: 'Alternate Supply Route', correct: false },
      { text: 'Ferry Crossing', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.block.file,
    description:
      'An obstacle effect that integrates fire planning and obstacle effort to stop an attacker along a specific avenue of approach or to prevent the attacking force from passing through an engagement area.',
    answers: [
      { text: 'Block', correct: true },
      { text: 'Breach', correct: false },
      { text: 'Border', correct: false },
      { text: 'Disrupt', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.disrupt.file,
    description:
      'An obstacle effect that focuses fire planning and obstacle effort to cause the enemy to break up its formation and tempo, interrupt its timetable, commit breaching assets prematurely, and attack in a piecemeal effort.',
    answers: [
      { text: 'Breach', correct: false },
      { text: 'Disrupt', correct: true },
      { text: 'Block', correct: false },
      { text: 'Detonation', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fix.file,
    description: 'An obstacle effect that focuses fire planning and obstacle effort to slow an attacker’s movement within a specified area, normally an engagement area.',
    answers: [
      { text: 'Foraging activity', correct: false },
      { text: 'Friendly Axis of Attack', correct: false },
      { text: 'Fix', correct: true },
      { text: 'Fire Support', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.turn.file,
    description:
      'An obstacle effect that integrates fire planning and obstacle effort to divert an enemy formation from one avenue of approach to an adjacent avenue of approach or into an engagement area.',
    answers: [
      { text: 'Troop Movement Activity', correct: false },
      { text: 'Axis of Advance', correct: false },
      { text: 'Trap', correct: false },
      { text: 'Turn', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.obstacleLine.file,
    description:
      'A conceptual control measure used at battalion or brigade level to show placement intent without specifying a particular type of linear obstacle. Note: obstacles can be either green or black.',
    answers: [
      { text: 'Obstacle Line', correct: true },
      { text: 'Planned Explosives', correct: false },
      { text: 'Roadblock (completed)', correct: false },
      { text: 'Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.abatis.file,
    description: 'An obstacle constructed by the felling and interlacing of trees across a route.',
    answers: [
      { text: 'Planned Explosives', correct: false },
      { text: 'Abatis', correct: true },
      { text: 'Roadblock (completed)', correct: false },
      { text: 'Dragons Teeth', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.wireObstacle.file,
    description: 'Obstacles created with manual labor and or equipment. Note: obstacles can be either green or black.',
    answers: [
      { text: 'Wire Obstacle (Single Fence)', correct: false },
      { text: 'Double Apron Fence', correct: false },
      { text: 'Wire Obstacle (unspecified)', correct: true },
      { text: 'Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.wireObstacleSingleFence.file,
    description: 'Obstacles created with manual labor and or equipment. Note: obstacles can be either green or black. Fence obstacles are denoted with an X.',
    answers: [
      { text: 'Double Apron Fence', correct: false },
      { text: 'Wire Obstacle (unspecified)', correct: false },
      { text: 'Minefield', correct: false },
      { text: 'Wire Obstacle (Single Fence)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.wireObstacleSingleStrandConcertina.file,
    description: 'Obstacles created with manual labor and or equipment. Note: obstacles can be either green or black. Concertina strand obstacles are denoted with an O.',
    answers: [
      { text: 'Wire Obstacle (Single Fence)', correct: false },
      { text: 'Double Apron Fence', correct: false },
      { text: 'Minefield', correct: false },
      { text: 'Wire Obstacle (Single Strand Concertina)', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.atDitch.file,
    description: 'Obstacles created with manual labor and or equipment. Note: obstacles can be either green or black. This particular ditch is under construction.',
    answers: [
      { text: 'Antitank Ditch (Under Construction)', correct: true },
      { text: 'Antitank Ditch (Completed)', correct: false },
      { text: 'Double Apron Fence', correct: false },
      { text: 'Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.atDitchComplete.file,
    description: 'Obstacles created with manual labor and or equipment. Note: obstacles can be either green or black. This particular ditch is completed and ready.',
    answers: [
      { text: 'Antitank Ditch (Under Construction)', correct: false },
      { text: 'Antitank Ditch (Completed)', correct: true },
      { text: 'Double Apron Fence', correct: false },
      { text: 'Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.atDitchWithATMines.file,
    description: 'Obstacles created with manual labor and or equipment. Note: obstacles can be either green or black. The teeth on antitank ditches typically point towards the enemy.',
    answers: [
      { text: 'Antitank Ditch (Completed)', correct: false },
      { text: 'Double Apron Fence', correct: false },
      { text: 'Antitank ditch reinforced, with antitank mines', correct: true },
      { text: 'Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.apMine.file,
    description: 'Designed to be exploded by the presence, proximity or contact of a person and that will incapacitate, wound or kill one or more persons.‎',
    answers: [
      { text: 'Antipersonnel Mine with Directional Effects', correct: false },
      { text: 'Antitank Mine', correct: false },
      { text: 'Boobytrap', correct: false },
      { text: 'Antipersonnel Mine', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.apMineWithDirFX.file,
    description:
      'Designed to be exploded by the presence, proximity or contact of a person and that will incapacitate, wound or kill one or more persons. A mine with a directional effect is essentially a Claymore mine.‎‎',
    answers: [
      { text: 'Antipersonnel Mine with Directional Effects', correct: true },
      { text: 'Antitank Mine', correct: false },
      { text: 'Boobytrap', correct: false },
      { text: 'Antipersonnel Mine', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.atMine.file,
    description: 'A mine designed to immobilize or destroy a tank.‎‎‎',
    answers: [
      { text: 'Antipersonnel Mine with Directional Effects', correct: false },
      { text: 'Antitank Mine', correct: true },
      { text: 'Cannonball', correct: false },
      { text: 'Antipersonnel Mine', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.atMineWithAHDev.file,
    description:
      'A device intended to protect a mine and which is part of, linked to, attached to or placed under the mine and which activates when an attempt is made to tamper with or otherwise intentionally disturb the mine.‎‎‎‎',
    answers: [
      { text: 'Antipersonnel Mine with Directional Effects', correct: false },
      { text: 'Ground Penetrating Radar', correct: false },
      { text: 'Antitank Mine with Antihandling Device', correct: true },
      { text: 'Antipersonnel Mine', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.waatMine.file,
    description: 'An antitank mine that detects and acquires targets then launches subammunition that attacks the top of the targets.‎',
    answers: [
      { text: 'Antipersonnel Mine with Directional Effects', correct: false },
      { text: 'Ground Penetrating Radar', correct: false },
      { text: 'Antipersonnel Mine', correct: false },
      { text: 'Wide Area Antitank Mine', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.unspecifiedMine.file,
    description: 'An unspecified mine. It could be AP or AT.',
    answers: [
      { text: 'Unspecified Mine', correct: true },
      { text: 'Antipersonnel Mine with Directional Effects', correct: false },
      { text: 'Key Terrain', correct: false },
      { text: 'Antipersonnel Mine', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.boobyTrapMine.file,
    description: 'A device designed, constructed or adapted to kill or injure, which functions when a person disturbs or approaches an apparently harmless object or performs an apparently safe act.‎',
    answers: [
      { text: 'Antipersonnel Mine with Directional Effects', correct: false },
      { text: 'Boobytrap Mine', correct: true },
      { text: 'Observation Post', correct: false },
      { text: 'Antipersonnel Mine', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.tripwireMine.file,
    description: 'A type of mine which functions when someone or something "trips" over it.',
    answers: [
      { text: 'Antipersonnel Mine with Directional Effects', correct: false },
      { text: 'Boobytrap Mine', correct: false },
      { text: 'Tripwire Mine', correct: true },
      { text: 'Antipersonnel Mine', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.minefield_unspecified.file,
    description: 'An minefield with unspecified mines. It could be AP or AT or a mix of both.',
    answers: [
      { text: 'Antipersonnel Mine with Directional Effects', correct: false },
      { text: 'Boobytrap Mine', correct: false },
      { text: 'Antipersonnel Mine', correct: false },
      { text: 'Unspecified Mines', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.minefield_ap.file,
    description: 'An minefield consisting of antipersonnel mines.',
    answers: [
      { text: 'Antipersonnel Mine with Directional Effects', correct: false },
      { text: 'Boobytrap Mine', correct: false },
      { text: 'Antitank Mines', correct: false },
      { text: 'Antipersonnel Mines', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.minefield_apwdfx.file,
    description: 'An minefield consisting of antipersonnel mines with directional effects (think Claymores).',
    answers: [
      { text: 'Antipersonnel Mines with Directional Effects', correct: true },
      { text: 'Antitank Mines with Directional Effects', correct: false },
      { text: 'Boobytrap Mine', correct: false },
      { text: 'Antitank Mines', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.minefield_at.file,
    description: 'An minefield consisting of antitank mines.',
    answers: [
      { text: 'Antipersonnel Mines with Directional Effects', correct: false },
      { text: 'Antitank Mines', correct: true },
      { text: 'Antitank Mines with Directional Effects', correct: false },
      { text: 'Boobytrap Mines', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.minefield_atah.file,
    description: 'An minefield consisting of antitank mines with antihandling devices.',
    answers: [
      { text: 'Antipersonnel Mines with Directional Effects', correct: false },
      { text: 'Antitank Mines with Directional Effects', correct: false },
      { text: 'Antitank Mines with Antihandling Devices', correct: true },
      { text: 'Unspecified Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.minefield_waat.file,
    description: 'An minefield consisting of wide area antitank mines.',
    answers: [
      { text: 'Antipersonnel Mines with Directional Effects', correct: false },
      { text: 'Antitank Mines with Directional Effects', correct: false },
      { text: 'Unspecified Minefield', correct: false },
      { text: 'Wide Area Antitank Mines', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.minefield_cluster.file,
    description: 'A minefield. The dashed lines in this symbol shall be displayed in present and anticipated status.',
    answers: [
      { text: 'Mine Cluster', correct: true },
      { text: 'Antipersonnel Mines with Directional Effects', correct: false },
      { text: 'Antitank Mines with Directional Effects', correct: false },
      { text: 'Unspecified Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.shelter.file,
    description:
      'An unspecified type of shelter. Could be above or below ground. These can be constructed with reasonable facility by units requiring no more than minor engineer supervisory and equipment participation',
    answers: [
      { text: 'Above Ground Facility', correct: false },
      { text: 'Shelter', correct: true },
      { text: 'Below Ground Facility', correct: false },
      { text: 'Unspecified Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.aboveGroundFacility.file,
    description:
      'A type of shelter or fortification that is above ground which can be constructed with reasonable facility by units requiring no more than minor engineer supervisory and equipment participation.',
    answers: [
      { text: 'Shelter', correct: false },
      { text: 'Below Ground Facility', correct: false },
      { text: 'Above Ground Facility', correct: true },
      { text: 'Unspecified Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.undergroundFacility.file,
    description:
      'A type of shelter or fortification that is underground which can be constructed with reasonable facility by units requiring no more than minor engineer supervisory and equipment participation.',
    answers: [
      { text: 'Shelter', correct: false },
      { text: 'Above Ground Facility', correct: false },
      { text: 'Unspecified Minefield', correct: false },
      { text: 'Underground Facility', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fort.file,
    description: 'A type of fortification which can be constructed with reasonable facility by units requiring no more than minor engineer supervisory and equipment participation.',
    answers: [
      { text: 'Fort', correct: true },
      { text: 'Ammunition Holding Area', correct: false },
      { text: 'Above Ground Facility', correct: false },
      { text: 'Unspecified Minefield', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fortifiedLine.file,
    description:
      'A type of fortification which can be constructed with reasonable facility by units requiring no more than minor engineer supervisory and equipment participation. Note, the ramparts typically point toward enemy forces‎‎‎.‎',
    answers: [
      { text: 'Combat Outpost', correct: false },
      { text: 'Fortified Line', correct: true },
      { text: 'Forward Edge of the Battlefield', correct: false },
      { text: 'Final Protective Fires', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.fightingPosition.file,
    description:
      'A type of fortification or shelter which can be constructed with reasonable facility by units requiring no more than minor engineer supervisory and equipment participation. Note, this typically points toward enemy forces‎‎‎.‎',
    answers: [
      { text: 'Combat Outpost', correct: false },
      { text: 'Forward Edge of the Battlefield', correct: false },
      { text: 'Fighting Position', correct: true },
      { text: 'Final Protective Fires', correct: false },
    ],
  },
  // ? Tactical Mission Tasks
  {
    question: 'What is this symbol?',
    symbolSVG: mso.breach.file,
    description: 'A tactical mission task in which the unit employs all available means to break through or establish a passage through an enemy defense, obstacle, minefield, or fortification.',
    answers: [
      { text: 'Canalize', correct: false },
      { text: 'Bypass', correct: false },
      { text: 'Block', correct: false },
      { text: 'Breach', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.bypass.file,
    description:
      'A tactical mission task in which the commander directs the unit to maneuver around an obstacle, position, or enemy force to maintain the momentum of the operation while deliberately avoiding combat with an enemy force.',
    answers: [
      { text: 'Bypass', correct: true },
      { text: 'Canalize', correct: false },
      { text: 'Block', correct: false },
      { text: 'Breach', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.clear.file,
    description:
      'A tactical mission task in which the commander directs the unit to maneuver around an obstacle, position, or enemy force to maintain the momentum of the operation while deliberately avoiding combat with an enemy force.',
    answers: [
      { text: 'Canalize', correct: false },
      { text: 'Clear', correct: true },
      { text: 'Control', correct: false },
      { text: 'Cordon and Breach', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.disengage.file,
    description: 'A tactical mission task where a commander has the unit break contact with the enemy to allow the conduct of another mission or to avoid decisive engagement.',
    answers: [
      { text: 'Create Distance Between Elements', correct: false },
      { text: 'Disrupt', correct: false },
      { text: 'Disengage', correct: true },
      { text: 'Cordon and Breach', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.exfiltrate.file,
    description: 'A tactical mission task where a commander removes Soldiers or units from areas under enemy control by stealth, deception, surprise, or clandestine means.',
    answers: [
      { text: 'Examine', correct: false },
      { text: 'Explosive Detonation Cord', correct: false },
      { text: 'Foraging', correct: false },
      { text: 'Exfiltrate', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.followAndAssume.file,
    description:
      'A tactical mission task in which a second committed force follows a force conducting an offensive task and is prepared to continue the mission if the lead force is fixed, attrited, or unable to continue.',
    answers: [
      { text: 'Follow and Assume', correct: true },
      { text: 'Occupy', correct: false },
      { text: 'Main Axis of Attack', correct: false },
      { text: 'Foraging', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.followAndSupport.file,
    description: 'A tactical mission task in which a committed force follows and supports a lead force conducting an offensive task.',
    answers: [
      { text: 'Follow and Assume', correct: false },
      { text: 'Follow and Support', correct: true },
      { text: 'Main Axis of Attack', correct: false },
      { text: 'Foraging', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.occupy.file,
    description:
      'A tactical mission task that involves a force moving a friendly force into an area so that it can control that area. Both the force’s movement to and occupation of the area occur without enemy opposition.',
    answers: [
      { text: 'Cordon and Knock', correct: false },
      { text: 'Main Axis of Attack', correct: false },
      { text: 'Occupy', correct: true },
      { text: 'Origin of Impact', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.retain.file,
    description: 'A tactical mission task in which the commander ensures that a terrain feature controlled by a friendly force remains free of enemy occupation or use.',
    answers: [
      { text: 'Cordon and Knock', correct: false },
      { text: 'Main Axis of Retirement', correct: false },
      { text: 'Retirement Operations', correct: false },
      { text: 'Retain', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.secure.file,
    description: 'A tactical mission task that involves preventing a unit, facility, or geographical location from being damaged or destroyed as a result of enemy action.',
    answers: [
      { text: 'Secure', correct: true },
      { text: 'Cordon and Knock', correct: false },
      { text: 'Main Axis of Seizure', correct: false },
      { text: 'Seizure Operations', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.seize.file,
    description: 'A tactical mission task that involves taking possession of a designated area using overwhelming force.',
    answers: [
      { text: 'Secure', correct: false },
      { text: 'Seize', correct: true },
      { text: 'Main Axis of Advance', correct: false },
      { text: 'Security Operations', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.canalize.file,
    description: 'A tactical mission task in which the commander restricts enemy movement to a narrow zone by exploiting terrain coupled with the use of obstacles, fires, or friendly maneuver.',
    answers: [
      { text: 'Contain', correct: false },
      { text: 'Main Axis of Advance', correct: false },
      { text: 'Canalize', correct: true },
      { text: 'Security Operations', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.contain.file,
    description:
      'A tactical mission task that requires the commander to stop, hold, or surround enemy forces or to cause them to center their activity on a given front and prevent them from withdrawing any part of their forces for use elsewhere.',
    answers: [
      { text: 'Main Axis of Advance', correct: false },
      { text: 'Canalize', correct: false },
      { text: 'Security Operations', correct: false },
      { text: 'Contain', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.destroy.file,
    description:
      'A tactical mission task that physically renders an enemy force combat-ineffective until it is reconstituted. Alternatively, to destroy a combat system is to damage it so badly that it cannot perform any function or be restored to a usable condition without being entirely rebuilt.',
    answers: [
      { text: 'Destroy', correct: true },
      { text: 'Target Reference Point', correct: false },
      { text: 'Waypoint', correct: false },
      { text: 'Disruption', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.isolate.file,
    description: 'To separate a force from its sources of support in order to reduce its effectiveness and increase its vulnerability to defeat.',
    answers: [
      { text: 'Cordon and Knock', correct: false },
      { text: 'Isolate', correct: true },
      { text: 'Cordon and Search', correct: false },
      { text: 'Interdiction', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.interdict.file,
    description: 'A tactical mission task where the commander prevents, disrupts, or delays the enemy’s use of an area or route.',
    answers: [
      { text: 'Cordon and Knock', correct: false },
      { text: 'Isolate', correct: false },
      { text: 'Interdict', correct: true },
      { text: 'Cordon and Search', correct: false },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.neutralize.file,
    description: 'A tactical mission task to render enemy personnel or materiel incapable of interfering with a particular operation.',
    answers: [
      { text: 'Naval Waypoint', correct: false },
      { text: 'Target Reference Point', correct: false },
      { text: 'Nuclear Target', correct: false },
      { text: 'Neutralize', correct: true },
    ],
  },
  {
    question: 'What is this symbol?',
    symbolSVG: mso.suppress.file,
    description: 'A tactical mission task that results in temporary degradation of the performance of a force or weapons system below the level needed to accomplish the mission.',
    answers: [
      { text: 'Suppress', correct: true },
      { text: 'Waypoint', correct: false },
      { text: 'Target Reference Point', correct: false },
      { text: 'Smoke Target', correct: false },
    ],
  },
];

// ********************************************************* //
// * Validation Functions to Check for Duplicates            //
// ********************************************************* //
// On each reload, check if there are SVG files with duplicate content.
// ! Remove on production
// https://stackoverflow.com/questions/50840157/find-duplicate-values-in-objects-with-javascript
// const duplicateSVG = [];
// questions.forEach((el, i) => {
//   questions.forEach((element, index) => {
//     if (i === index) return null;
//     if (element.symbolSVG === el.symbolSVG) {
//       if (!duplicateSVG.includes(el)) duplicateSVG.push(el);
//     }
//     return true;
//   });
// });

// if (duplicateSVG.length) {
//   console.error('Matching SVG contents found', duplicateSVG);
// }

// On each reload, check if there are multiple true values for each question.
// ! Remove on production
// https://www.codegrepper.com/code-examples/javascript/find+duplicate+values+in+an+array+javascript
// Object.values(questions).forEach((e) => {
//   // Flatten answers into an array of true/false values
//   const answerArray = [...e.answers.map((x) => x.correct)];
//   // Group the true/false values into an object
//   const objectArray = answerArray.reduce((a, b) => ({ ...a, [b]: (a[b] || 0) + 1 }), {});
//   // Find answer array with more than 1 true value
//   const duplicateTrueArray = Object.keys(objectArray).filter((a) => objectArray[a] > 1);
//   // Return only arrays with more than 1 true answer value
//   if (duplicateTrueArray.length > 1) {
//     console.error('Duplicate true values found in question', e);
//   }
// });

export default questions;
